import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import $ from '@sparta.global.vendors/jquery';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es5.js';
import _ from '@sparta.global.vendors/lodash';

/* eslint-disable */
var countries = [{
  "text": "Afghanistan",
  "value": "AF"
}, {
  "text": "Albania",
  "value": "AL"
}, {
  "text": "Algeria",
  "value": "DZ"
}, {
  "text": "Andorra",
  "value": "AD"
}, {
  "text": "Angola",
  "value": "AO"
}, {
  "text": "Anguilla",
  "value": "AI"
}, {
  "text": "Antigua and Barbuda",
  "value": "AG"
}, {
  "text": "Argentina",
  "value": "AR"
}, {
  "text": "Armenia",
  "value": "AM"
}, {
  "text": "Aruba",
  "value": "AW"
}, {
  "text": "Australia",
  "value": "AU"
}, {
  "text": "Austria",
  "value": "AT"
}, {
  "text": "Azerbaijan",
  "value": "AZ"
}, {
  "text": "Bahamas (the)",
  "value": "BS"
}, {
  "text": "Bahrain",
  "value": "BH"
}, {
  "text": "Bangladesh",
  "value": "BD"
}, {
  "text": "Barbados",
  "value": "BB"
}, {
  "text": "Belarus",
  "value": "BY"
}, {
  "text": "Belgium",
  "value": "BE"
}, {
  "text": "Belize",
  "value": "BZ"
}, {
  "text": "Benin",
  "value": "BJ"
}, {
  "text": "Bermuda",
  "value": "BM"
}, {
  "text": "Bhutan",
  "value": "BT"
}, {
  "text": "Bolivia, Plurinational State of",
  "value": "BO"
}, {
  "text": "Bonaire, Sint Eustatius and Saba",
  "value": "BQ"
}, {
  "text": "Bosnia and Herzegovina",
  "value": "BA"
}, {
  "text": "Botswana",
  "value": "BW"
}, {
  "text": "Brazil",
  "value": "BR"
}, {
  "text": "Brunei Darussalam",
  "value": "BN"
}, {
  "text": "Bulgaria",
  "value": "BG"
}, {
  "text": "Burkina Faso",
  "value": "BF"
}, {
  "text": "Burundi",
  "value": "BI"
}, {
  "text": "Cabo Verde",
  "value": "CV"
}, {
  "text": "Cambodia",
  "value": "KH"
}, {
  "text": "Cameroon",
  "value": "CM"
}, {
  "text": "Canada",
  "value": "CA"
}, {
  "text": "Cayman Islands (the)",
  "value": "KY"
}, {
  "text": "Central African Republic (the)",
  "value": "CF"
}, {
  "text": "Chad",
  "value": "TD"
}, {
  "text": "Chile",
  "value": "CL"
}, {
  "text": "China",
  "value": "CN"
}, {
  "text": "Christmas Island",
  "value": "CX"
}, {
  "text": "Cocos (Keeling) Islands (the)",
  "value": "CC"
}, {
  "text": "Colombia",
  "value": "CO"
}, {
  "text": "Comoros",
  "value": "KM"
}, {
  "text": "Congo",
  "value": "CG"
}, {
  "text": "Congo (the Democratic Republic of the)",
  "value": "CD"
}, {
  "text": "Cook Islands (the)",
  "value": "CK"
}, {
  "text": "Costa Rica",
  "value": "CR"
}, {
  "text": "Cote d'Ivoire",
  "value": "CI"
}, {
  "text": "Croatia",
  "value": "HR"
}, {
  "text": "Cuba",
  "value": "CU"
}, {
  "text": "Curacao",
  "value": "CW"
}, {
  "text": "Cyprus",
  "value": "CY"
}, {
  "text": "Czech Republic (the)",
  "value": "CZ"
}, {
  "text": "Denmark",
  "value": "DK"
}, {
  "text": "Djibouti",
  "value": "DJ"
}, {
  "text": "Dominica",
  "value": "DM"
}, {
  "text": "Dominican Republic (the)",
  "value": "DO"
}, {
  "text": "Ecuador",
  "value": "EC"
}, {
  "text": "Egypt",
  "value": "EG"
}, {
  "text": "El Salvador",
  "value": "SV"
}, {
  "text": "Equatorial Guinea",
  "value": "GQ"
}, {
  "text": "Eritrea",
  "value": "ER"
}, {
  "text": "Estonia",
  "value": "EE"
}, {
  "text": "Ethiopia",
  "value": "ET"
}, {
  "text": "Falkland Islands (the) [Malvinas]",
  "value": "FK"
}, {
  "text": "Faroe Islands (the)",
  "value": "FO"
}, {
  "text": "Fiji",
  "value": "FJ"
}, {
  "text": "Finland",
  "value": "FI"
}, {
  "text": "France",
  "value": "FR"
}, {
  "text": "French Guiana",
  "value": "GF"
}, {
  "text": "French Polynesia",
  "value": "PF"
}, {
  "text": "Gabon",
  "value": "GA"
}, {
  "text": "Gambia (The)",
  "value": "GM"
}, {
  "text": "Georgia",
  "value": "GE"
}, {
  "text": "Germany",
  "value": "DE"
}, {
  "text": "Ghana",
  "value": "GH"
}, {
  "text": "Gibraltar",
  "value": "GI"
}, {
  "text": "Greece",
  "value": "GR"
}, {
  "text": "Greenland",
  "value": "GL"
}, {
  "text": "Grenada",
  "value": "GD"
}, {
  "text": "Guadeloupe",
  "value": "GP"
}, {
  "text": "Guatemala",
  "value": "GT"
}, {
  "text": "Guernsey",
  "value": "GG"
}, {
  "text": "Guinea",
  "value": "GN"
}, {
  "text": "Guinea-Bissau",
  "value": "GW"
}, {
  "text": "Guyana",
  "value": "GY"
}, {
  "text": "Haiti",
  "value": "HT"
}, {
  "text": "Holy See (the) [Vatican City State]",
  "value": "VA"
}, {
  "text": "Honduras",
  "value": "HN"
}, {
  "text": "Hong Kong",
  "value": "HK"
}, {
  "text": "Hungary",
  "value": "HU"
}, {
  "text": "Iceland",
  "value": "IS"
}, {
  "text": "India",
  "value": "IN"
}, {
  "text": "Indonesia",
  "value": "ID"
}, {
  "text": "Iran (the Islamic Republic of)",
  "value": "IR"
}, {
  "text": "Iraq",
  "value": "IQ"
}, {
  "text": "Ireland",
  "value": "IE"
}, {
  "text": "Isle of Man",
  "value": "IM"
}, {
  "text": "Israel",
  "value": "IL"
}, {
  "text": "Italy",
  "value": "IT"
}, {
  "text": "Jamaica",
  "value": "JM"
}, {
  "text": "Japan",
  "value": "JP"
}, {
  "text": "Jersey",
  "value": "JE"
}, {
  "text": "Jordan",
  "value": "JO"
}, {
  "text": "Kazakhstan",
  "value": "KZ"
}, {
  "text": "Kenya",
  "value": "KE"
}, {
  "text": "Kiribati",
  "value": "KI"
}, {
  "text": "Korea (the Democratic People's Republic of)",
  "value": "KP"
}, {
  "text": "Korea (the Republic of)",
  "value": "KR"
}, {
  "text": "Kosovo",
  "value": "XK"
}, {
  "text": "Kuwait",
  "value": "KW"
}, {
  "text": "Kyrgyzstan",
  "value": "KG"
}, {
  "text": "Lao People's Democratic Republic (the)",
  "value": "LA"
}, {
  "text": "Latvia",
  "value": "LV"
}, {
  "text": "Lebanon",
  "value": "LB"
}, {
  "text": "Lesotho",
  "value": "LS"
}, {
  "text": "Liberia",
  "value": "LR"
}, {
  "text": "Libya",
  "value": "LY"
}, {
  "text": "Liechtenstein",
  "value": "LI"
}, {
  "text": "Lithuania",
  "value": "LT"
}, {
  "text": "Luxembourg",
  "value": "LU"
}, {
  "text": "Macao",
  "value": "MO"
}, {
  "text": "Macedonia (the former Yugoslav Republic of)",
  "value": "MK"
}, {
  "text": "Madagascar",
  "value": "MG"
}, {
  "text": "Malawi",
  "value": "MW"
}, {
  "text": "Malaysia",
  "value": "MY"
}, {
  "text": "Maldives",
  "value": "MV"
}, {
  "text": "Mali",
  "value": "ML"
}, {
  "text": "Malta",
  "value": "MT"
}, {
  "text": "Marshall Islands (the)",
  "value": "MH"
}, {
  "text": "Martinique",
  "value": "MQ"
}, {
  "text": "Mauritania",
  "value": "MR"
}, {
  "text": "Mauritius",
  "value": "MU"
}, {
  "text": "Mayotte",
  "value": "YT"
}, {
  "text": "Mexico",
  "value": "MX"
}, {
  "text": "Micronesia (the Federated States of)",
  "value": "FM"
}, {
  "text": "Moldova (the Republic of)",
  "value": "MD"
}, {
  "text": "Monaco",
  "value": "MC"
}, {
  "text": "Mongolia",
  "value": "MN"
}, {
  "text": "Montenegro",
  "value": "ME"
}, {
  "text": "Montserrat",
  "value": "MS"
}, {
  "text": "Morocco",
  "value": "MA"
}, {
  "text": "Mozambique",
  "value": "MZ"
}, {
  "text": "Myanmar",
  "value": "MM"
}, {
  "text": "Namibia",
  "value": "NA"
}, {
  "text": "Nauru",
  "value": "NR"
}, {
  "text": "Nepal",
  "value": "NP"
}, {
  "text": "Netherlands (the)",
  "value": "NL"
}, {
  "text": "New Caledonia",
  "value": "NC"
}, {
  "text": "New Zealand",
  "value": "NZ"
}, {
  "text": "Nicaragua",
  "value": "NI"
}, {
  "text": "Niger (the)",
  "value": "NE"
}, {
  "text": "Nigeria",
  "value": "NG"
}, {
  "text": "Niue",
  "value": "NU"
}, {
  "text": "Norfolk Island",
  "value": "NF"
}, {
  "text": "Norway",
  "value": "NO"
}, {
  "text": "Oman",
  "value": "OM"
}, {
  "text": "Pakistan",
  "value": "PK"
}, {
  "text": "Palau",
  "value": "PW"
}, {
  "text": "Palestine, State of",
  "value": "PS"
}, {
  "text": "Panama",
  "value": "PA"
}, {
  "text": "Papua New Guinea",
  "value": "PG"
}, {
  "text": "Paraguay",
  "value": "PY"
}, {
  "text": "Peru",
  "value": "PE"
}, {
  "text": "Philippines (the)",
  "value": "PH"
}, {
  "text": "Pitcairn",
  "value": "PN"
}, {
  "text": "Poland",
  "value": "PL"
}, {
  "text": "Portugal",
  "value": "PT"
}, {
  "text": "Qatar",
  "value": "QA"
}, {
  "text": "Reunion",
  "value": "RE"
}, {
  "text": "Romania",
  "value": "RO"
}, {
  "text": "Russian Federation (the)",
  "value": "RU"
}, {
  "text": "Rwanda",
  "value": "RW"
}, {
  "text": "Saint Barthelemy",
  "value": "BL"
}, {
  "text": "Saint Helena, Ascension and Tristan da Cunha",
  "value": "SH"
}, {
  "text": "Saint Kitts and Nevis",
  "value": "KN"
}, {
  "text": "Saint Lucia",
  "value": "LC"
}, {
  "text": "Saint Martin (French part)",
  "value": "MF"
}, {
  "text": "Saint Pierre and Miquelon",
  "value": "PM"
}, {
  "text": "Saint Vincent and the Grenadines",
  "value": "VC"
}, {
  "text": "Samoa",
  "value": "WS"
}, {
  "text": "San Marino",
  "value": "SM"
}, {
  "text": "Sao Tome and Principe",
  "value": "ST"
}, {
  "text": "Saudi Arabia",
  "value": "SA"
}, {
  "text": "Senegal",
  "value": "SN"
}, {
  "text": "Serbia",
  "value": "RS"
}, {
  "text": "Seychelles",
  "value": "SC"
}, {
  "text": "Sierra Leone",
  "value": "SL"
}, {
  "text": "Singapore",
  "value": "SG"
}, {
  "text": "Sint Maarten (Dutch part)",
  "value": "SX"
}, {
  "text": "Slovakia",
  "value": "SK"
}, {
  "text": "Slovenia",
  "value": "SI"
}, {
  "text": "Solomon Islands (the)",
  "value": "SB"
}, {
  "text": "Somalia",
  "value": "SO"
}, {
  "text": "South Africa",
  "value": "ZA"
}, {
  "text": "South Sudan",
  "value": "SS"
}, {
  "text": "Spain",
  "value": "ES"
}, {
  "text": "Sri Lanka",
  "value": "LK"
}, {
  "text": "Sudan (the)",
  "value": "SD"
}, {
  "text": "Suriname",
  "value": "SR"
}, {
  "text": "Svalbard and Jan Mayen",
  "value": "SJ"
}, {
  "text": "Swaziland",
  "value": "SZ"
}, {
  "text": "Sweden",
  "value": "SE"
}, {
  "text": "Switzerland",
  "value": "CH"
}, {
  "text": "Syrian Arab Republic (the)",
  "value": "SY"
}, {
  "text": "Taiwan (Province of China)",
  "value": "TW"
}, {
  "text": "Tajikistan",
  "value": "TJ"
}, {
  "text": "Tanzania, United Republic of",
  "value": "TZ"
}, {
  "text": "Thailand",
  "value": "TH"
}, {
  "text": "Timor-Leste",
  "value": "TL"
}, {
  "text": "Togo",
  "value": "TG"
}, {
  "text": "Tokelau",
  "value": "TK"
}, {
  "text": "Tonga",
  "value": "TO"
}, {
  "text": "Trinidad and Tobago",
  "value": "TT"
}, {
  "text": "Tunisia",
  "value": "TN"
}, {
  "text": "Turkey",
  "value": "TR"
}, {
  "text": "Turkmenistan",
  "value": "TM"
}, {
  "text": "Turks and Caicos Islands (the)",
  "value": "TC"
}, {
  "text": "Tuvalu",
  "value": "TV"
}, {
  "text": "Uganda",
  "value": "UG"
}, {
  "text": "Ukraine",
  "value": "UA"
}, {
  "text": "United Arab Emirates (the)",
  "value": "AE"
}, {
  "text": "United Kingdom of Great Britain and Norhtern Ireland",
  "value": "GB"
}, {
  "text": "United States (the)",
  "value": "US"
}, {
  "text": "Uruguay",
  "value": "UY"
}, {
  "text": "Uzbekistan",
  "value": "UZ"
}, {
  "text": "Vanuatu",
  "value": "VU"
}, {
  "text": "Venezuela, Bolivarian Republic of",
  "value": "VE"
}, {
  "text": "Viet Nam",
  "value": "VN"
}, {
  "text": "Virgin Islands (British)",
  "value": "VG"
}, {
  "text": "Wallis and Futuna",
  "value": "WF"
}, {
  "text": "Western Sahara*",
  "value": "EH"
}, {
  "text": "Yemen",
  "value": "YE"
}, {
  "text": "Zambia",
  "value": "ZM"
}, {
  "text": "Zimbabwe",
  "value": "ZW"
}];

/* eslint-disable */
var occupations = [{
  "text": "Senior Political Figure",
  "value": "98"
}, {
  "text": "Accountant",
  "value": "01"
}, {
  "text": "Actor",
  "value": "02"
}, {
  "text": "Administrative Professional",
  "value": "05"
}, {
  "text": "Architect",
  "value": "03"
}, {
  "text": "Arms / Ammo Dealer",
  "value": "84"
}, {
  "text": "Art and Design Professional",
  "value": "04"
}, {
  "text": "Auctioneer",
  "value": "91"
}, {
  "text": "Barber",
  "value": "07"
}, {
  "text": "Beauty Salon Owner",
  "value": "83"
}, {
  "text": "Casino/Gaming Services Owner",
  "value": "88"
}, {
  "text": "Chiropractor",
  "value": "08"
}, {
  "text": "Cigarette Distributors",
  "value": "92"
}, {
  "text": "Conv Store Owner",
  "value": "81"
}, {
  "text": "Counselor",
  "value": "12"
}, {
  "text": "Craftsperson",
  "value": "13"
}, {
  "text": "Dancer",
  "value": "14"
}, {
  "text": "Dentist",
  "value": "15"
}, {
  "text": "Diplomat/Ambassador",
  "value": "78"
}, {
  "text": "Educational Service Professional",
  "value": "37"
}, {
  "text": "Educator",
  "value": "67"
}, {
  "text": "Electrician",
  "value": "16"
}, {
  "text": "Engineer",
  "value": "17"
}, {
  "text": "Executive",
  "value": "76"
}, {
  "text": "Farming/Agriculture",
  "value": "18"
}, {
  "text": "Federal/State/Local Government Employee",
  "value": "09"
}, {
  "text": "Finance",
  "value": "19"
}, {
  "text": "Financial Services Professional",
  "value": "06"
}, {
  "text": "Firefighter",
  "value": "20"
}, {
  "text": "Fisher/Angler",
  "value": "21"
}, {
  "text": "Florist",
  "value": "22"
}, {
  "text": "Gas Station Owner",
  "value": "82"
}, {
  "text": "Gem / Metal Dealer",
  "value": "87"
}, {
  "text": "General Contractor",
  "value": "23"
}, {
  "text": "General Physician",
  "value": "24"
}, {
  "text": "Hairdresser",
  "value": "25"
}, {
  "text": "Health Fitness",
  "value": "26"
}, {
  "text": "Homemaker",
  "value": "70"
}, {
  "text": "Hospitality/Food Services",
  "value": "27"
}, {
  "text": "Human Resources Professional",
  "value": "28"
}, {
  "text": "Importer/Exporter",
  "value": "93"
}, {
  "text": "Insurance Agent",
  "value": "29"
}, {
  "text": "Interior Decorator",
  "value": "30"
}, {
  "text": "Investment Advisor",
  "value": "90"
}, {
  "text": "Investment Manager",
  "value": "89"
}, {
  "text": "Jeweler",
  "value": "31"
}, {
  "text": "Journalist",
  "value": "32"
}, {
  "text": "Laborer",
  "value": "33"
}, {
  "text": "Landscape/Garden",
  "value": "34"
}, {
  "text": "Law Enforcement Professional",
  "value": "35"
}, {
  "text": "Legal Professional",
  "value": "36"
}, {
  "text": "Liquor store Owner",
  "value": "95"
}, {
  "text": "Marketing Professional",
  "value": "38"
}, {
  "text": "Mechanic",
  "value": "39"
}, {
  "text": "Media Associate",
  "value": "40"
}, {
  "text": "Military",
  "value": "41"
}, {
  "text": "Military Associate",
  "value": "42"
}, {
  "text": "Mortgage Broker",
  "value": "43"
}, {
  "text": "Musician",
  "value": "44"
}, {
  "text": "Nurse",
  "value": "46"
}, {
  "text": "Nutritionist",
  "value": "47"
}, {
  "text": "Office Associate",
  "value": "48"
}, {
  "text": "Optometrist",
  "value": "49"
}, {
  "text": "Parking Lot Owner",
  "value": "85"
}, {
  "text": "Pawn Broker",
  "value": "96"
}, {
  "text": "Pharmacist",
  "value": "50"
}, {
  "text": "Photographer",
  "value": "51"
}, {
  "text": "Physical Therapist",
  "value": "52"
}, {
  "text": "Pilot",
  "value": "53"
}, {
  "text": "Podiatrist",
  "value": "54"
}, {
  "text": "Police Officer",
  "value": "55"
}, {
  "text": "Professor",
  "value": "56"
}, {
  "text": "Programmer",
  "value": "11"
}, {
  "text": "Psychiatrist",
  "value": "57"
}, {
  "text": "Psychologist",
  "value": "58"
}, {
  "text": "Public Relations",
  "value": "59"
}, {
  "text": "Real Estate",
  "value": "60"
}, {
  "text": "Religious Worker",
  "value": "10"
}, {
  "text": "Restaurant Owner",
  "value": "80"
}, {
  "text": "Retail/Service Business Owner",
  "value": "97"
}, {
  "text": "Retired",
  "value": "71"
}, {
  "text": "Salesperson",
  "value": "61"
}, {
  "text": "Scientist",
  "value": "62"
}, {
  "text": "Social Worker",
  "value": "63"
}, {
  "text": "Sports Pro",
  "value": "64"
}, {
  "text": "Stock Broker",
  "value": "65"
}, {
  "text": "Surgeon",
  "value": "66"
}, {
  "text": "Taxi Driver",
  "value": "79"
}, {
  "text": "Technology Professional",
  "value": "86"
}, {
  "text": "Travel Professional",
  "value": "77"
}, {
  "text": "Unemployed",
  "value": "73"
}, {
  "text": "Vending Machine/ATM Operators",
  "value": "99"
}, {
  "text": "Veterinarian",
  "value": "68"
}, {
  "text": "Writer",
  "value": "69"
}];

/* eslint-disable */
var residency = {
  type: [{
    "text": "US Permanent Resident (Green) Card",
    "value": "PRGC",
    "groupCode": "PRA"
  }, {
    "text": "Adjustment of Status (AOS)",
    "value": "AOS",
    "groupCode": "NPRA"
  }, {
    "text": "Asylum",
    "value": "ASYM",
    "groupCode": "NPRA"
  }, {
    "text": "Compact of Free Association (CFA)",
    "value": "CFA",
    "groupCode": "NPRA"
  }, {
    "text": "Deferred Action for Childhood Arrivals (DACA)",
    "value": "DACA",
    "groupCode": "NPRA"
  }, {
    "text": "Refugee",
    "value": "REFG",
    "groupCode": "NPRA"
  }, {
    "text": "Temporary Protected Status",
    "value": "TMPS",
    "groupCode": "NPRA"
  }, {
    "text": "Visa",
    "value": "VISA",
    "groupCode": ""
  }, {
    "text": "Not on this list",
    "value": "NOL",
    "groupCode": "NRA"
  }],
  document: [{
    "text": "E-1 Visa",
    "value": "RE1",
    "groupCode": "NPRA"
  }, {
    "text": "E-2 Visa",
    "value": "RE2",
    "groupCode": "NPRA"
  }, {
    "text": "E-3 Visa",
    "value": "RE3",
    "groupCode": "NPRA"
  }, {
    "text": "G-2 Visa",
    "value": "RG2",
    "groupCode": "NPRA"
  }, {
    "text": "G-3 Visa",
    "value": "RG3",
    "groupCode": "NPRA"
  }, {
    "text": "G-4 Visa",
    "value": "RG4",
    "groupCode": "NPRA"
  }, {
    "text": "G-5 Visa",
    "value": "RG5",
    "groupCode": "NPRA"
  }, {
    "text": "H-1B Visa",
    "value": "RH1B",
    "groupCode": "NPRA"
  }, {
    "text": "H-2A Visa",
    "value": "RH2A",
    "groupCode": "NPRA"
  }, {
    "text": "H-2B Visa",
    "value": "RH2B",
    "groupCode": "NPRA"
  }, {
    "text": "H-4 Visa",
    "value": "RH4",
    "groupCode": "NPRA"
  }, {
    "text": "I Visa",
    "value": "RIV",
    "groupCode": "NPRA"
  }, {
    "text": "J-1 Visa",
    "value": "RJ1",
    "groupCode": "NPRA"
  }, {
    "text": "J-2 Visa",
    "value": "RJ2",
    "groupCode": "NPRA"
  }, {
    "text": "K-1 Visa",
    "value": "RK1",
    "groupCode": "NPRA"
  }, {
    "text": "K-3 Visa",
    "value": "RK3",
    "groupCode": "NPRA"
  }, {
    "text": "L-1A Visa",
    "value": "RL1A",
    "groupCode": "NPRA"
  }, {
    "text": "L-1B Visa",
    "value": "RL1B",
    "groupCode": "NPRA"
  }, {
    "text": "L-2 Visa",
    "value": "RL2",
    "groupCode": "NPRA"
  }, {
    "text": "NATO-1 Visa",
    "value": "RN1",
    "groupCode": "NPRA"
  }, {
    "text": "NATO-2 Visa",
    "value": "RN2",
    "groupCode": "NPRA"
  }, {
    "text": "NATO-3 Visa",
    "value": "RN3",
    "groupCode": "NPRA"
  }, {
    "text": "NATO-4 Visa",
    "value": "RN4",
    "groupCode": "NPRA"
  }, {
    "text": "NATO-5 Visa",
    "value": "RN5",
    "groupCode": "NPRA"
  }, {
    "text": "NATO-6 Visa",
    "value": "RN6",
    "groupCode": "NPRA"
  }, {
    "text": "NATO-7 Visa",
    "value": "RN7",
    "groupCode": "NPRA"
  }, {
    "text": "O-1A Visa",
    "value": "RO1A",
    "groupCode": "NPRA"
  }, {
    "text": "O-1B Visa",
    "value": "RO1B",
    "groupCode": "NPRA"
  }, {
    "text": "O-2 Visa",
    "value": "RO2",
    "groupCode": "NPRA"
  }, {
    "text": "P-1A Visa",
    "value": "RP1A",
    "groupCode": "NPRA"
  }, {
    "text": "P-1B Visa",
    "value": "RP1B",
    "groupCode": "NPRA"
  }, {
    "text": "P-2 Visa",
    "value": "RP2",
    "groupCode": "NPRA"
  }, {
    "text": "P-3 Visa",
    "value": "RP3",
    "groupCode": "NPRA"
  }, {
    "text": "P-4 Visa",
    "value": "RP4",
    "groupCode": "NPRA"
  }, {
    "text": "Q-1 Visa",
    "value": "RQ1",
    "groupCode": "NPRA"
  }, {
    "text": "Q-2 Visa",
    "value": "RQ2",
    "groupCode": "NPRA"
  }, {
    "text": "R-1 Visa",
    "value": "RR1",
    "groupCode": "NPRA"
  }, {
    "text": "T-1 Visa",
    "value": "RT1",
    "groupCode": "NPRA"
  }, {
    "text": "TN Visa",
    "value": "RTN",
    "groupCode": "NPRA"
  }, {
    "text": "V-1 Visa",
    "value": "RV1",
    "groupCode": "NPRA"
  }, {
    "text": "V-2 Visa",
    "value": "RV2",
    "groupCode": "NPRA"
  }, {
    "text": "V-3 Visa",
    "value": "RV3",
    "groupCode": "NPRA"
  }, {
    "text": "Not on this list",
    "value": "NOL",
    "groupCode": "NRA"
  }]
};
var chapterRoutes = ['BORROWER-PERSONAL-INFORMATION-URLA-2020', 'YOUR-NEW-HOME', 'BORROWER-INCOME-PREFILL-RESOURCES', 'ASSETS-OTHER-PREFILL', 'PROFESSIONAL-RELATIONSHIP', 'REVIEW-YOUR-INFORMATION', 'LOAN-AMOUNT-CALCULATOR'];
var baseMLO = {
  firstName: 'Deborah',
  lastName: 'Smith',
  nmlsid: '12345678',
  email: 'deborah@gmail.com',
  phoneNumber: '8007001234',
  phoneExt: '246',
  photoURL: null,
  isGetACallBackEnabled: false,
  mloaddress: {
    entityID: 'fd3b7ec2-2188-45bb-957d-eda51f2926c5',
    isDirty: true,
    priorityLevel: 0,
    addressLine: ['119 Cross Center Drive', 'Suite A'],
    city: 'Denver',
    county: null,
    countyGroupCode: null,
    countyGroupName: null,
    countyCode: null,
    countryCode: null,
    countryCodeEnt: null,
    postalCode: '28037',
    state: 'NC',
    stateCode: null,
    type: null,
    sameAddressBoolean: null,
    samePrimaryAndMailingAddress: false,
    usage: null,
    numberOfMonthsAtAddress: null,
    numberOfYearsAtAddress: null,
    startDateAtaddress: null,
    endDateAtAddress: null,
    streetAddress: null,
    preferredContactMethod: false,
    currentDate: 1527190555584
  }
};

/**
 * Object containing all url params, ie ?mock=local at the end of the url would be
 * `params.mock`, containing the value "local". All values are strings, even if numeric.
 *
 * We intentionally only use GET params before the hash, since disturbing the hash disturbs
 * existing code using the hash.
 */
var params = function () {
  var href = window.location.href;
  var url = href.replace(window.location.hash, '');
  var paramsIdx = url.indexOf('?');
  if (paramsIdx === -1) return {};
  var urlParams = new URLSearchParams(url.substring(paramsIdx)).entries();
  return _.chain(Array.from(urlParams)).map(function (x) {
    return {
      name: x[0],
      value: x[1]
    };
  }).keyBy('name').mapValues('value').value();
}();

/**
 * Gets a string parameter with a default
 * @param {String} param Parameter name
 * @param {String} def Default value
 * @returns {String} Param value
 */
function strDefault(param, def) {
  if (params[param]) return params[param];
  return def;
}

/**
 * Gets a boolean parameter with a default
 * @param {String} param Parameter name
 * @param {Boolean} def Default value
 * @returns {Boolean} Param value
 */
function boolDefault(param, def) {
  if (params[param]) return JSON.parse(params[param]);
  return def;
}

/**
 * Gets a integer parameter with a default
 * @param {String} param Parameter name
 * @param {String} def Default value
 * @returns {String} Param value
 */
function integerDefault(param, def) {
  if (params[param]) return Number(params[param]);
  return def;
}

/**
 * Gets the DMA Base DTO dynamically based on the URL params. Most if not all route DTOs
 * should be extending this (in java its inheritance, here we would just use a spread operator)
 * @returns {Object} Base DTO data
 */
function baseDTO() {
  return {
    selectedChapter: null,
    // Should be overrided by route
    isAuthenticated: boolDefault('auth', true),
    // Auth/unauth flag
    isSaveAndExit: false,
    // Save and exit flag
    subCampPhoneNumber: '800.324.4842',
    // Display in some routes
    bypassServerSideValidationFields: null,
    // Never not-null
    applicationId: 'DMA345742',
    // Application ID
    savedApplicationId: '40352',
    // Saved app ID
    messageCodes: (params.messageCodes || '').split('-'),
    // Affects messaging sections
    associate: boolDefault('associate', false),
    // Whether or not customer is associate
    primaryApplicantPhone: '456123788',
    // Borrower phone
    returnStep: null,
    // Return step
    flowSelection: null,
    // Flow selection
    productUniqueIdentifier: null,
    // Shopping Cart ID
    isTestLoan: true,
    // Whether or not this is a test loan
    prequalSavedApplicationId: null,
    // Prequal saved app
    mortgagePrequalifyQueryString: null,
    // Mortgage prequalifying query section of url
    mortgagePrequalifyURL: null,
    // Full mortgage prequalifying url

    // List of routes to go to when respective index in hamburger menu is clicked
    clickableChapters: function () {
      var clickableChapters = params.clickableChapters;
      if (!clickableChapters || clickableChapters === 'null') return null;
      if (clickableChapters === 'empty') return [];
      return chapterRoutes.slice(0, Number(clickableChapters));
    }(),
    // List of completed chapter routes
    completedChapters: function () {
      var completedChapters = params.completedChapters;
      if (!completedChapters || completedChapters === 'null') return null;
      if (completedChapters === 'empty') return [];
      return chapterRoutes.slice(0, Number(completedChapters));
    }(),
    // MLO information object
    mloInformation: function () {
      var mlo = params.mlo;
      if (!mlo) return baseMLO;
      if (mlo === 'picture') {
        return _objectSpread(_objectSpread({}, baseMLO), {}, {
          photoURL: 'https://vignette.wikia.nocookie.net/inkagames-english/images/b/bb/Dragon.jpg/revision/latest?cb=20160226120559'
        });
      }
      if (mlo === 'empty') {
        return {
          firstName: null,
          lastName: null,
          nmlsid: null,
          email: null,
          phoneNumber: null,
          phoneExt: null,
          photoURL: null,
          isGetACallBackEnabled: null
        };
      }
      return baseMLO;
    }()
  };
}
var mocks = {
  'your-new-home-location-review': {
    propertyAddress: {
      zipcode: 28262
    },
    propertyPurpose: 'Primary',
    propertyType: 'SingleFamily',
    changesNeeded: false,
    primaryApplicantPhone: '8484487862',
    mloInformation: {
      firstName: 'Deborah',
      lastName: 'Smith',
      nmlsid: '12345678',
      email: 'deborah@gmail.com',
      phoneNumber: '8007001234',
      phoneExt: '246',
      photoURL: 'https://mortgage.bankofamerica.com/deborahssmith/photo',
      isGetACallBackEnabled: true
    }
  },
  'borrower-edelivery-consent': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    optIn: true,
    firstName: 'Deborah',
    borrowerName: 'Amy'
  }),
  'co-borrower-edelivery-consent': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    edeliveryConsent: true,
    firstName: 'Deborah',
    borrowerName: 'Amy'
  }),
  'borrower-edelivery-consent-with-spouse': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    edeliveryConsent: true,
    firstName: 'Deborah',
    borrowerName: 'Amy'
  }),
  'co-borrower-paperless-consent': {
    paperlessConsent: true,
    firstName: 'Deborah'
  },
  'hmda-intro': {
    mloInformation: {
      firstName: 'Deborah',
      lastName: 'Smith',
      nmlsid: '12345678',
      email: 'deborah@gmail.com',
      phoneNumber: '8007001234',
      phoneExt: '246',
      photoURL: 'https://mortgage.bankofamerica.com/deborahssmith/photo',
      isGetACallBackEnabled: true
    }
  },
  'save-and-exit': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    applicationId: 'DMA120',
    savedApplicationId: '23455'
  }),
  'off-ramp': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    offRampCode: strDefault('code', 'OR025'),
    subCampPhoneNumber: '800.324.4843',
    daysUntilClosing: '25',
    applicationId: 'ff23d2edf'
  }),
  'proceeds-for-bus-purposes': _objectSpread({}, baseDTO()),
  'dmpa-referred-to-hln': {
    isAuthenticated: true,
    applicationId: 'DMA109780',
    mloInformation: {
      entityID: 'a8aa2754-cfae-469d-beeb-002015575055',
      isDirty: false,
      firstName: 'Deborah',
      lastName: 'Smith',
      email: 'deborah.s.smith@bankofamerica.com',
      mloaddress: {
        entityID: 'fd3b7ec2-2188-45bb-957d-eda51f2926c5',
        isDirty: true,
        priorityLevel: 0,
        addressLine: ['119 Cross Center Drive', 'Suite A'],
        city: 'Denver',
        county: null,
        countyGroupCode: null,
        countyGroupName: null,
        countyCode: null,
        countryCode: null,
        countryCodeEnt: null,
        postalCode: '28037',
        state: 'NC',
        stateCode: null,
        type: null,
        sameAddressBoolean: null,
        samePrimaryAndMailingAddress: false,
        usage: null,
        numberOfMonthsAtAddress: null,
        numberOfYearsAtAddress: null,
        startDateAtaddress: null,
        endDateAtAddress: null,
        streetAddress: null,
        preferredContactMethod: false,
        currentDate: 1527190555584
      },
      affiliateCD: '020005NBKFN6E000000000',
      bcZIP: '28037',
      caiID: '84PZ6',
      nbId: 'NBKFN6E',
      nmlsid: '505114',
      phoneExt: '123456',
      phoneNumber: '7046024153',
      photoURL: 'https://mortgage.bankofamerica.com/deborahssmith/photo',
      title: 'Financial Center Lending Officer',
      webSite: 'https://mortgage.bankofamerica.com/deborahssmith',
      bbaURL: 'https://secure.bankofamerica.com/mycommunications/public/appointments/getTopics.go?marketingCode=MLOWEB_ECBBA_A5000_A5200&apptType=IP&zip=28037&caid=84PZ6',
      isGetACallBackEnabled: true,
      isBBAEnabled: true,
      mloisPresent: true,
      workWithAssociates: true,
      isActive: true,
      currentDate: 1527190555584
    }
  },
  'referred-to-hln': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'approvedAndReferredToHLNDTO',
    loanAmount: '160000.00',
    applicationId: 'DMA109780',
    loanNumber: '123456',
    productType: '30FX',
    apr: '4.035',
    rate: '4.375',
    rateLocked: true,
    isAuthenticated: true,
    points: '0.002',
    loanTimeFrame: '45 days',
    firstName: 'Norma',
    lastName: 'Borders',
    nmlsid: '1196115',
    email: 'norma.borders@bankofamerica.com',
    phoneNumber: '704.616.5344',
    loanOfficerWorkPhoneExtn: null,
    primaryApplicantPhone: '7045529523',
    website: 'https://mortgage.bankofamerica.com/normaborders',
    mortgagePrequalifyQueryString: null,
    mortgagePrequalifyURL: null,
    prequalSavedApplicationId: null,
    productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
    productLongDescription: '15-year fixed ',
    productShortDescription: '15yr fixed',
    productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 15 years of the loan.'
  }),
  'refinancing-loan-on-us': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    customerLoans: [{
      account: {
        accountType: null,
        accountNumber: '5101',
        accountBalance: '21593.6',
        vestedBalance: null,
        accountOwnerShipType: null,
        applicationCoOwnsAccount: null,
        currentMarketValue: null,
        financialInstitution: null,
        downPaymentSource: null,
        accountDisplayName: 'MORTGAGE LOAN ACCOUNT',
        yodleeAccountId: null,
        yodleeSiteId: null,
        yodleeAccountSelected: null,
        assetsAccountSelected: false
      },
      address: {
        streetNumber: '272',
        addressLineOne: 'UBMFKHVRE XO',
        addressLineTwo: null,
        city: 'ELY, NV',
        state: 'NV',
        zipcode: '89301',
        countyName: null,
        fipsCountyCode: null
      },
      selectedForRefinance: null
    }, {
      account: {
        accountType: null,
        accountNumber: '9113',
        accountBalance: '113301.17',
        vestedBalance: null,
        accountOwnerShipType: null,
        applicationCoOwnsAccount: null,
        currentMarketValue: null,
        financialInstitution: null,
        downPaymentSource: null,
        accountDisplayName: 'MORTGAGE LOAN ACCOUNT',
        yodleeAccountId: null,
        yodleeSiteId: null,
        yodleeAccountSelected: null,
        assetsAccountSelected: false
      },
      address: {
        streetNumber: '829',
        addressLineOne: 'W MACARTHUR BLVD',
        addressLineTwo: '1905 RAKKS EGOJ VGOD',
        city: 'HAYWARD',
        state: 'CA',
        zipcode: '94541',
        countyName: null,
        fipsCountyCode: null
      },
      selectedForRefinance: null
    }],
    yesSelectedForRefinance: null
  }),
  'choose-refi-loan-on-us': {
    type: 'customerLoanOnUsDTO',
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    customerLoans: [{
      account: {
        accountType: null,
        accountNumber: '5101',
        accountBalance: '21593.6',
        vestedBalance: null,
        accountOwnerShipType: null,
        applicationCoOwnsAccount: null,
        currentMarketValue: null,
        financialInstitution: null,
        downPaymentSource: null,
        accountDisplayName: 'MORTGAGE LOAN ACCOUNT',
        yodleeAccountId: null,
        yodleeSiteId: null,
        yodleeAccountSelected: null,
        assetsAccountSelected: false
      },
      address: {
        streetNumber: '272',
        addressLineOne: 'UBMFKHVRE XO',
        addressLineTwo: null,
        city: 'ELY, NV',
        state: 'NV',
        zipcode: '89301',
        countyName: null,
        fipsCountyCode: null
      },
      selectedForRefinance: null
    }, {
      account: {
        accountType: null,
        accountNumber: '9113',
        accountBalance: '113301.17',
        vestedBalance: null,
        accountOwnerShipType: null,
        applicationCoOwnsAccount: null,
        currentMarketValue: null,
        financialInstitution: null,
        downPaymentSource: null,
        accountDisplayName: 'MORTGAGE LOAN ACCOUNT',
        yodleeAccountId: null,
        yodleeSiteId: null,
        yodleeAccountSelected: null,
        assetsAccountSelected: false
      },
      address: {
        streetNumber: '829',
        addressLineOne: 'W MACARTHUR BLVD',
        addressLineTwo: '1905 RAKKS EGOJ VGOD',
        city: 'HAYWARD',
        state: 'CA',
        zipcode: '94541',
        countyName: null,
        fipsCountyCode: null
      },
      selectedForRefinance: null
    }],
    yesSelectedForRefinance: true
  },
  'cash-out-guideline-contractions': {},
  'bac-sign-in': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    messageCodes: (params.messageCodes || 'H043').split('-')
  }),
  'co-borrower-sign-in': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    messageCodes: (params.messageCodes || 'H030-H049').split('-')
  }),
  'bofa-security-questions': _objectSpread({}, baseDTO()),
  'mortgage-involved': _objectSpread({}, baseDTO()),
  yodlee: {
    selectedChapter: 'PERSONAL-INFORMATION'
  },
  default: {
    selectedChapter: 'PERSONAL-INFORMATION'
  },
  'personal-information': {
    selectedChapter: 'PERSONAL-INFORMATION'
  },
  assets: {
    selectedChapter: 'ASSETS'
  },
  'borrower-personal-information': {
    isUSTrustCustomer: true,
    isMerrillLynchCustomer: false,
    associate: false,
    isMLOExist: false,
    subCampPhoneNumber: '800.324.4842',
    isAuthenticated: true,
    consentContentInfoDTO: null,
    type: 'customerInformationDTO',
    selectedChapter: 'PERSONAL-INFORMATION',
    index: null,
    messageCodes: ['H039'],
    mloInformation: {
      entityID: 'a8aa2754-cfae-469d-beeb-002015575055',
      isDirty: false,
      firstName: 'Deborah',
      lastName: 'Smith',
      email: 'deborah.s.smith@bankofamerica.com',
      mloaddress: {
        entityID: 'fd3b7ec2-2188-45bb-957d-eda51f2926c5',
        isDirty: true,
        priorityLevel: 0,
        addressLine: ['119 Cross Center Drive', 'Suite A'],
        city: 'Denver',
        county: null,
        countyGroupCode: null,
        countyGroupName: null,
        countyCode: null,
        countryCode: null,
        countryCodeEnt: null,
        postalCode: '28037',
        state: 'NC',
        stateCode: null,
        type: null,
        sameAddressBoolean: null,
        samePrimaryAndMailingAddress: false,
        usage: null,
        numberOfMonthsAtAddress: null,
        numberOfYearsAtAddress: null,
        startDateAtaddress: null,
        endDateAtAddress: null,
        streetAddress: null,
        preferredContactMethod: false,
        currentDate: 1527190555584
      },
      affiliateCD: '020005NBKFN6E000000000',
      bcZIP: '28037',
      caiID: '84PZ6',
      nbId: 'NBKFN6E',
      nmlsid: '505114',
      phoneExt: '123456',
      phoneNumber: '7046024153',
      photoURL: 'https://mortgage.bankofamerica.com/deborahssmith/photo',
      title: 'Financial Center Lending Officer',
      webSite: 'https://mortgage.bankofamerica.com/deborahssmith',
      bbaURL: 'https://secure.bankofamerica.com/mycommunications/public/appointments/getTopics.go?marketingCode=MLOWEB_ECBBA_A5000_A5200&apptType=IP&zip=28037&caid=84PZ6',
      isGetACallBackEnabled: true,
      isBBAEnabled: true,
      mloisPresent: true,
      workWithAssociates: true,
      isActive: true,
      currentDate: 1527190555584
    },
    name: {
      firstName: 'Mike',
      middleName: 'J',
      lastName: 'Johnson',
      suffix: 'Jr'
    },
    address: {
      addressLineOne: 'Webster Place',
      addressLineTwo: null,
      city: 'Charlotte',
      state: 'NC',
      streetNumber: '512',
      zipcode: '28209'
    },
    citizenshipStatusType: 'USCitizen',
    samePrimaryAndMailingAddress: true,
    phoneNumber: '123-456-7890',
    phoneNumberType: 'HomePhone',
    primaryApplicantPhone: '123-456-7890',
    email: 'abc@gmail.com',
    dob: '01/01/1989',
    ssn: '342-84-5398',
    haveDependents: true,
    ageOfDependents: ['1', '3'],
    yearsInSchool: '5',
    productUniqueIdentifier: '123abc'
  },
  'borrower-unmarried-relationship': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    selectState: 'AZ',
    typeOfRelationship: 'CivilUnion'
  }),
  'borrower-unmarried-property-rights': _objectSpread({}, baseDTO()),
  'borrower-personal-information-urla-2020': _objectSpread(_objectSpread({
    type: 'customerInformationDTO'
  }, baseDTO()), {}, {
    selectedChapter: 'BORROWER-PERSONAL-INFORMATION-URLA-2020',
    isProspect: boolDefault('prospect', true),
    primaryApplicantPhone: null,
    name: {
      firstName: 'Mario',
      middleName: 'MMario',
      lastName: 'LMario',
      suffix: 'jr'
    },
    address: {
      streetNumber: params.address === 'empty' ? null : '505',
      addressLineOne: params.address === 'empty' ? null : 'Athenian Ct',
      addressLineTwo: params.address === 'empty' ? null : 'Apt K',
      city: params.address === 'empty' ? null : 'Charlotte',
      state: params.address === 'empty' ? null : 'NC',
      zipcode: params.address === 'empty' ? null : '28262',
      countyName: null,
      fipsCountyCode: null
    },
    phoneNumberType: 'CellularPhone',
    phoneNumber: '7327324441',
    email: 'eamil@email.com',
    differentPrimaryAndMailingAddress: false,
    mailingAddress: null,
    citizenshipStatusType: 'NonUSCitizen',
    residencyStatusType: 'PermanentResidentAlien',
    residentType: 'PRGC',
    residentDocument: null,
    dob: null,
    ssn: null,
    countryOfCitizenship: 'IN',
    countryOfResidence: 'US',
    otherCountryOfCitizenship: null,
    highestLevelOfEducationCompleted: null,
    isMilitaryOrVeteran: null,
    currentMilitaryOrVeteran: null,
    interestedInVeteransAdministrationLoan: null,
    maritalStatus: 'Unmarried',
    haveDependents: false,
    ageOfDependents: null,
    consentContentInfoDTO: null,
    countryCitizenshipDescription: null,
    countryResidenceDescription: null,
    dualCitizenshipCountryDescription: null,
    isAddressSameAsBorrower: null,
    isCoBorrowerSpouse: null,
    yearsInSchool: null,
    isUSTrustCustomer: boolDefault('ustrust', false),
    isMerrillLynchCustomer: boolDefault('merill', null),
    isMLOExist: false,
    saveAndExit: null,
    associate: false
  }),
  'borrower-military-service': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    activeOnDuty: true,
    projectedExpirationDateOfService: '02/2020'
  }),
  'mortgage-assumptions': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'loanTermAndPointsDTO',
    productDTOList: [{
      productType: '30FX',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: true,
        productShortDescription: '30yr fixed',
        productLongDescription: '30-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '7',
          apr: '5.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }, {
        type: '1',
        verticalPriority: '1',
        singlePriceOption: false,
        productShortDescription: '30yr FHA',
        productLongDescription: '30-year FHA',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1012.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '2.853',
          apr: '3.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }, {
      productType: '30FX',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: true,
        productShortDescription: '30yr fixed',
        productLongDescription: '30-year fixed',
        productBenefitStatement: 'Rate and Monthly Principal and Interest payment remain the same',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '2230.15',
          closingCosts: '14356.40',
          rate: '6.875',
          apr: '6.939',
          points: '-0.048',
          estimatedCashNeededAtClosing: '451247.4',
          downPayment: '200000',
          estimatedClosingCosts: '14356.40',
          estimatedPointsAndLenderAndThirdPartyFees: '6103.68',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8252.72',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '359',
            ratePercent: '6.875',
            paymentAmount: '1412.4'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '6.875',
            paymentAmount: '1409.16'
          }],
          estimatedPointsAndLenderFees: '531.8',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2267.5',
          initialEscrowAccountFunds: '5985.22'
        }]
      }],
      productTierDTOList: null
    }, {
      productType: '15FX',
      horizontalPriority: '2',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: false,
        productShortDescription: '15yr fixed',
        productLongDescription: '15-year fixed',
        productBenefitStatement: 'Rate and Monthly Principal and Interest payment remain the same',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 15 years of the loan.',
        productTierDTOList: [{
          monthlyPayment: '2646.59',
          closingCosts: '15431.75',
          rate: '6.125',
          apr: '6.311',
          points: '0.483',
          estimatedCashNeededAtClosing: '452322.75',
          downPayment: '200000',
          estimatedClosingCosts: '15431.75',
          estimatedPointsAndLenderAndThirdPartyFees: '7245.33',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8186.42',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '179',
            ratePercent: '6.125',
            paymentAmount: '1828.84'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '6.125',
            paymentAmount: '1829.89'
          }],
          estimatedPointsAndLenderFees: '1673.45',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2201.2',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2661.21',
          closingCosts: '14643.05',
          rate: '6.25',
          apr: '6.378',
          points: '0.111',
          estimatedCashNeededAtClosing: '451534.05',
          downPayment: '200000',
          estimatedClosingCosts: '14643.05',
          estimatedPointsAndLenderAndThirdPartyFees: '6445.53',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8197.52',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '179',
            ratePercent: '6.25',
            paymentAmount: '1843.46'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '6.25',
            paymentAmount: '1843.08'
          }],
          estimatedPointsAndLenderFees: '873.65',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2212.3',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2675.89',
          closingCosts: '14092.85',
          rate: '6.375',
          apr: '6.462',
          points: '-0.15',
          estimatedCashNeededAtClosing: '450983.85',
          downPayment: '200000',
          estimatedClosingCosts: '14092.85',
          estimatedPointsAndLenderAndThirdPartyFees: '5884.38',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8208.47',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '179',
            ratePercent: '6.375',
            paymentAmount: '1858.14'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '6.375',
            paymentAmount: '1857.63'
          }],
          estimatedPointsAndLenderFees: '312.5',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2223.25',
          initialEscrowAccountFunds: '5985.22'
        }]
      }],
      productTierDTOList: null
    }, {
      productType: '7Y',
      horizontalPriority: '3',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: false,
        productShortDescription: '7y/6m ARM',
        productLongDescription: '7-year adjustable',
        productBenefitStatement: 'Initial period has a lower fixed rate, rate can fluctuate thereafter',
        productTooltipText: 'Your interest rate will remain fixed for the initial 7-year period and then can adjust either up or down once every 6 months thereafter.',
        productTierDTOList: [{
          monthlyPayment: '2194.42',
          closingCosts: '15107.40',
          rate: '6.625',
          apr: '7.424',
          points: '0.3',
          estimatedCashNeededAtClosing: '451998.4',
          downPayment: '200000',
          estimatedClosingCosts: '15107.40',
          estimatedPointsAndLenderAndThirdPartyFees: '6876.88',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8230.52',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '5',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '11.625',
            maximumInitialRatePayment: '2028.89',
            maximumLifetimeRate: '11.625',
            maximumLifetimePayment: '2028.89'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '84',
            ratePercent: '6.625',
            paymentAmount: '1376.67'
          }, {
            totalNumberOfPayments: '275',
            ratePercent: '8.125',
            paymentAmount: '1561.41'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1562.39'
          }],
          estimatedPointsAndLenderFees: '1280',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2245.3',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2212.24',
          closingCosts: '14477.80',
          rate: '6.75',
          apr: '7.459',
          points: '0.002',
          estimatedCashNeededAtClosing: '451368.8',
          downPayment: '200000',
          estimatedClosingCosts: '14477.80',
          estimatedPointsAndLenderAndThirdPartyFees: '6236.18',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8241.62',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '5',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '11.75',
            maximumInitialRatePayment: '2050.54',
            maximumLifetimeRate: '11.75',
            maximumLifetimePayment: '2056.51'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '84',
            ratePercent: '6.75',
            paymentAmount: '1394.49'
          }, {
            totalNumberOfPayments: '275',
            ratePercent: '8.125',
            paymentAmount: '1564.58'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1567.3'
          }],
          estimatedPointsAndLenderFees: '639.3',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2256.4',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2230.15',
          closingCosts: '13704.15',
          rate: '6.875',
          apr: '7.489',
          points: '-0.363',
          estimatedCashNeededAtClosing: '450595.15',
          downPayment: '200000',
          estimatedClosingCosts: '13704.15',
          estimatedPointsAndLenderAndThirdPartyFees: '5451.43',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8252.72',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '5',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '11.875',
            maximumInitialRatePayment: '2072.26',
            maximumLifetimeRate: '11.875',
            maximumLifetimePayment: '2074.23'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '84',
            ratePercent: '6.875',
            paymentAmount: '1412.4'
          }, {
            totalNumberOfPayments: '275',
            ratePercent: '8.125',
            paymentAmount: '1567.71'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1567.83'
          }],
          estimatedPointsAndLenderFees: '-145.45',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2267.5',
          initialEscrowAccountFunds: '5985.22'
        }]
      }],
      productTierDTOList: null
    }, {
      productType: '10Y',
      horizontalPriority: '4',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: false,
        productShortDescription: '10y/6m ARM',
        productLongDescription: '10-year adjustable',
        productBenefitStatement: 'Initial period has a lower fixed rate, rate can fluctuate thereafter',
        productTooltipText: 'Your interest rate will remain fixed for the initial 10-year period and then can adjust either up or down once every 6 months thereafter.',
        productTierDTOList: [{
          monthlyPayment: '2194.42',
          closingCosts: '15146.10',
          rate: '6.625',
          apr: '7.213',
          points: '0.318',
          estimatedCashNeededAtClosing: '452037.1',
          downPayment: '200000',
          estimatedClosingCosts: '15146.10',
          estimatedPointsAndLenderAndThirdPartyFees: '6915.58',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8230.52',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '5',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '11.625',
            maximumInitialRatePayment: '1965.59',
            maximumLifetimeRate: '11.625',
            maximumLifetimePayment: '1967.57'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '120',
            ratePercent: '6.625',
            paymentAmount: '1376.67'
          }, {
            totalNumberOfPayments: '239',
            ratePercent: '8.125',
            paymentAmount: '1543.57'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1543.81'
          }],
          estimatedPointsAndLenderFees: '1318.7',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2245.3',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2212.24',
          closingCosts: '14368.15',
          rate: '6.75',
          apr: '7.260',
          points: '-0.049',
          estimatedCashNeededAtClosing: '451259.15',
          downPayment: '200000',
          estimatedClosingCosts: '14368.15',
          estimatedPointsAndLenderAndThirdPartyFees: '6126.53',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8241.62',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '5',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '11.75',
            maximumInitialRatePayment: '1987.48',
            maximumLifetimeRate: '11.75',
            maximumLifetimePayment: '1987.54'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '120',
            ratePercent: '6.75',
            paymentAmount: '1394.49'
          }, {
            totalNumberOfPayments: '239',
            ratePercent: '8.125',
            paymentAmount: '1548.3'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1548.04'
          }],
          estimatedPointsAndLenderFees: '529.65',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2256.4',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2230.15',
          closingCosts: '13592.35',
          rate: '6.875',
          apr: '7.307',
          points: '-0.415',
          estimatedCashNeededAtClosing: '450483.35',
          downPayment: '200000',
          estimatedClosingCosts: '13592.35',
          estimatedPointsAndLenderAndThirdPartyFees: '5339.63',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8252.72',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '5',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '11.875',
            maximumInitialRatePayment: '2009.44',
            maximumLifetimeRate: '11.875',
            maximumLifetimePayment: '2010.73'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '120',
            ratePercent: '6.875',
            paymentAmount: '1412.4'
          }, {
            totalNumberOfPayments: '239',
            ratePercent: '8.125',
            paymentAmount: '1552.97'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1554.7'
          }],
          estimatedPointsAndLenderFees: '-257.25',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2267.5',
          initialEscrowAccountFunds: '5985.22'
        }]
      }],
      productTierDTOList: null
    }, {
      productType: '5Y',
      horizontalPriority: '5',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: false,
        productShortDescription: '5y/6m ARM',
        productLongDescription: '5-year adjustable',
        productBenefitStatement: 'Initial period has a lower fixed rate, rate can fluctuate thereafter',
        productTooltipText: 'Your interest rate will remain fixed for the initial 5-year period and then can adjust either up or down once every 6 months thereafter.',
        productTierDTOList: [{
          monthlyPayment: '2248.15',
          closingCosts: '14777.20',
          rate: '7',
          apr: '7.738',
          points: '0.131',
          estimatedCashNeededAtClosing: '451668.2',
          downPayment: '200000',
          estimatedClosingCosts: '14777.20',
          estimatedPointsAndLenderAndThirdPartyFees: '6513.53',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8263.67',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '2',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '9',
            maximumInitialRatePayment: '1698.39',
            maximumLifetimeRate: '12',
            maximumLifetimePayment: '2128.16'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '60',
            ratePercent: '7',
            paymentAmount: '1430.4'
          }, {
            totalNumberOfPayments: '299',
            ratePercent: '8.125',
            paymentAmount: '1578.82'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1578.95'
          }],
          estimatedPointsAndLenderFees: '916.65',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2278.45',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2266.24',
          closingCosts: '14306.70',
          rate: '7.125',
          apr: '7.767',
          points: '-0.093',
          estimatedCashNeededAtClosing: '451197.7',
          downPayment: '200000',
          estimatedClosingCosts: '14306.70',
          estimatedPointsAndLenderAndThirdPartyFees: '6031.93',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8274.77',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '2',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '9.125',
            maximumInitialRatePayment: '1718.02',
            maximumLifetimeRate: '12.125',
            maximumLifetimePayment: '2144.15'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '60',
            ratePercent: '7.125',
            paymentAmount: '1448.49'
          }, {
            totalNumberOfPayments: '299',
            ratePercent: '8.125',
            paymentAmount: '1580.91'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1584'
          }],
          estimatedPointsAndLenderFees: '435.05',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2289.55',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2284.43',
          closingCosts: '13743.75',
          rate: '7.25',
          apr: '7.791',
          points: '-0.36',
          estimatedCashNeededAtClosing: '450634.75',
          downPayment: '200000',
          estimatedClosingCosts: '13743.75',
          estimatedPointsAndLenderAndThirdPartyFees: '5457.88',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8285.87',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '2',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '9.25',
            maximumInitialRatePayment: '1737.72',
            maximumLifetimeRate: '12.25',
            maximumLifetimePayment: '2169.07'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '60',
            ratePercent: '7.25',
            paymentAmount: '1466.68'
          }, {
            totalNumberOfPayments: '299',
            ratePercent: '8.125',
            paymentAmount: '1582.97'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1578.51'
          }],
          estimatedPointsAndLenderFees: '-139',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2300.65',
          initialEscrowAccountFunds: '5985.22'
        }]
      }],
      productTierDTOList: null
    }, {
      productType: '20FX',
      horizontalPriority: '6',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: false,
        productShortDescription: '20yr fixed',
        productLongDescription: '20-year fixed',
        productBenefitStatement: 'Rate and Monthly Principal and Interest payment remain the same',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 20 years of the loan.',
        productTierDTOList: [{
          monthlyPayment: '2452.53',
          closingCosts: '15291.30',
          rate: '6.75',
          apr: '6.890',
          points: '0.392',
          estimatedCashNeededAtClosing: '452182.3',
          downPayment: '200000',
          estimatedClosingCosts: '15291.30',
          estimatedPointsAndLenderAndThirdPartyFees: '7049.68',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8241.62',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '239',
            ratePercent: '6.75',
            paymentAmount: '1634.78'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '6.75',
            paymentAmount: '1636.07'
          }],
          estimatedPointsAndLenderFees: '1477.8',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2256.4',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2468.55',
          closingCosts: '13821.05',
          rate: '6.875',
          apr: '6.927',
          points: '-0.297',
          estimatedCashNeededAtClosing: '450712.05',
          downPayment: '200000',
          estimatedClosingCosts: '13821.05',
          estimatedPointsAndLenderAndThirdPartyFees: '5568.33',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8252.72',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '239',
            ratePercent: '6.875',
            paymentAmount: '1650.8'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '6.875',
            paymentAmount: '1650.37'
          }],
          estimatedPointsAndLenderFees: '-3.55',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2267.5',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2484.64',
          closingCosts: '12582.85',
          rate: '7',
          apr: '6.977',
          points: '-0.878',
          estimatedCashNeededAtClosing: '449473.85',
          downPayment: '200000',
          estimatedClosingCosts: '12582.85',
          estimatedPointsAndLenderAndThirdPartyFees: '4319.18',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8263.67',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '239',
            ratePercent: '7',
            paymentAmount: '1666.89'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '7',
            paymentAmount: '1668.24'
          }],
          estimatedPointsAndLenderFees: '-1252.7',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2278.45',
          initialEscrowAccountFunds: '5985.22'
        }]
      }],
      productTierDTOList: null
    }],
    displayProducts: true,
    horizontalTabs: ['Modification', '30FX', '15FX', '7Y', '10Y', '5Y', '20FX'],
    zipCode: '77459',
    selectedProduct: '30FX',
    selectedTier: '-0.048',
    selectedTierVerticalPriority: null,
    borrowerFirstName: 'John',
    coBorrowerFirstName: null,
    borrowerPreferedRewardTier: 'PlatinumHonors',
    coBorrowerPreferedRewardTier: null,
    loanAmount: '215000.0',
    rateLockPeriod: 45,
    downPaymentPercent: '48',
    purchaseprice: '415000',
    refinanceGoal: 'GetCashOut',
    // other options are: LowerMyPayment or GetCashOut
    cashOutAmount: '15000',
    rateMod: {
      loanAcctNumber: '280007113',
      loan: {
        borrowers: {
          borrower: [{
            partyID: '10050184808',
            name: {
              prefix: null,
              firstName: 'STEPHEN',
              middleName: null,
              lastName: 'SITTETE',
              suffix: null
            }
          }]
        },
        property: {
          propertyUsageType: 'PrimaryResidence',
          address: {
            streetAddress: '4421 NEWCASTLE CV',
            city: 'BRUNSWICK',
            state: 'OH',
            postalCode: '4421'
          }
        }
      },
      eligibility: {
        eligibile: true,
        status: 'OFFERED',
        statusDateTime: 1664301044869,
        validations: null
      },
      rateModification: {
        loanBalanceAmount: 93694.61,
        rateDateTime: 1664147186000,
        rateExpirationDateTime: 1664175600000,
        presentDetail: {
          rateDetail: {
            ruleId: null,
            description: 'Rate',
            code: null,
            ratePercent: 8,
            marginPercent: 0,
            pointsPercent: 0
          },
          housingExpense: {
            type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
            description: 'Monthly Principal And Interest Payment',
            amount: 812.67
          }
        },
        proposedDetail: {
          rateDetail: {
            ruleId: null,
            description: 'Rate',
            code: null,
            ratePercent: 4.625,
            marginPercent: 0,
            pointsPercent: 0
          },
          housingExpense: {
            type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
            description: 'Monthly Principal And Interest Payment',
            amount: 706.61
          }
        },
        savingsDetail: {
          rateDetail: {
            ruleId: null,
            description: 'Rate',
            code: null,
            ratePercent: 3.375,
            marginPercent: 0,
            pointsPercent: 0
          },
          housingExpense: {
            type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
            description: 'Monthly Principal And Interest Payment',
            amount: 106.06
          }
        },
        fees: {
          loanFee: [{
            categoryType: 'LENDER',
            categorySubType: 'NONE',
            description: 'One-time fee',
            quotedFeeAmount: 0,
            policyFeeAmount: 0,
            borrowerPaidAmount: 950.00,
            lenderPaidAmount: 0,
            thirdPartyPaidAmount: 0,
            sellerPaidAmount: 0,
            hudline: null
          }]
        }
      },
      loanDetailsAccepted: null,
      rateModOfferAccepted: false,
      confirmLoanDetailsAccepted: null,
      rateModDetailsSubmit: null,
      processingStatus: null
    }
  }),
  'your-new-home': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'PropertyInformationDTO',
    index: null,
    selectedChapter: 'PROPERTY',
    propertyAddress: {
      cachedCounties: [{
        state: 'NC',
        fipsStateCode: '37',
        countyName: 'CABARRUS',
        fipsCountyCode: '025'
      }, {
        state: 'NC',
        fipsStateCode: '37',
        countyName: 'MECKLENBURG',
        fipsCountyCode: '119'
      }]
    },
    plannedClosingDate: '01/01/2022',
    includeFinanceContingencyDate: 'true',
    financeContingencyDate: '01/01/2022',
    propertyUse: 'Primary',
    propertyType: 'Townhouse',
    borrowerDOB: '02/01/1990',
    coborrowerDOB: null,
    closingDateLimit: 28
  }),
  'your-new-home-confirm-address': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'addressStandardizationDTO',
    index: null,
    selectedChapter: 'YOUR-NEW-HOME',
    standardizedAddressOptions: [{
      addressLineOne: 'Side St.',
      addressLineTwo: 'Apt 1B',
      city: 'Chicago',
      state: 'IL',
      streetNumber: '246',
      zipcode: '60007'
    }, {
      addressLineOne: 'Main St.',
      addressLineTwo: 'Apt 1B',
      city: 'Chicago',
      state: 'IL',
      streetNumber: '246',
      zipcode: '60007'
    }],
    selectedAddressIndex: integerDefault('index', 0)
  }),
  'use-of-funds': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    refinanceUseOfFundTypeList: ['DebtConsolidationOrOther', 'PayOffBridgeOrConstructionLoan', 'PurchaseHome']
  }),
  'refi-gather-info-about-home': {
    type: 'PropertyInformationDTO',
    index: null,
    selectedChapter: 'YOUR-NEW-HOME',
    completedChapters: ['BORROWER-PERSONAL-INFORMATION'],
    clickableChapters: ['BORROWER-PERSONAL-INFORMATION'],
    refinancingPrimaryHome: null,
    isPrefilledSubjectPropertyValue: true,
    propertyAddress: {
      addressLineOne: 'Main Str.',
      addressLineTwo: 'Apt 1B',
      city: 'Chicago',
      state: 'IL',
      streetNumber: '246',
      zipcode: '60007',
      county: 'Mecklenburg County',
      cachedCounties: [{
        state: 'NC',
        fipsStateCode: '37',
        countyName: 'CABARRUS',
        fipsCountyCode: '025'
      }, {
        state: 'NC',
        fipsStateCode: '37',
        countyName: 'MECKLENBURG',
        fipsCountyCode: '119'
      }]
    },
    propertyType: 'Condominium',
    borrowerFirstName: 'John',
    coBorrowerFirstName: 'Jane',
    whoOwnsThisProperty: 'Both',
    acquisitionDate: '01/2017',
    originalCost: 4029,
    currentHomeValue: 209000,
    isPrimaryHouse: null
  },
  'borrower-living-situation': _objectSpread(_objectSpread({
    type: 'livingSituationDTO'
  }, baseDTO()), {}, {
    startDateAtAddress: '01/2017',
    livingType: 'Rent',
    monthlyRentPayment: 2000.99,
    propertyManagerPhone: '8484482345',
    applicantBirthDate: '11/11/1984'
  }),
  'borrower-past-living-situation': _objectSpread(_objectSpread({
    type: 'pastLivingSituationDTO'
  }, baseDTO()), {}, {
    index: 1,
    startDateAtAddress: '01/2017',
    startDateAtPreviousAddress: '05/2017',
    livingType: 'Rent',
    monthlyRentPayment: 2000.99,
    propertyManagerPhone: '8484482345',
    address: {}
  }),
  'borrower-income-tax-returns': {
    type: 'incomeTaxReturnsInfoDTO',
    index: null,
    selectedChapter: 'BORROWER-PERSONAL-INFORMATION',
    clickableChapters: [],
    completedChapters: [],
    isShowJointTaxReturnsFiled: false,
    noJointTaxReturnsOrExtensionFiled: null,
    hasLivedAtCurrentResidenceMoreThanAYear: true,
    hasFiledTaxReturnsFromDifferentAddress: false,
    taxReturnFilingAddressOptions: [{
      streetNumber: '620',
      addressLineOne: 'Parkaire Ln',
      addressLineTwo: 'Apt 1010',
      city: 'Charlotte',
      state: 'NC',
      zipcode: '28217'
    }, {
      streetNumber: '628',
      addressLineOne: 'Dittleworth DR',
      addressLineTwo: 'Apt 112',
      city: 'Charlotte',
      state: 'NC',
      zipcode: '282157'
    }],
    taxReturnFilingSelectedAddressIndex: '-1',
    taxReturnDifferentFilingAddress: {
      addressLineOne: '3243 sdijchs',
      addressLineTwo: null,
      city: 'charlotte',
      countyName: null,
      fipsCountyCode: null,
      state: 'NC',
      streetNumber: null,
      zipcode: '28202'
    }
  },
  'co-borrower-income-tax-returns': {
    type: 'incomeTaxReturnsInfoDTO',
    index: null,
    selectedChapter: 'CO-BORROWER-PERSONAL-INFORMATION',
    clickableChapters: [],
    completedChapters: [],
    isShowJointTaxReturnsFiled: false,
    jointTaxReturnsFiled: true,
    extensionFiledOnTaxReturns: null,
    noJointTaxReturnsOrExtensionFiled: null,
    taxReturnFilingAddressOptions: [{
      streetNumber: '620',
      addressLineOne: 'Parkaire Ln',
      addressLineTwo: 'Apt 1010',
      city: 'Charlotte',
      state: 'NC',
      zipcode: '28217'
    }, {
      streetNumber: '628',
      addressLineOne: 'Dittleworth DR',
      addressLineTwo: 'Apt 112',
      city: 'Charlotte',
      state: 'NC',
      zipcode: '282157'
    }],
    taxReturnFilingSelectedAddressIndex: '-1',
    taxReturnDifferentFilingAddress: {
      addressLineOne: '3243 sdijchs',
      addressLineTwo: null,
      city: 'charlotte',
      countyName: null,
      fipsCountyCode: null,
      state: 'NC',
      streetNumber: null,
      zipcode: '28202'
    }
  },
  'borrower-citizenship-status': {},
  'borrower-residency-status': {},
  'borrower-marital-status': {},
  'borrower-ssn-dob': {},
  'borrower-military-info': {
    isMilitaryOrVeteran: 'YES',
    currentMilitaryOrVeteran: 'VETERAN'
  },
  'borrower-add-co-borrower': _objectSpread({}, baseDTO()),
  'borrower-co-borrower-same-address': _objectSpread({}, baseDTO()),
  'borrower-co-borrower-spouse': _objectSpread({}, baseDTO()),
  'co-borrower-personal-information': {
    type: 'contactInfoDTO',
    selectedChapter: 'PERSONAL-INFORMATION',
    index: null,
    messageCodes: ['H040'],
    mloInformation: {
      entityID: 'a8aa2754-cfae-469d-beeb-002015575055',
      isDirty: false,
      firstName: 'Bob',
      lastName: 'Jones',
      email: 'Bob.s.Bob@bankofamerica.com',
      mloaddress: {
        entityID: 'fd3b7ec2-2188-45bb-957d-eda51f2926c5',
        isDirty: true,
        priorityLevel: 0,
        addressLine: ['119 Cross Center Drive', 'Suite A'],
        city: 'Denver',
        county: null,
        countyGroupCode: null,
        countyGroupName: null,
        countyCode: null,
        countryCode: null,
        countryCodeEnt: null,
        postalCode: '28037',
        state: 'NC',
        stateCode: null,
        type: null,
        sameAddressBoolean: null,
        samePrimaryAndMailingAddress: false,
        usage: null,
        numberOfMonthsAtAddress: null,
        numberOfYearsAtAddress: null,
        startDateAtaddress: null,
        endDateAtAddress: null,
        streetAddress: null,
        preferredContactMethod: false,
        currentDate: 1527190555584
      },
      affiliateCD: '020005NBKFN6E000000000',
      bcZIP: '28037',
      caiID: '84PZ6',
      nbId: 'NBKFN6E',
      nmlsid: '000000',
      phoneExt: '123456',
      phoneNumber: '7046024153',
      photoURL: 'https://mortgage.bankofamerica.com/deborahssmith/photo',
      title: 'Financial Center Lending Officer',
      webSite: 'https://mortgage.bankofamerica.com/deborahssmith',
      bbaURL: 'https://secure.bankofamerica.com/mycommunications/public/appointments/getTopics.go?marketingCode=MLOWEB_ECBBA_A5000_A5200&apptType=IP&zip=28037&caid=84PZ6',
      isGetACallBackEnabled: true,
      isBBAEnabled: true,
      mloisPresent: true,
      workWithAssociates: true,
      isActive: true,
      currentDate: 1527190555584
    },
    name: {
      firstName: 'Mike',
      middleName: 'J',
      lastName: 'Johnson',
      suffix: null
    },
    address: {},
    samePrimaryAndMailingAddress: true,
    mailingAddress: {
      addressLineOne: null,
      addressLineTwo: null,
      city: null,
      state: null,
      streetNumber: null,
      zipcode: null
    },
    phoneNumber: '123-456-7890',
    phoneNumberType: null,
    email: 'abc@gmail.com',
    citizenshipStatusType: 'DualCitizenWithUS',
    residencyStatusType: 'PermanentResidentAlien',
    countryOfCitizenship: 'US',
    otherCountryOfCitizenship: 'AF',
    countryOfResidence: 'US',
    dob: '01/01/1989',
    ssn: '342-84-5398',
    yearsInSchool: '5',
    isMilitaryOrVeteran: 'false',
    currentMilitaryOrVeteran: 'current',
    interestedInVeteransAdministrationLoan: 'false',
    maritalStatus: 'Married',
    haveDependents: 'false',
    ageOfDependents: ['3', '4'],
    consentToContact: false
  },
  'co-borrower-personal-information-urla-2020': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    isProspect: boolDefault('prospect', true),
    isUSTrustCustomer: boolDefault('ustrust', false),
    isMerrillLynchCustomer: boolDefault('merill', null),
    primaryApplicantPhone: null,
    type: 'contactInfoDTO',
    selectedChapter: 'PERSONAL-INFORMATION',
    index: null,
    name: {
      firstName: 'Mike',
      middleName: 'J',
      lastName: 'Johnson',
      suffix: null
    },
    address: {},
    samePrimaryAndMailingAddress: true,
    mailingAddress: {
      addressLineOne: null,
      addressLineTwo: null,
      city: null,
      state: null,
      streetNumber: null,
      zipcode: null
    },
    phoneNumber: '123-456-7890',
    phoneNumberType: null,
    email: 'abc@gmail.com',
    citizenshipStatusType: 'DualCitizenWithUS',
    residencyStatusType: 'PermanentResidentAlien',
    countryOfCitizenship: 'US',
    otherCountryOfCitizenship: 'AF',
    countryOfResidence: 'US',
    dob: '01/01/1989',
    ssn: '342-84-5398',
    yearsInSchool: '5',
    isMilitaryOrVeteran: 'false',
    currentMilitaryOrVeteran: 'current',
    interestedInVeteransAdministrationLoan: 'false',
    maritalStatus: 'Married',
    haveDependents: 'false',
    ageOfDependents: ['3', '4'],
    consentToContact: false
  }),
  'co-borrower-military-service': _objectSpread({}, baseDTO()),
  'co-borrower-unmarried-property-rights': _objectSpread({}, baseDTO()),
  'co-borrower-unmarried-relationship': _objectSpread({}, baseDTO()),
  'co-borrower-living-situation': _objectSpread(_objectSpread({
    type: 'colivingSituationDTO'
  }, baseDTO()), {}, {
    startDateAtAddress: '01/2017',
    livingType: 'Rent',
    monthlyRentPayment: 2000.99,
    propertyManagerPhone: '8484482345'
  }),
  'co-borrower-past-living-situation': _objectSpread(_objectSpread({
    type: 'coPastLivingSituationDTO'
  }, baseDTO()), {}, {
    index: 1,
    startDateAtAddress: '01/2017',
    startDateAtPreviousAddress: '05/2017',
    livingType: 'Rent',
    monthlyRentPayment: 2000.99,
    propertyManagerPhone: '8484482345',
    address: {}
  }),
  'co-borrower-living-situation-address': {
    livingType: 'Rent'
  },
  'borrower-past-living-situation-address': {
    livingType: 'Rent'
  },
  'co-borrower-past-living-situation-address': {
    livingType: 'Rent'
  },
  'co-borrower-residency-status': {},
  'co-borrower-live-with-borrower': {
    type: 'coBorrowerLivewithBorrowerDTO',
    index: 1,
    selectedChapter: null,
    clickableChapters: null,
    completedChapters: null,
    coBorrowerLiveWithBorrower: null,
    primaryAppFirstName: 'AAA'
  },
  'co-borrower-citizenship-status': {},
  'co-borrower-ssn-dob': {
    countryResidence: '',
    countryCitizenship: 'US',
    dualCitizenshipCountry: null,
    birthDate: null,
    socialSecurityNumber: null,
    hasDualCitizenship: true,
    // so we can see the optional input
    residentAlien: true // so we can see the optional input
  },
  'co-borrower-military-info': {},
  'borrower-income-prefill-resources': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    borrowerFirstName: 'John',
    coBorrowerFirstName: 'Jane'
  }),
  'co-borrower-income-prefill-resources': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    coBorrowerFirstName: 'Firstname'
  }),
  'borrower-current-income': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    messageCodes: (params.messageCodes || 'H019').split('-'),
    incomePrefillDisabled: false,
    borrowerFirstName: 'John',
    coBorrowerFirstName: 'Jane'
  }),
  'co-borrower-current-income': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    messageCodes: (params.messageCodes || 'H019').split('-'),
    borrowerFirstName: 'John',
    coBorrowerFirstName: 'Jane',
    incomePrefillDisabled: true
  }),
  'your-new-home-misc': {
    heldOnTrustOrCorp: 'true',
    underConstruction: 'true',
    noneOftheStmts: null,
    shortsaleOrForeclosure: 'true',
    pud: null,
    hOADues: null,
    hOADuesAmount: null
  },
  'your-new-home-misc-urla-2020': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    heldOnTrustOrCorp: params.prefill === 'none' ? null : 'true',
    propertyToRunMyOwnBusiness: params.prefill === 'none' ? null : 'true',
    underConstruction: params.prefill === 'none' ? null : 'true',
    noneOftheStmts: null,
    shortsaleOrForeclosure: params.prefill === 'none' ? null : 'true',
    pud: params.pud === 'true' ? 'true' : null,
    hOADues: params.hoa === 'true' ? 'true' : null,
    hOADuesAmount: params.hoaAmount || null,
    manufacturedHome: params.prefill === 'none' ? null : 'true'
  }),
  'borrower-income-type': {
    selectedChapter: 'INCOME',
    hasRetirementIncome: 'true',
    hasEmploymentIncome: 'true',
    hasSelfEmploymentIncome: null
  },
  'borrower-employed-by': _objectSpread({}, baseDTO()),
  'borrower-income-prefill-consent': _objectSpread({}, baseDTO()),
  'borrower-income-prefill': {
    type: 'employmentBusinessDTO',
    selectedChapter: 'BORROWER-INCOME-PREFILL-RESOURCES',
    isAuthenticated: true,
    bypassServerSideValidationFields: null,
    applicationId: 'DMA8157',
    messageCodes: null,
    mortgagePrequalifyQueryString: 'requesttype=MPQ',
    mortgagePrequalifyURL: '/applynow/initialize-workflow.go?requesttype=MPQ',
    businessEmployments: [{
      isFullTime: true,
      employerName: 'AON',
      jobTitle: 'Leader',
      startDate: '03/2005',
      endDate: null,
      yearlyIncome: '64070.4',
      hasAdditionalIncome: true,
      overtime: '0.0',
      bonus: '200.04',
      commission: '0.0',
      employerPhoneNumber: null,
      isCurrentEmployment: true,
      businessName: null,
      businessType: null,
      jobType: null,
      profitLossStartDate: null,
      profitLossEndDate: null,
      lineOfWorkStartDate: null,
      isSelfEmployment: null,
      branchOfService: null,
      einNumber: null,
      fiscalYearEndDate: null,
      isPrefillIncomeEdited: null,
      vendorMasterRefNumber: '100068774495',
      vendorReferenceNumber: '100068774503',
      vendorOrderDate: '01-24-2018'
    }, {
      isFullTime: false,
      employerName: 'Goodyear Tire & Rubber Company',
      jobTitle: 'Temp-2',
      startDate: '03/2005',
      endDate: '04/2006',
      yearlyIncome: '56332.8',
      hasAdditionalIncome: true,
      overtime: '0.0',
      bonus: '200.04',
      commission: '0.0',
      employerPhoneNumber: null,
      isCurrentEmployment: false,
      businessName: null,
      businessType: null,
      jobType: null,
      profitLossStartDate: null,
      profitLossEndDate: null,
      lineOfWorkStartDate: null,
      isSelfEmployment: null,
      branchOfService: null,
      einNumber: null,
      fiscalYearEndDate: null,
      isPrefillIncomeEdited: null,
      vendorMasterRefNumber: '100068774495',
      vendorReferenceNumber: '100068774499',
      vendorOrderDate: '01-24-2018'
    }, {
      isFullTime: false,
      employerName: 'Enterprise USA',
      jobTitle: 'Analyst',
      startDate: '03/2005',
      endDate: null,
      yearlyIncome: '43201.56',
      hasAdditionalIncome: true,
      overtime: '99.96',
      bonus: '200.04',
      commission: '0.0',
      employerPhoneNumber: null,
      isCurrentEmployment: false,
      businessName: null,
      businessType: null,
      jobType: null,
      profitLossStartDate: null,
      profitLossEndDate: null,
      lineOfWorkStartDate: null,
      isSelfEmployment: null,
      branchOfService: null,
      einNumber: null,
      fiscalYearEndDate: null,
      isPrefillIncomeEdited: null,
      vendorMasterRefNumber: '100068774495',
      vendorReferenceNumber: '100068774505',
      vendorOrderDate: '01-24-2018'
    }, {
      isFullTime: false,
      employerName: 'Enterprise USA Financial',
      jobTitle: 'Manager',
      startDate: '03/2005',
      endDate: null,
      yearlyIncome: '63752.04',
      hasAdditionalIncome: true,
      overtime: '0.0',
      bonus: '0.0',
      commission: '0.0',
      employerPhoneNumber: null,
      isCurrentEmployment: true,
      businessName: null,
      businessType: null,
      jobType: null,
      profitLossStartDate: null,
      profitLossEndDate: null,
      lineOfWorkStartDate: null,
      isSelfEmployment: null,
      branchOfService: null,
      einNumber: null,
      fiscalYearEndDate: null,
      isPrefillIncomeEdited: null,
      vendorMasterRefNumber: '100068774495',
      vendorReferenceNumber: '100068774501',
      vendorOrderDate: '01-24-2018'
    }, {
      isFullTime: false,
      employerName: 'Enterprise One',
      jobTitle: 'Assistant',
      startDate: '03/2005',
      endDate: null,
      yearlyIncome: '37171.2',
      hasAdditionalIncome: true,
      overtime: '0.0',
      bonus: '380.04',
      commission: '0.0',
      employerPhoneNumber: null,
      isCurrentEmployment: false,
      businessName: null,
      businessType: null,
      jobType: null,
      profitLossStartDate: null,
      profitLossEndDate: null,
      lineOfWorkStartDate: null,
      isSelfEmployment: null,
      branchOfService: null,
      einNumber: null,
      fiscalYearEndDate: null,
      isPrefillIncomeEdited: null,
      vendorMasterRefNumber: '100068774495',
      vendorReferenceNumber: '100068774497',
      vendorOrderDate: '01-24-2018'
    }],
    showOccupationFields: true,
    occupation: null,
    numberOfYearsInIndustry: null,
    isManualIncome: null,
    saveAndExit: null,
    subCampPhoneNumber: '866.436.2508'
  },
  'borrower-income-prefill-urla-2020': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'employmentBusinessDTO',
    mortgagePrequalifyQueryString: 'requesttype=MPQ',
    mortgagePrequalifyURL: '/applynow/initialize-workflow.go?requesttype=MPQ',
    businessEmployments: [{
      isFullTime: true,
      employerName: 'AON',
      jobTitle: 'Leader',
      startDate: '03/2005',
      endDate: null,
      yearlyIncome: '64070.4',
      borrowerEmployedByInterestedPartyIndicator: true,
      hasAdditionalIncome: true,
      overtime: '0.0',
      bonus: '200.04',
      commission: '0.0',
      employerPhoneNumber: null,
      isCurrentEmployment: true,
      businessName: null,
      businessType: null,
      jobType: null,
      profitLossStartDate: null,
      profitLossEndDate: null,
      lineOfWorkStartDate: null,
      isSelfEmployment: null,
      branchOfService: null,
      einNumber: null,
      fiscalYearEndDate: null,
      isPrefillIncomeEdited: null,
      vendorMasterRefNumber: '100068774495',
      vendorReferenceNumber: '100068774503',
      vendorOrderDate: '01-24-2018'
    }, {
      isFullTime: false,
      employerName: 'Goodyear Tire & Rubber Company',
      jobTitle: 'Temp-2',
      startDate: '03/2005',
      endDate: '04/2006',
      yearlyIncome: '56332.8',
      borrowerEmployedByInterestedPartyIndicator: false,
      hasAdditionalIncome: false,
      overtime: '0.0',
      bonus: '200.04',
      commission: '0.0',
      employerPhoneNumber: null,
      isCurrentEmployment: false,
      businessName: null,
      businessType: null,
      jobType: null,
      profitLossStartDate: null,
      profitLossEndDate: null,
      lineOfWorkStartDate: null,
      isSelfEmployment: null,
      branchOfService: null,
      einNumber: null,
      fiscalYearEndDate: null,
      isPrefillIncomeEdited: null,
      vendorMasterRefNumber: '100068774495',
      vendorReferenceNumber: '100068774499',
      vendorOrderDate: '01-24-2018'
    }, {
      isFullTime: false,
      employerName: 'Enterprise USA',
      jobTitle: 'Analyst',
      startDate: '03/2005',
      endDate: null,
      yearlyIncome: '43201.56',
      borrowerEmployedByInterestedPartyIndicator: true,
      hasAdditionalIncome: false,
      overtime: null,
      bonus: null,
      commission: null,
      employerPhoneNumber: null,
      isCurrentEmployment: false,
      businessName: null,
      businessType: null,
      jobType: null,
      profitLossStartDate: null,
      profitLossEndDate: null,
      lineOfWorkStartDate: null,
      isSelfEmployment: null,
      branchOfService: null,
      einNumber: null,
      fiscalYearEndDate: null,
      isPrefillIncomeEdited: null,
      vendorMasterRefNumber: '100068774495',
      vendorReferenceNumber: '100068774505',
      vendorOrderDate: '01-24-2018'
    }, {
      isFullTime: false,
      employerName: 'Enterprise USA Financial',
      jobTitle: 'Manager',
      startDate: '03/2005',
      endDate: null,
      yearlyIncome: '63752.04',
      borrowerEmployedByInterestedPartyIndicator: false,
      hasAdditionalIncome: true,
      overtime: '0.0',
      bonus: '0.0',
      commission: '0.0',
      employerPhoneNumber: null,
      isCurrentEmployment: true,
      businessName: null,
      businessType: null,
      jobType: null,
      profitLossStartDate: null,
      profitLossEndDate: null,
      lineOfWorkStartDate: null,
      isSelfEmployment: null,
      branchOfService: null,
      einNumber: null,
      fiscalYearEndDate: null,
      isPrefillIncomeEdited: null,
      vendorMasterRefNumber: '100068774495',
      vendorReferenceNumber: '100068774501',
      vendorOrderDate: '01-24-2018'
    }, {
      isFullTime: false,
      employerName: 'Enterprise One',
      jobTitle: 'Assistant',
      startDate: '03/2005',
      endDate: null,
      yearlyIncome: '37171.2',
      borrowerEmployedByInterestedPartyIndicator: true,
      hasAdditionalIncome: true,
      overtime: '0.0',
      bonus: '380.04',
      commission: '0.0',
      employerPhoneNumber: null,
      isCurrentEmployment: false,
      businessName: null,
      businessType: null,
      jobType: null,
      profitLossStartDate: null,
      profitLossEndDate: null,
      lineOfWorkStartDate: null,
      isSelfEmployment: null,
      branchOfService: null,
      einNumber: null,
      fiscalYearEndDate: null,
      isPrefillIncomeEdited: null,
      vendorMasterRefNumber: '100068774495',
      vendorReferenceNumber: '100068774497',
      vendorOrderDate: '01-24-2018'
    }],
    showOccupationFields: true,
    occupation: strDefault('occupation', null),
    numberOfYearsInIndustry: integerDefault('experience', null),
    isManualIncome: null
  }),
  'co-borrower-income-prefill': {
    type: 'employmentBusinessDTO',
    businessEmployments: [{
      isFullTime: true,
      employerName: 'AON',
      jobTitle: 'Leader',
      startDate: '03/2005',
      endDate: null,
      yearlyIncome: '64070.4',
      borrowerEmployedByInterestedPartyIndicator: true,
      hasAdditionalIncome: true,
      overtime: '0.0',
      bonus: '200.04',
      commission: '0.0',
      employerPhoneNumber: null,
      isCurrentEmployment: true,
      businessName: null,
      businessType: null,
      jobType: null,
      profitLossStartDate: null,
      profitLossEndDate: null,
      lineOfWorkStartDate: null,
      isSelfEmployment: null,
      branchOfService: null,
      einNumber: null,
      fiscalYearEndDate: null,
      isPrefillIncomeEdited: null,
      vendorMasterRefNumber: '100068774495',
      vendorReferenceNumber: '100068774503',
      vendorOrderDate: '01-24-2018'
    }]
  },
  'co-borrower-income-prefill-urla-2020': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'employmentBusinessDTO',
    businessEmployments: [{
      isFullTime: true,
      employerName: 'AON',
      jobTitle: 'Leader',
      startDate: '03/2005',
      endDate: null,
      yearlyIncome: '64070.4',
      borrowerEmployedByInterestedPartyIndicator: true,
      hasAdditionalIncome: true,
      overtime: '0.0',
      bonus: '200.04',
      commission: '0.0',
      employerPhoneNumber: null,
      isCurrentEmployment: true,
      businessName: null,
      businessType: null,
      jobType: null,
      profitLossStartDate: null,
      profitLossEndDate: null,
      lineOfWorkStartDate: null,
      isSelfEmployment: null,
      branchOfService: null,
      einNumber: null,
      fiscalYearEndDate: null,
      isPrefillIncomeEdited: null,
      vendorMasterRefNumber: '100068774495',
      vendorReferenceNumber: '100068774503',
      vendorOrderDate: '01-24-2018'
    }],
    occupation: strDefault('occupation', null),
    numberOfYearsInIndustry: integerDefault('experience', null)
  }),
  'borrower-employment': {
    type: 'employmentBusinessDTO',
    hideIsFullTimeQuestion: false,
    showOccupationFields: true,
    occupation: '01',
    numberOfYearsInIndustry: 2,
    businessEmployments: [{}]
  },
  'borrower-employment-urla-2020': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'employmentBusinessDTO',
    hideIsFullTimeQuestion: false,
    showOccupationFields: true,
    occupation: '01',
    numberOfYearsInIndustry: 2,
    businessEmployments: [{}]
  }),
  'borrower-self-employed': {
    type: 'BORROWER-SELF-EMPLOYED',
    showOccupationFields: true,
    occupation: '01',
    numberOfYearsInIndustry: 2,
    selfEmployments: [{
      isFullTime: 'true',
      businessName: 'dfsfsdg',
      einNumber: '454545454',
      'einNumber-masked': '●●-●●●●●●●',
      employerPhoneNumber: '',
      jobTitle: 'IR',
      businessType: 'Sole Proprietor',
      startDate: '012000',
      yearlyIncome: '8979897',
      profitLossStartDate: '012000',
      profitLossEndDate: '012016',
      fiscalYearEndDate: '11202018',
      lastBusinessTaxReturnsFiled: true,
      occupation: '08',
      numberOfYearsInIndustry: '6',
      currentEmployment: true,
      lastBusinessAddress: {
        streetNumber: '272',
        addressLineOne: 'UBMFKHVRE XO',
        addressLineTwo: null,
        city: 'ELY',
        state: 'NV',
        zipcode: '89301',
        countyName: null,
        fipsCountyCode: null
      }
    }]
  },
  'borrower-self-employed-urla-2020': {
    type: 'BORROWER-SELF-EMPLOYED',
    showOccupationFields: true,
    occupation: '01',
    numberOfYearsInIndustry: 2,
    selfEmployments: [{
      isFullTime: 'true',
      businessName: 'dfsfsdg',
      einNumber: '454545454',
      'einNumber-masked': '●●-●●●●●●●',
      employerPhoneNumber: '',
      jobTitle: 'IR',
      businessType: 'Corporation',
      startDate: '012000',
      yearlyIncome: '8979897',
      profitLossStartDate: '012000',
      profitLossEndDate: '012016',
      fiscalYearEndDate: '122017',
      lastBusinessTaxReturnsFiled: true,
      occupation: '08',
      numberOfYearsInIndustry: '6',
      currentEmployment: true,
      lastBusinessAddress: {
        streetNumber: '272',
        addressLineOne: 'UBMFKHVRE XO',
        addressLineTwo: null,
        city: 'ELY',
        state: 'NV',
        zipcode: '89301',
        countyName: null,
        fipsCountyCode: null
      }
    }]
  },
  'borrower-self-employed-gain-loss': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    businessName: strDefault('business', 'Some Business')
  }),
  'borrower-previous-self-employed-gain-loss': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    businessName: strDefault('business', 'Some Previous Business')
  }),
  'borrower-self-employed-income': {
    selfEmploymentBusinessDetails: [{
      businessName: 'Business 1',
      isBusinessProfitable: false,
      yearlyIncome: '123'
    }, {
      businessName: 'Business 2',
      isBusinessProfitable: true,
      yearlyIncome: '234'
    }, {
      businessName: 'Business 3',
      isBusinessProfitable: false,
      yearlyIncome: '345'
    }]
  },
  'borrower-previous-self-employed-income': {
    selfEmploymentBusinessDetails: [{
      businessName: 'Prev Business 1',
      isBusinessProfitable: false,
      yearlyIncome: '123'
    }, {
      businessName: 'Prev Business 2',
      isBusinessProfitable: true,
      yearlyIncome: '234'
    }, {
      businessName: 'Prev Business 3',
      isBusinessProfitable: false,
      yearlyIncome: '345'
    }]
  },
  'co-borrower-self-employed-income': {
    selfEmploymentBusinessDetails: [{
      businessName: 'Co Business 1',
      isBusinessProfitable: false,
      yearlyIncome: '123'
    }, {
      businessName: 'Co Business 2',
      isBusinessProfitable: true,
      yearlyIncome: '234'
    }, {
      businessName: 'Co Business 3',
      isBusinessProfitable: false,
      yearlyIncome: '345'
    }]
  },
  'co-borrower-previous-self-employed-income': {
    selfEmploymentBusinessDetails: [{
      businessName: 'Prev Co Business 1',
      isBusinessProfitable: false,
      yearlyIncome: '123'
    }, {
      businessName: 'Prev Co Business 2',
      isBusinessProfitable: true,
      yearlyIncome: '234'
    }, {
      businessName: 'Prev Co Business 3',
      isBusinessProfitable: false,
      yearlyIncome: '345'
    }]
  },
  'co-borrower-self-employed-gain-loss': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    businessName: strDefault('business', 'Some Co-Business')
  }),
  'co-borrower-previous-self-employed-gain-loss': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    businessName: strDefault('business', 'Some Previous Co-Business')
  }),
  'borrower-retired-other': {
    type: 'BORROWER-RETIRED-OTHER',
    otherIncome: [{
      incomeSource: 'Annuity Income',
      yearlyIncome: '1',
      isCurrentEmployment: true
    }, {
      incomeSource: 'Disability',
      yearlyIncome: '2',
      isCurrentEmployment: true
    }, {
      incomeSource: 'IRA (Keogh, 401k), Distribution',
      yearlyIncome: '3',
      isCurrentEmployment: true
    }]
  },
  'co-borrower-retired-other': {
    type: 'CO-BORROWER-RETIRED-OTHER',
    otherIncome: [{
      isCurrentEmployment: true
    }]
  },
  'borrower-previous-employment': {
    type: 'BORROWER-PREVIOUS-EMPLOYMENT',
    hideIsFullTimeQuestion: false,
    showOccupationFields: true,
    occupation: '01',
    numberOfYearsInIndustry: 2,
    businessEmployments: [{
      hasAdditionalIncome: null
    }]
  },
  'borrower-previous-self-employed': {
    type: 'BORROWER-PREVIOUS-SELF-EMPLOYED',
    showOccupationFields: true,
    occupation: '01',
    numberOfYearsInIndustry: 2,
    selfEmployments: [{
      hasAdditionalIncome: null
    }]
  },
  'borrower-previous-self-employed-urla-2020': {
    type: 'BORROWER-PREVIOUS-SELF-EMPLOYED',
    showOccupationFields: true,
    occupation: '01',
    numberOfYearsInIndustry: 2,
    selfEmployments: [{
      hasAdditionalIncome: null
    }]
  },
  'co-borrower-previous-self-employed': {
    type: 'CO-BORROWER-PREVIOUS-SELF-EMPLOYED',
    showOccupationFields: true,
    occupation: '06',
    numberOfYearsInIndustry: 3,
    selfEmployments: [{
      hasAdditionalIncome: null
    }]
  },
  'co-borrower-previous-self-employed-urla-2020': {
    type: 'CO-BORROWER-PREVIOUS-SELF-EMPLOYED',
    showOccupationFields: true,
    occupation: '06',
    numberOfYearsInIndustry: 3,
    selfEmployments: [{
      hasAdditionalIncome: null
    }]
  },
  'co-borrower-employment': {
    type: 'CO-BORROWER-EMPLOYMENT',
    showOccupationFields: true,
    occupation: '06',
    numberOfYearsInIndustry: 3,
    businessEmployments: [{
      hasAdditionalIncome: 'true'
    }]
  },
  'co-borrower-employment-urla-2020': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'CO-BORROWER-EMPLOYMENT',
    showOccupationFields: true,
    occupation: '06',
    numberOfYearsInIndustry: 3,
    businessEmployments: [{
      hasAdditionalIncome: 'true'
    }]
  }),
  'co-borrower-previous-employment': {
    type: 'CO-BORROWER-PREVIOUS-EMPLOYMENT',
    showOccupationFields: true,
    occupation: '06',
    numberOfYearsInIndustry: 3,
    businessEmployments: [{
      hasAdditionalIncome: null
    }]
  },
  'borrower-previous-military': {
    type: 'BORROWER-PREVIOUS-MILITARY',
    previousMilitaryEmployments: [{
      hasAdditionalIncome: null
    }]
  },
  'co-borrower-previous-military': {
    type: 'CO-BORROWER-PREVIOUS-MILITARY',
    previousMilitaryEmployments: [{
      hasAdditionalIncome: null
    }]
  },
  'loan-amount-calculator': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'LoanAmountCalcDTO',
    index: null,
    purchasePrice: 100000.0,
    downPaymentDollars: 20000,
    downPaymentPercent: 20,
    refiCurrentLoanAmount: '231235.00',
    cashOutAmount: 0,
    isCashOut: boolDefault('cashOut', true)
  }),
  'dmpa-loan-amount-calculator': {
    type: 'LoanAmountCalcDTO',
    index: null,
    selectedChapter: null,
    clickableChapters: null,
    completedChapters: null,
    purchasePrice: 100000.0,
    downPaymentDollars: 20000,
    downPaymentPercent: 20,
    refiCurrentLoanAmount: '231235.00',
    cashOutAmount: 0,
    isCashOut: true
  },
  'borrower-previous-income-type': {},
  'borrower-previous-income': _objectSpread({}, baseDTO()),
  'property-sfr-question': {},
  'property-owner-occupied': {},
  property: {
    selectedChapter: 'PROPERTY',
    completedChapters: ['PERSONAL-INFORMATION'],
    clickableChapters: ['PERSONAL-INFORMATION']
  },
  income: {
    selectedChapter: 'INCOME',
    completedChapters: ['PERSONAL-INFORMATION', 'PROPERTY'],
    clickableChapters: ['PERSONAL-INFORMATION', 'PROPERTY']
  },
  'borrower-additional-income': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    hasAdditionalIncome: true
  }),
  'co-borrower-additional-income': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    hasAdditionalIncome: true
  }),
  'co-borrower-self-employed': {
    type: 'CO-BORROWER-SELF-EMPLOYED',
    showOccupationFields: true,
    occupation: '06',
    numberOfYearsInIndustry: 3,
    selfEmployments: [{
      hasAdditionalIncome: 'true'
    }]
  },
  'co-borrower-self-employed-urla-2020': {
    type: 'CO-BORROWER-SELF-EMPLOYED',
    showOccupationFields: true,
    occupation: '06',
    numberOfYearsInIndustry: 3,
    selfEmployments: [{
      hasAdditionalIncome: 'true'
    }]
  },
  'co-borrower-income-type': {
    selectedChapter: 'INCOME',
    hasRetirementIncome: null,
    hasEmploymentIncome: 'true',
    hasSelfEmploymentIncome: null
  },
  'co-borrower-employed-by': _objectSpread({}, baseDTO()),
  'co-borrower-previous-income-type': {},
  'co-borrower-previous-income': _objectSpread({}, baseDTO()),
  'co-borrower-income-prefill-consent': _objectSpread({}, baseDTO()),
  'assets-manual': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    messageCodes: (params.messageCodes || 'H033').split('-'),
    borrowerName: 'Billy Bob',
    coBorrowerName: 'Suzie Anne',
    primaryApplicantPhone: '7045529523',
    accountList: [{
      accountType: 'Checking',
      accountNumber: '123456',
      accountBalance: '1200.00',
      applicationCoOwnsAccount: false,
      financialInstitution: 'BofA',
      ownerType: 'PrimaryApplicant'
    }, {
      accountType: 'MoneyMarket',
      accountNumber: '98725',
      accountBalance: '100.00',
      applicationCoOwnsAccount: true,
      financialInstitution: 'Chase',
      ownerType: 'Both'
    }]
  }),
  'missing-lien-info': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    messageCodes: (params.messageCodes || 'H018').split('-'),
    type: 'provideMissingLienDTO',
    index: null,
    liabilityList: [{
      liabilityId: '1',
      financialInstitution: 'Chase NA',
      accountNumber: '1931',
      accountBalance: '12000',
      monthlyPaymentAmount: '1200',
      payOffIndicator: true,
      payOffPeriod: 'At Close',
      isLienHeldbyBOA: true
    }, {
      liabilityId: '2',
      financialInstitution: 'BANK OF AMERICA',
      accountNumber: '9500',
      accountBalance: '20000',
      monthlyPaymentAmount: '2000',
      payOffIndicator: false,
      payOffPeriod: 'Prior to Close',
      isLienHeldbyBOA: false
    }]
  }),
  'declarations-legal': {
    type: 'legalDeclarationsDTO',
    index: null,
    selectedChapter: null,
    clickableChapters: null,
    completedChapters: null,
    isCoborrowerAvailable: true,
    outstandingJudgments: 'Yes',
    bankruptcy: 'No',
    foreclosure: 'PrimaryApplicant',
    lawsuit: 'PrimaryApplicant',
    coApplicantName: 'Jane',
    primaryApplicantName: 'John',
    post: {
      valid: true,
      pageErrors: [],
      fieldErrors: [{
        elementId: 'bankruptcy',
        failedValidatorIds: ['server-validation-invalid-error-message']
      }, {
        elementId: 'outstandingJudgments',
        failedValidatorIds: ['server-validation-invalid-error-message']
      }]
    }
  },
  'declarations-income': {
    type: 'incomeDeclarationsDTO',
    index: null,
    selectedChapter: null,
    clickableChapters: null,
    completedChapters: null,
    isCoborrowerAvailable: true,
    loanObligation: null,
    federalDebtFlag: null,
    alimonyObligation: null,
    coApplicantName: 'Jane',
    primaryApplicantName: 'John'
  },
  'declarations-payment': {
    type: 'paymentsDeclarationsDTO',
    index: null,
    selectedChapter: null,
    clickableChapters: null,
    completedChapters: null,
    isCoborrowerAvailable: true,
    ownPropertyType: null,
    propertyOwnershipTitle: null,
    downPaymentBorrowed: null,
    endorser: null,
    occupyasPrimaryResidence: null,
    immediateRelationship: null,
    ownershipInterest: null,
    coApplicantName: 'Jane',
    primaryApplicantName: 'John'
  },
  'assets-bofa-prefill': {
    type: 'assetsAccountInfo',
    index: null,
    selectedChapter: null,
    clickableChapters: null,
    completedChapters: null,
    accountList: [{
      accountType: 'DebitCard',
      accountNumber: '7878',
      accountBalance: '100000.0',
      assetsAccountSelected: false
    }, {
      accountType: 'DebitCard',
      accountNumber: '5232',
      accountBalance: '124456.0',
      assetsAccountSelected: false
    }, {
      accountType: 'DebitCard',
      accountNumber: '2565',
      accountBalance: '199999.0',
      assetsAccountSelected: true
    }]
  },
  'assets-other-prefill': _objectSpread(_objectSpread({
    type: 'assetsOtherPrefillDTO',
    index: null
  }, baseDTO()), {}, {
    assetsOtherPrefillOption: 'FindAccounts',
    hasBoaAccounts: boolDefault('auth', true),
    authenticatedCustomer: boolDefault('auth', true),
    borrowerFirstName: 'Borrower',
    coBorrowerFirstName: 'CoBorrower'
  }),
  'purchase-gating-question': {
    enrichmentCodes: {
      fName: 'Scott',
      lName: 'Griffin',
      phone: '7043392104',
      propEsValue: null,
      balOnloan: null,
      propEsPrice: null,
      propDownPayment: null,
      propCashOutAmt: null,
      propZipcode: null,
      propUse: null,
      propType: null,
      loanPurpose: 'purchase',
      purchase: null,
      refinance: null,
      cashoutrefinance: null,
      affiliateCode: '020005NBKA5BU000000000',
      branchCode: null,
      branchSatelliteCode: null,
      originationCode: '18098',
      sourceCd: '18098',
      subCampCode: '98977',
      cmMmc: null,
      distSalesRouteId: null,
      marketingSourceCd: null,
      partyId: null,
      nmlsid: '1234567'
    },
    productUniqueIdentifier: '123abc'
  },
  landing: _objectSpread(_objectSpread({
    type: 'mortgageExperienceDTO'
  }, baseDTO()), {}, {
    mortgagePrequalifyQueryString: 'requesttype=MPQ&lName=Griffin&fName=Scott&affiliateCode=020005NBKA5BU000000000',
    mortgagePrequalifyURL: '/applynow/initialize-workflow.go?requesttype=MPQ&lName=Griffin&fName=Scott&affiliateCode=020005NBKA5BU000000000',
    enrichmentCodes: {
      fName: 'Scott',
      lName: 'Griffin',
      phone: '7043392104',
      propEsValue: null,
      balOnloan: null,
      propEsPrice: null,
      propDownPayment: null,
      propCashOutAmt: null,
      propZipcode: null,
      propUse: null,
      propType: null,
      loanPurpose: 'purchase',
      purchase: null,
      refinance: null,
      cashoutrefinance: null,
      affiliateCode: '020005NBKA5BU000000000',
      branchCode: null,
      branchSatelliteCode: null,
      originationCode: '18098',
      sourceCd: '18098',
      subCampCode: '98977',
      cmMmc: null,
      distSalesRouteId: null,
      marketingSourceCd: null,
      partyId: null,
      nmlsid: '1234567'
    },
    productUniqueIdentifier: '123abc'
  }),
  'assets-prefill-consent': {
    type: 'prefillConsentDTO',
    index: null,
    selectedChapter: null,
    clickableChapters: null,
    completedChapters: null,
    borrowerName: 'John',
    coBorrowerName: 'Jane',
    borrowerConsent: {
      consentContentUUID: 'b23833c4-67f5-41a3-83d9-8bf795a32a36',
      consentContentRevision: '1',
      recorded: true
    },
    coBorrowerConsent: null,
    accountList: [{
      accountType: 'Savings account',
      accountNumber: '7878',
      accountBalance: '700000.0',
      vestedBalance: null,
      accountOwnerShipType: 'PrimaryApplicant',
      applicationCoOwnsAccount: null,
      currentMarketValue: null,
      financialInstitution: null,
      downPaymentSource: null,
      accountDisplayName: null,
      yodleeAccountId: null,
      yodleeSiteId: null,
      yodleeAccountSelected: null,
      assetsAccountSelected: true,
      merillAccountIndicator: false
    }, {
      accountType: 'Savings account',
      accountNumber: '7979',
      accountBalance: '800000.0',
      vestedBalance: null,
      accountOwnerShipType: 'PrimaryApplicant',
      applicationCoOwnsAccount: null,
      currentMarketValue: null,
      financialInstitution: null,
      downPaymentSource: null,
      accountDisplayName: null,
      yodleeAccountId: null,
      yodleeSiteId: null,
      yodleeAccountSelected: null,
      assetsAccountSelected: true,
      merillAccountIndicator: true
    }, {
      accountType: 'Savings account',
      accountNumber: '5131',
      accountBalance: '700000.0',
      vestedBalance: null,
      accountOwnerShipType: 'CoApplicant',
      applicationCoOwnsAccount: null,
      currentMarketValue: null,
      financialInstitution: null,
      downPaymentSource: null,
      accountDisplayName: null,
      yodleeAccountId: null,
      yodleeSiteId: null,
      yodleeAccountSelected: null,
      assetsAccountSelected: true,
      merillAccountIndicator: false
    }, {
      accountType: 'Checking account',
      accountNumber: '5232',
      accountBalance: '124456.0',
      vestedBalance: null,
      accountOwnerShipType: 'CoApplicant',
      applicationCoOwnsAccount: null,
      currentMarketValue: null,
      financialInstitution: null,
      downPaymentSource: null,
      accountDisplayName: null,
      yodleeAccountId: null,
      yodleeSiteId: null,
      yodleeAccountSelected: null,
      assetsAccountSelected: true,
      merillAccountIndicator: true
    }]
  },
  'assets-prefill-loading': {
    type: 'assetsPrefillLoadingDTO'
  },
  'assets-prefill': {
    type: 'assetsPrefillDTO',
    borrowers: [{
      name: 'John Smith Mr.',
      token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwdWJsaWNfaWQiOiJmODBjYjk0NC1iYzMzLTQ3MTMtNGM2Ni1jNzkwODA1MDRkNjAiLCJzZXNzaW9uX2lkIjoiOWI5ZmNkNmItMjZiZi00MmY1LTczOGUtMGRmMzY0YWNhZThlIiwidXNlcl90eXBlIjoxLCJ0ZW5hbnRfaWQiOiJiMzUyNzhhZC0yN2Y2LTRkMzgtNzA5ZS05ZjAyNWNhYmNmMzgiLCJleHAiOjE1MjQ3NzA0NTUsImlhdCI6MTUyNDY4NDA1NSwiaXNzIjoiRmluYW5jaWFsQXBwcyIsIm5iZiI6MTUyNDY4NDA1NX0.yx7Su_uXhO1kijG-Ejvcv0OdCheokNd1t_aDZFlzuAA',
      borrowerType: 'PrimaryApplicant'
    }, {
      name: 'Jane Smith',
      token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwdWJsaWNfaWQiOiJmODBjYjk0NC1iYzMzLTQ3MTMtNGM2Ni1jNzkwODA1MDRkNjAiLCJzZXNzaW9uX2lkIjoiOWI5ZmNkNmItMjZiZi00MmY1LTczOGUtMGRmMzY0YWNhZThlIiwidXNlcl90eXBlIjoxLCJ0ZW5hbnRfaWQiOiJiMzUyNzhhZC0yN2Y2LTRkMzgtNzA5ZS05ZjAyNWNhYmNmMzgiLCJleHAiOjE1MjQ3NzA0NTUsImlhdCI6MTUyNDY4NDA1NSwiaXNzIjoiRmluYW5jaWFsQXBwcyIsIm5iZiI6MTUyNDY4NDA1NX0.yx7Su_uXhO1kijG-Ejvcv0OdCheokNd1t_aDZFlzuAA',
      borrowerType: 'CoApplicant'
    }],
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    consumerSessionId: null,
    onUsAccountList: [{
      accountType: 'Savings',
      accountNumber: '7878',
      accountBalance: '700000.0',
      vestedBalance: null,
      accountOwnerShipType: 'PrimaryApplicant',
      applicationCoOwnsAccount: null,
      currentMarketValue: null,
      financialInstitution: 'Bank of America',
      downPaymentSource: null,
      accountDisplayName: null,
      yodleeAccountSelected: null,
      assetsAccountSelected: true,
      merillAccountIndicator: false
    }, {
      accountType: 'Checking',
      accountNumber: '5232',
      accountBalance: '124456.0',
      vestedBalance: null,
      accountOwnerShipType: 'PrimaryApplicant',
      applicationCoOwnsAccount: null,
      currentMarketValue: null,
      financialInstitution: 'Bank of America',
      downPaymentSource: null,
      accountDisplayName: null,
      yodleeAccountSelected: null,
      assetsAccountSelected: true,
      merillAccountIndicator: false
    }, {
      accountType: 'DebitCard',
      accountNumber: '2565',
      accountBalance: '199999.0',
      vestedBalance: null,
      accountOwnerShipType: 'CoApplicant',
      applicationCoOwnsAccount: null,
      currentMarketValue: null,
      financialInstitution: 'Bank of America',
      downPaymentSource: null,
      accountDisplayName: null,
      yodleeAccountSelected: null,
      assetsAccountSelected: true,
      merillAccountIndicator: true
    }, {
      accountType: 'CertificateOfDeposit',
      accountNumber: '2565',
      accountBalance: '199999.0',
      vestedBalance: null,
      accountOwnerShipType: 'CoApplicant',
      applicationCoOwnsAccount: null,
      currentMarketValue: null,
      financialInstitution: 'Bank of America',
      downPaymentSource: null,
      accountDisplayName: null,
      yodleeAccountSelected: null,
      assetsAccountSelected: true,
      merillAccountIndicator: true
    }],
    offUsAccountList: [
      // {
      //   accountType: null,
      //   accountNumber: '88b2',
      //   accountBalance: '12356.23',
      //   vestedBalance: null,
      //   accountOwnerShipType: 'PrimaryApplicant',
      //   applicationCoOwnsAccount: null,
      //   currentMarketValue: null,
      //   financialInstitution: 'Discover',
      //   downPaymentSource: null,
      //   accountDisplayName: 'My Account #1',
      //   yodleeAccountSelected: true,
      //   assetsAccountSelected: true,
      // },
      // {
      //   accountType: null,
      //   accountNumber: 'c99c',
      //   accountBalance: '123456.23',
      //   vestedBalance: null,
      //   accountOwnerShipType: 'PrimaryApplicant',
      //   applicationCoOwnsAccount: null,
      //   currentMarketValue: null,
      //   financialInstitution: 'Wells Fargo',
      //   downPaymentSource: null,
      //   accountDisplayName: 'My Account #2',
      //   yodleeAccountSelected: true,
      //   assetsAccountSelected: true,
      // },
      // {
      //   accountType: null,
      //   accountNumber: '5545',
      //   accountBalance: '123556.23',
      //   vestedBalance: null,
      //   accountOwnerShipType: 'CoApplicant',
      //   applicationCoOwnsAccount: null,
      //   currentMarketValue: null,
      //   financialInstitution: 'Chase',
      //   downPaymentSource: null,
      //   accountDisplayName: null,
      //   yodleeAccountSelected: null,
      //   assetsAccountSelected: true,
      // },
    ]
  },
  'assets-reo-general-info': {
    type: 'generalInfoDTO',
    index: null,
    selectedChapter: 'BORROWER-PERSONAL-INFORMATION',
    clickableChapters: [],
    completedChapters: [],
    streetNumber: params.address === 'empty' ? null : '123',
    addressLineOne: params.address === 'empty' ? null : 'Parkaire Ln',
    addressLineTwo: null,
    city: params.address === 'empty' ? null : 'Charlotte',
    state: params.address === 'empty' ? null : 'NC',
    zipcode: params.address === 'empty' ? null : '28217',
    propertyDisposition: 'selling',
    grossRentalIncome: '1234343.3',
    percentageNotRented: null,
    marketValue: '232133.3',
    costOfSale: '324434.4',
    netProceeds: '45343.7',
    proceedsNotDeposited: null,
    amountNotDeposited: null,
    whoOwnsThisProperty: null,
    borrowerFirstName: 'John',
    coBorrowerFirstName: 'James',
    propertyUse: 'Investment',
    percentageOfPropertyOwn: '323.0',
    ownHome: false,
    propertyCoOwnedByAnyoneElse: true,
    isCollateral: true,
    messageCodes: ['H034']
  },
  'borrower-hmda': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    applicantName: strDefault('name', null),
    races: ['NoThankYou', 'AmericanIndianOrAlaskaNative', 'Asian', 'AsianIndian', 'Chinese', 'Filipino', 'BlackOrAfricanAmerican', 'NativeHawaiianPacificIslander', 'GuamanianOrChamorro'],
    otherAmericanIndianOrAlaskaNativeRace: 'Something',
    otherAsianRace: 'Hmong',
    otherPacificIslanderRace: 'Fijian',
    ethnicities: ['Cuban', 'Mexican', 'PuertoRican'],
    otherEthnicity: 'Argentinean',
    genders: ['NoThankYou', 'Male', 'Female']
  }),
  'co-borrower-hmda': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    applicantName: strDefault('name', null),
    ethnicities: ['NotHispanicOrLatino'],
    otherEthnicity: 'a',
    races: ['Asian', 'Vietnamese', 'OtherAsian', 'GuamanianOrChamorro'],
    otherAsianRace: 'Laotian',
    genders: ['Female']
  }),
  'borrower-hmda-dmpa': {
    races: ['NoThankYou', 'AmericanIndianOrAlaskaNative', 'Asian', 'AsianIndian', 'Chinese', 'Filipino', 'BlackOrAfricanAmerican', 'NativeHawaiianPacificIslander', 'GuamanianOrChamorro'],
    otherAmericanIndianOrAlaskaNativeRace: 'Something',
    otherAsianRace: 'Hmong',
    otherPacificIslanderRace: 'Fijian',
    ethnicities: ['Cuban', 'Mexican', 'PuertoRican'],
    otherEthnicity: 'Argentinean',
    genders: ['NoThankYou', 'Male', 'Female']
  },
  'co-borrower-hmda-dmpa': {
    ethnicities: ['NotHispanicOrLatino'],
    otherEthnicity: 'a',
    races: ['Asian', 'Vietnamese', 'OtherAsian', 'GuamanianOrChamorro'],
    otherAsianRace: 'Laotian',
    genders: ['Female']
  },
  'loan-options': {
    type: 'paymentsDeclarationsDTO',
    index: null,
    selectedChapter: null,
    clickableChapters: null,
    completedChapters: null,
    isCoborrowerAvailable: true,
    ownPropertyType: null,
    propertyOwnershipTitle: null,
    downPaymentBorrowed: null,
    endorser: null,
    occupyasPrimaryResidence: null,
    immediateRelationship: null,
    ownershipInterest: null,
    coApplicantName: 'Jane',
    primaryApplicantName: 'John'
  },
  'borrower-unemployment-gap': {
    employmentGaps: [{
      startTime: '01/2017',
      endTime: '03/2017',
      employmentStatus: 'HomeMaker'
    }, {
      startTime: '02/2016',
      endTime: '04/2016'
    }]
  },
  'co-borrower-unemployment-gap': {
    employmentGaps: [{
      startTime: '01/2017',
      endTime: '03/2017',
      employmentStatus: 'HomeMaker'
    }, {
      startTime: '02/2016',
      endTime: '04/2016'
    }]
  },
  'assets-reo': _objectSpread({}, baseDTO()),
  'assets-other-institution': _objectSpread({}, baseDTO()),
  'borrower-military-entitled-to-benefits': _objectSpread({}, baseDTO()),
  'co-borrower-military-entitled-to-benefits': _objectSpread({}, baseDTO()),
  'professional-relationship': _objectSpread({}, baseDTO()),
  'assets-reo-fees': {
    type: 'reoFeesDTO',
    streetNumber: '123',
    addressLineOne: 'Parkaire Ln',
    assetsREOFeesSelection: null,
    fixedInsuranceAmount: null,
    hazardInsuranceAmount: null,
    propertyTaxesAmount: null,
    mortgageInsuranceAmount: '150.00',
    insuranceCB: ['mortgageInsuranceAmountCB'],
    additionalRealEstate: false,
    authenticated: false
  },
  'loan-summary-waiting': {},
  'manner-of-title': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    borrowerName: 'Mr. Santa',
    coBorrowerName: strDefault('coborrower', null),
    borrowerSelected: true,
    coBorrowerSelected: null,
    otherTitleHolderOne: 'Miss Santa',
    otherTitleHolderTwo: 'Jr. Santa'
  }),
  'dmpa-loan-summary-waiting': {},
  'credit-pull-idv-waiting': {},
  'loan-amount-calculator-waiting': {},
  'dmpa-loan-amount-calculator-waiting': {},
  'military-va-loan': _objectSpread({}, baseDTO()),
  'assets-down-payment-sources': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    accountList: [{
      financialInstitution: "Bank's of America",
      accountType: 'Checking',
      accountNumber: '0879',
      accountBalance: '$4,000',
      downPaymentSource: true
    }, {
      financialInstitution: 'BANK OF AMERICA',
      accountType: 'Savings',
      accountNumber: '1132',
      accountBalance: '$1,000',
      downPaymentSource: false
    }, {
      financialInstitution: "Well's Fargo",
      accountType: 'Money Market',
      accountNumber: '3442',
      accountBalance: '$98,322',
      downPaymentSource: true
    }],
    propertyList: [{
      streetNumber: '1234',
      addressLineOne: 'Anywhere Street',
      downPaymentSource: false
    }, {
      streetNumber: '4321',
      addressLineOne: 'Nowhere Street',
      downPaymentSource: false
    }],
    otherDownPaymentSourcesGift: true,
    otherDownPaymentSources: true,
    otherClosingCostsSourcesGift: true,
    otherClosingCostsSources: true
  }),
  'assets-choose-onus-account': {
    type: 'assetsOnUsAccountsDTO',
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    isAuthenticated: true,
    bypassServerSideValidationFields: null,
    accountList: [{
      financialInstitution: 'Bank of America',
      accountNumber: '7878',
      accountBalance: '700000.0',
      accountType: 'Savings',
      assetsAccountSelected: true,
      merillAccountIndicator: false
    }, {
      financialInstitution: 'Merril Lync',
      accountNumber: '5232',
      accountBalance: '20000.0',
      accountType: 'Checking',
      assetsAccountSelected: false,
      merillAccountIndicator: false
    }, {
      financialInstitution: 'Bank of America',
      accountNumber: '2565',
      accountBalance: '199999.0',
      accountType: 'IRA',
      assetsAccountSelected: true,
      merillAccountIndicator: true
    }, {
      financialInstitution: 'Bank of America',
      accountNumber: '2566',
      accountBalance: '199999.0',
      accountType: 'Other',
      assetsAccountSelected: true,
      merillAccountIndicator: true
    }],
    saveAndExit: null,
    subCampPhoneNumber: '800.539.9159'
  },
  'assets-reo-additional-info': {
    additionalReoIndicator: true,
    type: 'reoAdditionalInfoDTO',
    index: null,
    selectedChapter: null,
    clickableChapters: null,
    completedChapters: null,
    streetNumber: '123',
    addressLineOne: 'Parkaire Ln',
    acquisitionDate: '07/2017',
    originalCost: '121212.0',
    propertyType: 'Farm',
    numberOfUnits: '2'
  },
  'review-your-information': {
    goToChapter: '',
    type: 'reviewAndSubmitDTO',
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    personInformationDTO: {
      borrowerCustomerInformationDTO: {
        type: 'customerInformationDTO',
        index: null,
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        name: {
          firstName: 'John',
          middleName: 'Mark',
          lastName: 'Smith',
          suffix: 'sr'
        },
        address: {
          streetNumber: '123',
          addressLineOne: 'Parkaire Ln',
          addressLineTwo: 'Apt B',
          city: 'Charlotte',
          state: 'NC',
          zipcode: '28217'
        },
        phoneNumberType: 'CellularPhone',
        phoneNumber: '456123788',
        email: 'abchj.klj@test.com',
        differentPrimaryAndMailingAddress: false,
        mailingAddress: {
          streetNumber: '246',
          addressLineOne: 'Main St',
          addressLineTwo: null,
          city: 'New York',
          state: 'NY',
          zipcode: '12345'
        },
        citizenshipStatusType: 'DualCitizenWithUS',
        residencyStatusType: 'PermanentResidentAlien',
        dob: '01/01/1990',
        ssn: '781624044',
        countryOfCitizenship: '1000009',
        countryOfResidence: '1000003',
        otherCountryOfCitizenship: null,
        highestLevelOfEducationCompleted: null,
        isMilitaryOrVeteran: true,
        currentMilitaryOrVeteran: true,
        interestedInVeteransAdministrationLoan: true,
        maritalStatus: 'Married',
        haveDependents: false,
        ageOfDependents: null,
        consentContentInfoDTO: {
          consentContentRevision: '$Rev: 12345 $',
          consentContentUUID: '23456543',
          recorded: false
        },
        countryCitizenshipDescription: null,
        countryResidenceDescription: null,
        dualCitizenshipCountryDescription: null
      },
      coBorrowerCustomerInformationDTO: {
        type: 'customerInformationDTO',
        index: null,
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        name: {
          firstName: 'Jane',
          middleName: null,
          lastName: 'Smith',
          suffix: null
        },
        address: {
          streetNumber: '123',
          addressLineOne: 'Parkaire Ln',
          addressLineTwo: null,
          city: 'Charlotte',
          state: 'NC',
          zipcode: '28217'
        },
        phoneNumberType: 'CellularPhone',
        phoneNumber: '456123787',
        email: 'test.generated.email1@test.com',
        differentPrimaryAndMailingAddress: true,
        mailingAddress: {
          streetNumber: '270',
          addressLineOne: ' Broad St.',
          addressLineTwo: null,
          city: 'New York',
          state: 'NY',
          zipcode: '12345'
        },
        citizenshipStatusType: 'USCitizen',
        residencyStatusType: 'PermanentResidentAlien',
        dob: '01/02/1980',
        ssn: '6816240434',
        countryOfCitizenship: '1000009',
        countryOfResidence: '1000003',
        otherCountryOfCitizenship: null,
        highestLevelOfEducationCompleted: null,
        isMilitaryOrVeteran: true,
        currentMilitaryOrVeteran: true,
        interestedInVeteransAdministrationLoan: true,
        maritalStatus: 'Married',
        haveDependents: false,
        ageOfDependents: null,
        consentContentInfoDTO: {
          consentContentRevision: '$Rev: 12345 $',
          consentContentUUID: '23456543',
          recorded: false
        },
        countryCitizenshipDescription: null,
        countryResidenceDescription: null,
        dualCitizenshipCountryDescription: null
      },
      livingSituationDTOList: [{
        type: 'livingSituationDTO',
        index: null,
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        monthlyRentPayment: null,
        startDateAtAddress: '092014',
        livingType: 'Own',
        address: {
          streetNumber: '123',
          addressLineOne: 'Parkaire Ln',
          addressLineTwo: null,
          city: 'Charlotte',
          state: 'NC',
          zipcode: '28217'
        }
      }, {
        type: 'livingSituationDTO',
        index: null,
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        monthlyRentPayment: '1,200',
        startDateAtAddress: '092014',
        livingType: 'Rent',
        address: {
          streetNumber: '246',
          addressLineOne: 'Main St',
          addressLineTwo: null,
          city: 'Charlotte',
          state: 'NC',
          zipcode: '28202'
        }
      }],
      coBorrowerLivingSituationDTOList: [{
        type: 'livingSituationDTO',
        index: null,
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        monthlyRentPayment: null,
        startDateAtAddress: '092014',
        livingType: 'Own',
        address: {
          streetNumber: '123',
          addressLineOne: 'Parkaire Ln',
          addressLineTwo: null,
          city: 'Charlotte',
          state: 'NC',
          zipcode: '28217'
        }
      }],
      isCoBorrowerSpouse: true,
      addressSameAsBorrower: false
    },
    propertyInformationDTO: {
      propertyInfoDTO: {
        type: 'propertyInformationDTO',
        index: null,
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        propertyAddress: {
          streetNumber: '2460',
          addressLineOne: 'Highland Blvd',
          addressLineTwo: null,
          city: 'San Diego',
          state: 'CA',
          zipcode: '29029'
        },
        plannedClosingDate: '11032017',
        includeFinanceContingencyDate: true,
        financeContingencyDate: '11012017',
        propertyUse: 'Primary',
        propertyType: 'SingleFamily'
      },
      typeOfPropertyDTO: {
        type: 'typeOfPropertyDTO',
        index: null,
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        heldOnTrustOrCorp: null,
        shortsaleOrForeclosure: null,
        underConstruction: null,
        noneOftheStmts: null,
        pud: null
      }
    },
    assetsDTO: {
      prefillConsentDTO: {
        type: 'prefillConsentDTO',
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        borrowerName: 'John',
        coBorrowerName: 'Jane',
        borrowerConsent: {
          consentContentUUID: '49c82eaa-a0a5-410d-ad4e-dfef88ad0abc',
          consentContentRevision: '1',
          recorded: true
        },
        coBorrowerConsent: {
          consentContentUUID: '0ff34a24-e730-4b57-89be-83961efe925b',
          consentContentRevision: '1',
          recorded: true
        },
        accountList: [{
          accountType: 'Savings',
          accountNumber: '7878',
          accountBalance: '100000.0',
          vestedBalance: null,
          accountOwnerShipType: 'PrimaryApplicant',
          applicationCoOwnsAccount: null,
          currentMarketValue: null,
          financialInstitution: null,
          downPaymentSource: null,
          assetsAccountSelected: true
        }, {
          accountType: 'Checking',
          accountNumber: '5232',
          accountBalance: '124456.0',
          vestedBalance: null,
          accountOwnerShipType: 'PrimaryApplicant',
          applicationCoOwnsAccount: null,
          currentMarketValue: null,
          financialInstitution: null,
          downPaymentSource: null,
          assetsAccountSelected: true
        }, {
          accountType: 'DebitCard',
          accountNumber: '2565',
          accountBalance: '199999.0',
          vestedBalance: null,
          accountOwnerShipType: 'CoApplicant',
          applicationCoOwnsAccount: null,
          currentMarketValue: null,
          financialInstitution: null,
          downPaymentSource: null,
          assetsAccountSelected: true
        }, {
          accountType: 'CertificateOfDeposit',
          accountNumber: '2565',
          accountBalance: '199999.0',
          vestedBalance: null,
          accountOwnerShipType: 'CoApplicant',
          applicationCoOwnsAccount: null,
          currentMarketValue: null,
          financialInstitution: null,
          downPaymentSource: null,
          assetsAccountSelected: true
        }]
      },
      manualAccountInfoDTO: {
        type: 'manualAccountInfoDTO',
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        accountList: [{
          accountType: 'P401K',
          accountNumber: '122332442278',
          accountBalance: '1000.0',
          vestedBalance: '200.0',
          accountOwnerShipType: 'PrimaryApplicant',
          applicationCoOwnsAccount: false,
          currentMarketValue: '1000.0',
          financialInstitution: 'Bank of America',
          downPaymentSource: null,
          assetsAccountSelected: false
        }, {
          accountType: 'Merrill',
          accountNumber: '122332442233',
          accountBalance: '1000.0',
          vestedBalance: '200.0',
          accountOwnerShipType: 'CoApplicant',
          applicationCoOwnsAccount: false,
          currentMarketValue: '1000.0',
          financialInstitution: 'Merill',
          downPaymentSource: null,
          assetsAccountSelected: false
        }, {
          accountType: 'LineOfCredit',
          accountNumber: '143332442233',
          accountBalance: '1000.0',
          vestedBalance: '200.0',
          accountOwnerShipType: 'Both',
          applicationCoOwnsAccount: true,
          currentMarketValue: null,
          financialInstitution: 'JP Morgan',
          downPaymentSource: null,
          assetsAccountSelected: false
        }],
        borrowerName: 'John',
        coBorrowerName: 'Jane'
      },
      generalInfoDTOList: [{
        type: 'generalInfoDTO',
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        streetNumber: null,
        addressLineOne: null,
        addressLineTwo: null,
        city: null,
        state: null,
        zipcode: null,
        propertyDisposition: null,
        grossRentalIncome: null,
        percentageNotRented: null,
        marketValue: null,
        costOfSale: null,
        netProceeds: null,
        proceedsNotDeposited: null,
        amountNotDeposited: null,
        whoOwnsThisProperty: null,
        borrowerFirstName: null,
        coBorrowerFirstName: null,
        propertyUse: null,
        percentageOfPropertyOwn: null,
        ownHome: null,
        propertyCoOwnedByAnyoneElse: null
      }, {
        type: 'generalInfoDTO',
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        streetNumber: null,
        addressLineOne: null,
        addressLineTwo: null,
        city: null,
        state: null,
        zipcode: null,
        propertyDisposition: null,
        grossRentalIncome: null,
        percentageNotRented: null,
        marketValue: null,
        costOfSale: null,
        netProceeds: null,
        proceedsNotDeposited: null,
        amountNotDeposited: null,
        whoOwnsThisProperty: null,
        borrowerFirstName: null,
        coBorrowerFirstName: null,
        propertyUse: null,
        percentageOfPropertyOwn: null,
        ownHome: null,
        propertyCoOwnedByAnyoneElse: null
      }, {
        type: 'generalInfoDTO',
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        streetNumber: null,
        addressLineOne: null,
        addressLineTwo: null,
        city: null,
        state: null,
        zipcode: null,
        propertyDisposition: null,
        grossRentalIncome: null,
        percentageNotRented: null,
        marketValue: null,
        costOfSale: null,
        netProceeds: null,
        proceedsNotDeposited: null,
        amountNotDeposited: null,
        whoOwnsThisProperty: null,
        borrowerFirstName: null,
        coBorrowerFirstName: null,
        propertyUse: null,
        percentageOfPropertyOwn: null,
        ownHome: null,
        propertyCoOwnedByAnyoneElse: null
      }],
      reoAdditionalInfoDTOList: [{
        type: 'reoAdditionalInfoDTO',
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        streetNumber: '101',
        addressLineOne: 'North block dr',
        acquisitionDate: '',
        originalCost: null,
        propertyType: null,
        numberOfUnits: null
      }, {
        type: 'reoAdditionalInfoDTO',
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        streetNumber: '102',
        addressLineOne: 'South block dr',
        acquisitionDate: '',
        originalCost: null,
        propertyType: null,
        numberOfUnits: null
      }, {
        type: 'reoAdditionalInfoDTO',
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        streetNumber: null,
        addressLineOne: null,
        acquisitionDate: '',
        originalCost: null,
        propertyType: null,
        numberOfUnits: null
      }],
      reoFeesDTO: [{
        type: 'reoFeesDTO',
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        streetNumber: '101',
        addressLineOne: 'North block dr',
        assetsREOFeesSelection: null,
        fixedInsuranceAmount: null,
        hazardInsuranceAmount: null,
        propertyTaxesAmount: null,
        mortgageInsuranceAmount: null,
        hOADues: null,
        additionalRealEstate: true
      }, {
        type: 'reoFeesDTO',
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        streetNumber: '102',
        addressLineOne: 'South block dr',
        assetsREOFeesSelection: null,
        fixedInsuranceAmount: null,
        hazardInsuranceAmount: null,
        propertyTaxesAmount: null,
        mortgageInsuranceAmount: null,
        hOADues: null,
        additionalRealEstate: true
      }, {
        type: 'reoFeesDTO',
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        streetNumber: null,
        addressLineOne: null,
        assetsREOFeesSelection: null,
        fixedInsuranceAmount: null,
        hazardInsuranceAmount: null,
        propertyTaxesAmount: null,
        mortgageInsuranceAmount: null,
        hOADues: null,
        additionalRealEstate: null
      }],
      downPaymentSourcesDTO: {
        type: 'downPaymentSourcesDTO',
        selectedChapter: null,
        clickableChapters: null,
        completedChapters: null,
        accountList: [{
          accountType: 'Savings',
          accountNumber: '12345677878',
          accountBalance: '100000.0',
          vestedBalance: null,
          accountOwnerShipType: null,
          applicationCoOwnsAccount: null,
          currentMarketValue: null,
          financialInstitution: 'Bank of America',
          downPaymentSource: null,
          assetsAccountSelected: false
        }, {
          accountType: 'Checking',
          accountNumber: '123454685232',
          accountBalance: '124456.0',
          vestedBalance: null,
          accountOwnerShipType: null,
          applicationCoOwnsAccount: null,
          currentMarketValue: null,
          financialInstitution: 'Bank of America',
          downPaymentSource: null,
          assetsAccountSelected: false
        }, {
          accountType: 'DebitCard',
          accountNumber: '123677132565',
          accountBalance: '199999.0',
          vestedBalance: null,
          accountOwnerShipType: null,
          applicationCoOwnsAccount: null,
          currentMarketValue: null,
          financialInstitution: 'Bank of America',
          downPaymentSource: null,
          assetsAccountSelected: false
        }, {
          accountType: 'CertificateOfDeposit',
          accountNumber: '123677132565',
          accountBalance: '199999.0',
          vestedBalance: null,
          accountOwnerShipType: null,
          applicationCoOwnsAccount: null,
          currentMarketValue: null,
          financialInstitution: 'Bank of America',
          downPaymentSource: null,
          assetsAccountSelected: false
        }, {
          accountType: 'P401K',
          accountNumber: '122332442278',
          accountBalance: '1000.0',
          vestedBalance: null,
          accountOwnerShipType: null,
          applicationCoOwnsAccount: null,
          currentMarketValue: null,
          financialInstitution: 'Bank of America',
          downPaymentSource: null,
          assetsAccountSelected: false
        }, {
          accountType: 'Merrill',
          accountNumber: '122332442233',
          accountBalance: '1000.0',
          vestedBalance: null,
          accountOwnerShipType: null,
          applicationCoOwnsAccount: null,
          currentMarketValue: null,
          financialInstitution: 'Merill',
          downPaymentSource: null,
          assetsAccountSelected: false
        }, {
          accountType: 'LineOfCredit',
          accountNumber: '143332442233',
          accountBalance: '1000.0',
          vestedBalance: null,
          accountOwnerShipType: null,
          applicationCoOwnsAccount: null,
          currentMarketValue: null,
          financialInstitution: 'JP Morgan',
          downPaymentSource: null,
          assetsAccountSelected: false
        }],
        propertyList: [],
        otherDownPaymentSources: true
      }
    },
    employmentInformationDTO: null
  },
  'credit-pull-idv-consent': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'creditPullIdvConsentDTO',
    index: null,
    borrowerConsent: {
      consentContentRevision: '1',
      recorded: true
    },
    coBorrowerConsent: {
      consentContentRevision: '1',
      recorded: false
    },
    isCoBorrowerPresent: true,
    borrowerName: 'George Washington',
    coBorrowerName: 'Anne Washington',
    subCampPhoneNumber: '800.324.4842'
  }),
  'associate-liens-to-property': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    streetNumber: '123',
    addressLineOne: 'Main St.',
    hasAnotherREO: true,
    liensList: [{
      financialInstitution: 'Chase Bank',
      accountNumber: '7789',
      accountBalance: '130000',
      associatedLienWithREO: null
    }, {
      financialInstitution: 'Well Fargo Bank',
      accountNumber: '3321',
      accountBalance: '40000',
      associatedLienWithREO: null
    }, {
      financialInstitution: 'Acme Investments',
      accountNumber: '5541',
      accountBalance: '3000',
      associatedLienWithREO: null
    }],
    propertyFreeAndClear: true,
    subCampPhoneNumber: '800.324.4842'
  }),
  'lien-position': {
    streetNumber: '1234',
    addressLineOne: 'Anywhere Street',
    hasAnotherREO: false,
    liensList: [{
      financialInstitution: 'Wells Fargo',
      accountNumber: '514541',
      accountBalance: '135513',
      lienPosition: null
    }, {
      financialInstitution: 'Chase',
      accountNumber: '123665',
      accountBalance: '25000',
      lienPosition: null
    }, {
      financialInstitution: 'Citi Bank',
      accountNumber: '7272',
      accountBalance: '5000',
      lienPosition: null
    }]
  },
  'borrower-oow-questions': {
    borrowerName: 'Jane Doe',
    oowQuestions: [{
      name: 'firstQuestion',
      label: 'First Question',
      answers: [{
        text: 'Why are we here?',
        value: 'purpose'
      }, {
        text: 'Is it 5 yet?',
        value: 'theImportantQuestions'
      }, {
        text: 'Does pizza go bad after a week?',
        value: 'theImportantQuestions'
      }]
    }, {
      name: 'secondQuestion',
      label: 'Second Question',
      answers: [{
        text: 'Why are we here?',
        value: 'purpose'
      }, {
        text: 'Is it 5 yet?',
        value: 'theImportantQuestions'
      }, {
        text: 'Does pizza go bad after a week?',
        value: 'theImportantQuestions'
      }]
    }, {
      name: 'thirdQuestion',
      label: 'Third Question',
      answers: [{
        text: 'Why are we here?',
        value: 'purpose'
      }, {
        text: 'Is it 5 yet?',
        value: 'theImportantQuestions'
      }, {
        text: 'Does pizza go bad after a week?',
        value: 'theImportantQuestions'
      }]
    }]
  },
  'borrower-declarations': {
    type: 'declarationDTO',
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    applicantName: 'Borrower',
    outstandingJudgments: null,
    bankruptcy: 'Yes',
    foreclosure: 'No',
    lawsuit: 'No',
    loanObligation: 'No',
    federalDebtFlag: 'No',
    alimonyObligation: 'No',
    ownershipInterest: 'Yes',
    ownPropertyType: 'Principal residence',
    propertyOwnershipTitle: 'Solely by yourself',
    downPaymentBorrowed: 'Yes',
    endorser: 'No'
  },
  'borrower-declarations-urla-2020': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'declarationDTO',
    applicantName: 'Borrower',
    outstandingJudgments: 'Yes',
    bankruptcy: 'Yes',
    typeOfBankruptcy: 'Chapter13',
    foreclosure: 'Yes',
    lawsuit: 'Yes',
    loanObligation: 'Yes',
    federalDebtFlag: 'Yes',
    alimonyObligation: 'Yes',
    downPaymentBorrowed: 'Yes',
    downPaymentBorrowedAmount: '10000',
    endorser: 'Yes',
    ownershipInterest: 'Yes',
    ownPropertyType: 'Primary',
    propertyOwnershipTitle: 'JointWithSpouse',
    applyingMortgageLoanOnAnotherProperty: 'Yes',
    applyingForAnyNewCredit: 'Yes',
    propertySubjectToLien: 'Yes',
    cosignerOrGuarantor: 'Yes',
    preForeclosureSaleOrShortSale: 'Yes',
    propertyForeclosed: 'Yes',
    primaryResidence: true
  }),
  'co-borrower-declarations-urla-2020': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'declarationDTO',
    applicantName: 'Co-Borrower',
    primaryResidence: true
  }),
  'co-borrower-declarations': {
    type: 'declarationDTO',
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    applicantName: 'CoBorrower',
    outstandingJudgments: 'Yes',
    bankruptcy: 'Yes',
    foreclosure: 'No',
    lawsuit: 'No',
    loanObligation: 'No',
    federalDebtFlag: 'No',
    alimonyObligation: 'No',
    ownPropertyType: 'Principal residence',
    propertyOwnershipTitle: 'Solely by yourself',
    downPaymentBorrowed: 'Yes',
    endorser: 'No',
    ownershipInterest: 'PrimaryApplicant'
  },
  'co-borrower-oow-questions': {
    borrowerName: 'John Doe',
    oowQuestions: [{
      name: 'firstQuestion',
      label: 'First Question',
      answers: [{
        text: 'Why are we here?',
        value: 'purpose'
      }, {
        text: 'Is it 5 yet?',
        value: 'theImportantQuestions'
      }, {
        text: 'Does pizza go bad after a week?',
        value: 'theImportantQuestions'
      }]
    }, {
      name: 'secondQuestion',
      label: 'Second Question',
      answers: [{
        text: 'Why are we here?',
        value: 'purpose'
      }, {
        text: 'Is it 5 yet?',
        value: 'theImportantQuestions'
      }, {
        text: 'Does pizza go bad after a week?',
        value: 'theImportantQuestions'
      }]
    }, {
      name: 'thirdQuestion',
      label: 'Third Question',
      answers: [{
        text: 'Why are we here?',
        value: 'purpose'
      }, {
        text: 'Is it 5 yet?',
        value: 'theImportantQuestions'
      }, {
        text: 'Does pizza go bad after a week?',
        value: 'theImportantQuestions'
      }]
    }]
  },
  'refinance-goals': _objectSpread(_objectSpread({
    type: 'refiGoalsDTO',
    index: null
  }, baseDTO()), {}, {
    lowerPayment: true,
    reduceMyTerm: true,
    getCashOut: true
  }),
  'ask-if-loan-on-us': _objectSpread({}, baseDTO()),
  'select-loan-term-and-points': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'loanTermAndPointsDTO',
    productDTOList: [{
      productType: '30FX',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: true,
        productShortDescription: '30yr fixed',
        productLongDescription: '30-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '7',
          apr: '5.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }, {
        type: '1',
        verticalPriority: '1',
        singlePriceOption: false,
        productShortDescription: '30yr FHA',
        productLongDescription: '30-year FHA',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1012.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '2.853',
          apr: '3.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }, {
      productType: '30FX',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: true,
        productShortDescription: '30yr fixed',
        productLongDescription: '30-year fixed',
        productBenefitStatement: 'Rate and Monthly Principal and Interest payment remain the same',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '2230.15',
          closingCosts: '14356.40',
          rate: '6.875',
          apr: '6.939',
          points: '-0.048',
          estimatedCashNeededAtClosing: '451247.4',
          downPayment: '200000',
          estimatedClosingCosts: '14356.40',
          estimatedPointsAndLenderAndThirdPartyFees: '6103.68',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8252.72',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '359',
            ratePercent: '6.875',
            paymentAmount: '1412.4'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '6.875',
            paymentAmount: '1409.16'
          }],
          estimatedPointsAndLenderFees: '531.8',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2267.5',
          initialEscrowAccountFunds: '5985.22'
        }]
      }],
      productTierDTOList: null
    }, {
      productType: '15FX',
      horizontalPriority: '2',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: false,
        productShortDescription: '15yr fixed',
        productLongDescription: '15-year fixed',
        productBenefitStatement: 'Rate and Monthly Principal and Interest payment remain the same',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 15 years of the loan.',
        productTierDTOList: [{
          monthlyPayment: '2646.59',
          closingCosts: '15431.75',
          rate: '6.125',
          apr: '6.311',
          points: '0.483',
          estimatedCashNeededAtClosing: '452322.75',
          downPayment: '200000',
          estimatedClosingCosts: '15431.75',
          estimatedPointsAndLenderAndThirdPartyFees: '7245.33',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8186.42',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '179',
            ratePercent: '6.125',
            paymentAmount: '1828.84'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '6.125',
            paymentAmount: '1829.89'
          }],
          estimatedPointsAndLenderFees: '1673.45',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2201.2',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2661.21',
          closingCosts: '14643.05',
          rate: '6.25',
          apr: '6.378',
          points: '0.111',
          estimatedCashNeededAtClosing: '451534.05',
          downPayment: '200000',
          estimatedClosingCosts: '14643.05',
          estimatedPointsAndLenderAndThirdPartyFees: '6445.53',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8197.52',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '179',
            ratePercent: '6.25',
            paymentAmount: '1843.46'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '6.25',
            paymentAmount: '1843.08'
          }],
          estimatedPointsAndLenderFees: '873.65',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2212.3',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2675.89',
          closingCosts: '14092.85',
          rate: '6.375',
          apr: '6.462',
          points: '-0.15',
          estimatedCashNeededAtClosing: '450983.85',
          downPayment: '200000',
          estimatedClosingCosts: '14092.85',
          estimatedPointsAndLenderAndThirdPartyFees: '5884.38',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8208.47',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '179',
            ratePercent: '6.375',
            paymentAmount: '1858.14'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '6.375',
            paymentAmount: '1857.63'
          }],
          estimatedPointsAndLenderFees: '312.5',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2223.25',
          initialEscrowAccountFunds: '5985.22'
        }]
      }],
      productTierDTOList: null
    }, {
      productType: '7Y',
      horizontalPriority: '3',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: false,
        productShortDescription: '7y/6m ARM',
        productLongDescription: '7-year adjustable',
        productBenefitStatement: 'Initial period has a lower fixed rate, rate can fluctuate thereafter',
        productTooltipText: 'Your interest rate will remain fixed for the initial 7-year period and then can adjust either up or down once every 6 months thereafter.',
        productTierDTOList: [{
          monthlyPayment: '2194.42',
          closingCosts: '15107.40',
          rate: '6.625',
          apr: '7.424',
          points: '0.3',
          estimatedCashNeededAtClosing: '451998.4',
          downPayment: '200000',
          estimatedClosingCosts: '15107.40',
          estimatedPointsAndLenderAndThirdPartyFees: '6876.88',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8230.52',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '5',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '11.625',
            maximumInitialRatePayment: '2028.89',
            maximumLifetimeRate: '11.625',
            maximumLifetimePayment: '2028.89'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '84',
            ratePercent: '6.625',
            paymentAmount: '1376.67'
          }, {
            totalNumberOfPayments: '275',
            ratePercent: '8.125',
            paymentAmount: '1561.41'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1562.39'
          }],
          estimatedPointsAndLenderFees: '1280',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2245.3',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2212.24',
          closingCosts: '14477.80',
          rate: '6.75',
          apr: '7.459',
          points: '0.002',
          estimatedCashNeededAtClosing: '451368.8',
          downPayment: '200000',
          estimatedClosingCosts: '14477.80',
          estimatedPointsAndLenderAndThirdPartyFees: '6236.18',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8241.62',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '5',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '11.75',
            maximumInitialRatePayment: '2050.54',
            maximumLifetimeRate: '11.75',
            maximumLifetimePayment: '2056.51'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '84',
            ratePercent: '6.75',
            paymentAmount: '1394.49'
          }, {
            totalNumberOfPayments: '275',
            ratePercent: '8.125',
            paymentAmount: '1564.58'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1567.3'
          }],
          estimatedPointsAndLenderFees: '639.3',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2256.4',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2230.15',
          closingCosts: '13704.15',
          rate: '6.875',
          apr: '7.489',
          points: '-0.363',
          estimatedCashNeededAtClosing: '450595.15',
          downPayment: '200000',
          estimatedClosingCosts: '13704.15',
          estimatedPointsAndLenderAndThirdPartyFees: '5451.43',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8252.72',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '5',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '11.875',
            maximumInitialRatePayment: '2072.26',
            maximumLifetimeRate: '11.875',
            maximumLifetimePayment: '2074.23'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '84',
            ratePercent: '6.875',
            paymentAmount: '1412.4'
          }, {
            totalNumberOfPayments: '275',
            ratePercent: '8.125',
            paymentAmount: '1567.71'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1567.83'
          }],
          estimatedPointsAndLenderFees: '-145.45',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2267.5',
          initialEscrowAccountFunds: '5985.22'
        }]
      }],
      productTierDTOList: null
    }, {
      productType: '10Y',
      horizontalPriority: '4',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: false,
        productShortDescription: '10y/6m ARM',
        productLongDescription: '10-year adjustable',
        productBenefitStatement: 'Initial period has a lower fixed rate, rate can fluctuate thereafter',
        productTooltipText: 'Your interest rate will remain fixed for the initial 10-year period and then can adjust either up or down once every 6 months thereafter.',
        productTierDTOList: [{
          monthlyPayment: '2194.42',
          closingCosts: '15146.10',
          rate: '6.625',
          apr: '7.213',
          points: '0.318',
          estimatedCashNeededAtClosing: '452037.1',
          downPayment: '200000',
          estimatedClosingCosts: '15146.10',
          estimatedPointsAndLenderAndThirdPartyFees: '6915.58',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8230.52',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '5',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '11.625',
            maximumInitialRatePayment: '1965.59',
            maximumLifetimeRate: '11.625',
            maximumLifetimePayment: '1967.57'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '120',
            ratePercent: '6.625',
            paymentAmount: '1376.67'
          }, {
            totalNumberOfPayments: '239',
            ratePercent: '8.125',
            paymentAmount: '1543.57'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1543.81'
          }],
          estimatedPointsAndLenderFees: '1318.7',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2245.3',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2212.24',
          closingCosts: '14368.15',
          rate: '6.75',
          apr: '7.260',
          points: '-0.049',
          estimatedCashNeededAtClosing: '451259.15',
          downPayment: '200000',
          estimatedClosingCosts: '14368.15',
          estimatedPointsAndLenderAndThirdPartyFees: '6126.53',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8241.62',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '5',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '11.75',
            maximumInitialRatePayment: '1987.48',
            maximumLifetimeRate: '11.75',
            maximumLifetimePayment: '1987.54'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '120',
            ratePercent: '6.75',
            paymentAmount: '1394.49'
          }, {
            totalNumberOfPayments: '239',
            ratePercent: '8.125',
            paymentAmount: '1548.3'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1548.04'
          }],
          estimatedPointsAndLenderFees: '529.65',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2256.4',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2230.15',
          closingCosts: '13592.35',
          rate: '6.875',
          apr: '7.307',
          points: '-0.415',
          estimatedCashNeededAtClosing: '450483.35',
          downPayment: '200000',
          estimatedClosingCosts: '13592.35',
          estimatedPointsAndLenderAndThirdPartyFees: '5339.63',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8252.72',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '5',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '11.875',
            maximumInitialRatePayment: '2009.44',
            maximumLifetimeRate: '11.875',
            maximumLifetimePayment: '2010.73'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '120',
            ratePercent: '6.875',
            paymentAmount: '1412.4'
          }, {
            totalNumberOfPayments: '239',
            ratePercent: '8.125',
            paymentAmount: '1552.97'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1554.7'
          }],
          estimatedPointsAndLenderFees: '-257.25',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2267.5',
          initialEscrowAccountFunds: '5985.22'
        }]
      }],
      productTierDTOList: null
    }, {
      productType: '5Y',
      horizontalPriority: '5',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: false,
        productShortDescription: '5y/6m ARM',
        productLongDescription: '5-year adjustable',
        productBenefitStatement: 'Initial period has a lower fixed rate, rate can fluctuate thereafter',
        productTooltipText: 'Your interest rate will remain fixed for the initial 5-year period and then can adjust either up or down once every 6 months thereafter.',
        productTierDTOList: [{
          monthlyPayment: '2248.15',
          closingCosts: '14777.20',
          rate: '7',
          apr: '7.738',
          points: '0.131',
          estimatedCashNeededAtClosing: '451668.2',
          downPayment: '200000',
          estimatedClosingCosts: '14777.20',
          estimatedPointsAndLenderAndThirdPartyFees: '6513.53',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8263.67',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '2',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '9',
            maximumInitialRatePayment: '1698.39',
            maximumLifetimeRate: '12',
            maximumLifetimePayment: '2128.16'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '60',
            ratePercent: '7',
            paymentAmount: '1430.4'
          }, {
            totalNumberOfPayments: '299',
            ratePercent: '8.125',
            paymentAmount: '1578.82'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1578.95'
          }],
          estimatedPointsAndLenderFees: '916.65',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2278.45',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2266.24',
          closingCosts: '14306.70',
          rate: '7.125',
          apr: '7.767',
          points: '-0.093',
          estimatedCashNeededAtClosing: '451197.7',
          downPayment: '200000',
          estimatedClosingCosts: '14306.70',
          estimatedPointsAndLenderAndThirdPartyFees: '6031.93',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8274.77',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '2',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '9.125',
            maximumInitialRatePayment: '1718.02',
            maximumLifetimeRate: '12.125',
            maximumLifetimePayment: '2144.15'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '60',
            ratePercent: '7.125',
            paymentAmount: '1448.49'
          }, {
            totalNumberOfPayments: '299',
            ratePercent: '8.125',
            paymentAmount: '1580.91'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1584'
          }],
          estimatedPointsAndLenderFees: '435.05',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2289.55',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2284.43',
          closingCosts: '13743.75',
          rate: '7.25',
          apr: '7.791',
          points: '-0.36',
          estimatedCashNeededAtClosing: '450634.75',
          downPayment: '200000',
          estimatedClosingCosts: '13743.75',
          estimatedPointsAndLenderAndThirdPartyFees: '5457.88',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8285.87',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: {
            subseqRateResetMonths: '6',
            indexRatePercent: '5.33',
            marginPercent: '2.75',
            initialAdjustableCapitalPercent: '2',
            subseqAdjCapPercent: '1',
            lifeCapPercent: '5',
            maximumInitialRate: '9.25',
            maximumInitialRatePayment: '1737.72',
            maximumLifetimeRate: '12.25',
            maximumLifetimePayment: '2169.07'
          },
          paymentSchedules: [{
            totalNumberOfPayments: '60',
            ratePercent: '7.25',
            paymentAmount: '1466.68'
          }, {
            totalNumberOfPayments: '299',
            ratePercent: '8.125',
            paymentAmount: '1582.97'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '8.125',
            paymentAmount: '1578.51'
          }],
          estimatedPointsAndLenderFees: '-139',
          thirdPartyFees: '5596.88',
          prepaidInterestTaxesAndInsurance: '2300.65',
          initialEscrowAccountFunds: '5985.22'
        }]
      }],
      productTierDTOList: null
    }, {
      productType: '20FX',
      horizontalPriority: '6',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: false,
        productShortDescription: '20yr fixed',
        productLongDescription: '20-year fixed',
        productBenefitStatement: 'Rate and Monthly Principal and Interest payment remain the same',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 20 years of the loan.',
        productTierDTOList: [{
          monthlyPayment: '2452.53',
          closingCosts: '15291.30',
          rate: '6.75',
          apr: '6.890',
          points: '0.392',
          estimatedCashNeededAtClosing: '452182.3',
          downPayment: '200000',
          estimatedClosingCosts: '15291.30',
          estimatedPointsAndLenderAndThirdPartyFees: '7049.68',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8241.62',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '239',
            ratePercent: '6.75',
            paymentAmount: '1634.78'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '6.75',
            paymentAmount: '1636.07'
          }],
          estimatedPointsAndLenderFees: '1477.8',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2256.4',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2468.55',
          closingCosts: '13821.05',
          rate: '6.875',
          apr: '6.927',
          points: '-0.297',
          estimatedCashNeededAtClosing: '450712.05',
          downPayment: '200000',
          estimatedClosingCosts: '13821.05',
          estimatedPointsAndLenderAndThirdPartyFees: '5568.33',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8252.72',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '239',
            ratePercent: '6.875',
            paymentAmount: '1650.8'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '6.875',
            paymentAmount: '1650.37'
          }],
          estimatedPointsAndLenderFees: '-3.55',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2267.5',
          initialEscrowAccountFunds: '5985.22'
        }, {
          monthlyPayment: '2484.64',
          closingCosts: '12582.85',
          rate: '7',
          apr: '6.977',
          points: '-0.878',
          estimatedCashNeededAtClosing: '449473.85',
          downPayment: '200000',
          estimatedClosingCosts: '12582.85',
          estimatedPointsAndLenderAndThirdPartyFees: '4319.18',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '8263.67',
          discountPoints: null,
          principalAndInterest: null,
          taxes: null,
          estimatedHomeOwnersInsurance: null,
          privateMortgageInsurance: null,
          rateLocked: null,
          rateLockPeriodDays: 45,
          armDetailsDTO: null,
          paymentSchedules: [{
            totalNumberOfPayments: '239',
            ratePercent: '7',
            paymentAmount: '1666.89'
          }, {
            totalNumberOfPayments: '1',
            ratePercent: '7',
            paymentAmount: '1668.24'
          }],
          estimatedPointsAndLenderFees: '-1252.7',
          thirdPartyFees: '5571.88',
          prepaidInterestTaxesAndInsurance: '2278.45',
          initialEscrowAccountFunds: '5985.22'
        }]
      }],
      productTierDTOList: null
    }],
    displayProducts: true,
    horizontalTabs: ['Modification', '30FX', '15FX', '7Y', '10Y', '5Y', '20FX'],
    zipCode: '77459',
    selectedProduct: '30FX',
    selectedTier: '-0.048',
    selectedTierVerticalPriority: null,
    borrowerFirstName: 'John',
    coBorrowerFirstName: null,
    borrowerPreferedRewardTier: 'PlatinumHonors',
    coBorrowerPreferedRewardTier: null,
    loanAmount: '215000.0',
    rateLockPeriod: 45,
    downPaymentPercent: '48',
    purchaseprice: '415000',
    refinanceGoal: 'GetCashOut',
    // other options are: LowerMyPayment or GetCashOut
    cashOutAmount: '15000',
    rateMod: {
      loanAcctNumber: '280007113',
      loan: {
        borrowers: {
          borrower: [{
            partyID: '10050184808',
            name: {
              prefix: null,
              firstName: 'STEPHEN',
              middleName: null,
              lastName: 'SITTETE',
              suffix: null
            }
          }]
        },
        property: {
          propertyUsageType: 'PrimaryResidence',
          address: {
            streetAddress: '4421 NEWCASTLE CV',
            city: 'BRUNSWICK',
            state: 'OH',
            postalCode: '4421'
          }
        }
      },
      eligibility: {
        eligibile: true,
        status: 'OFFERED',
        statusDateTime: 1664301044869,
        validations: null
      },
      rateModification: {
        loanBalanceAmount: 93694.61,
        rateDateTime: 1664147186000,
        rateExpirationDateTime: 1664175600000,
        presentDetail: {
          rateDetail: {
            ruleId: null,
            description: 'Rate',
            code: null,
            ratePercent: 8,
            marginPercent: 0,
            pointsPercent: 0
          },
          housingExpense: {
            type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
            description: 'Monthly Principal And Interest Payment',
            amount: 812.67
          }
        },
        proposedDetail: {
          rateDetail: {
            ruleId: null,
            description: 'Rate',
            code: null,
            ratePercent: 4.625,
            marginPercent: 0,
            pointsPercent: 0
          },
          housingExpense: {
            type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
            description: 'Monthly Principal And Interest Payment',
            amount: 706.61
          }
        },
        savingsDetail: {
          rateDetail: {
            ruleId: null,
            description: 'Rate',
            code: null,
            ratePercent: 3.375,
            marginPercent: 0,
            pointsPercent: 0
          },
          housingExpense: {
            type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
            description: 'Monthly Principal And Interest Payment',
            amount: 106.06
          }
        },
        fees: {
          loanFee: [{
            categoryType: 'LENDER',
            categorySubType: 'NONE',
            description: 'One-time fee',
            quotedFeeAmount: 0,
            policyFeeAmount: 0,
            borrowerPaidAmount: 950.00,
            lenderPaidAmount: 0,
            thirdPartyPaidAmount: 0,
            sellerPaidAmount: 0,
            hudline: null
          }]
        }
      },
      loanDetailsAccepted: null,
      rateModOfferAccepted: false,
      confirmLoanDetailsAccepted: null,
      rateModDetailsSubmit: null,
      processingStatus: null
    }
  }),
  'dmpa-select-loan-term-and-points': {
    type: 'loanTermAndPointsDTO',
    horizontalTabs: ['30FX'],
    refinanceGoal: 'GetCashOut',
    // other options are: LowerMyPayment or GetCashOut
    productDTOList: [{
      productType: '30FX',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: true,
        productShortDescription: '30yr fixed',
        productLongDescription: '30-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }, {
        type: '1',
        verticalPriority: '1',
        singlePriceOption: false,
        productShortDescription: '30yr FHA',
        productLongDescription: '30-year FHA',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1012.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }, {
      productType: '15FX',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: 'False',
        productShortDescription: '30yr fixed',
        productLongDescription: '30-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }],
    displayProducts: true,
    mloInformation: {
      firstName: 'Deborah',
      lastName: 'Smith',
      nmlsid: '12345678',
      email: 'deborah@gmail.com',
      phoneNumber: '8007001234',
      phoneExt: '246',
      photoURL: 'https://mortgage.bankofamerica.com/deborahssmith/photo',
      isGetACallBackEnabled: true
    },
    selectedProduct: '30FX',
    selectedTier: '0.527',
    selectedTierVerticalPriority: 0,
    subCampPhoneNumber: '800.324.4842',
    messageCodes: ['H026', 'H048', 'H011'],
    borrowerPreferedRewardTier: 'Diamond',
    coBorrowerPreferedRewardTier: 'DiamondHonors',
    borrowerFirstName: 'Jake',
    coBorrowerFirstName: 'Jane',
    cashOutAmount: '8652',
    associate: true
  },
  'confirm-loan-details': {
    type: 'confirmLoanDetailsDTO',
    productDTOList: [],
    mloInformation: [],
    firstname: 'Geortonge',
    loanDetails: {
      loanAccount: 500100204,
      firstname: 'George',
      lastname: 'Washington',
      street: 'Charlotte',
      state: 'North Carolina',
      zip: 28255
    }
  },
  'rate-mod-validate': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'RateModQuoteDTO',
    primaryApplicantPhone: '456123788',
    loanAcctNumber: '280007113',
    loan: {
      borrowers: {
        borrower: [{
          partyID: '10050184808',
          name: {
            prefix: 'MR.',
            firstName: 'STEPHEN',
            middleName: null,
            lastName: 'SITTETE',
            suffix: null
          }
        }, {
          partyID: '20248923489',
          name: {
            prefix: null,
            firstName: 'STEVE',
            middleName: null,
            lastName: 'STILL',
            suffix: null
          }
        }]
      },
      property: {
        propertyUsageType: 'PrimaryResidence',
        address: {
          streetAddress: '4421 NEWCASTLE CV',
          city: 'BRUNSWICK',
          state: 'OH',
          postalCode: '44212'
        }
      }
    },
    eligibility: {
      eligibile: true,
      status: 'OFFERED',
      statusDateTime: 1664301044869,
      validations: null
    },
    rateModification: {
      loanBalanceAmount: 93694.61,
      rateDateTime: 1664147186000,
      rateExpirationDateTime: 1664175600000,
      presentDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 8,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 812.67
        }
      },
      proposedDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 4.625,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 706.61
        }
      },
      savingsDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 3.375,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 106.06
        }
      },
      fees: {
        loanFee: [{
          categoryType: 'LENDER',
          categorySubType: 'NONE',
          description: 'One-time fee',
          quotedFeeAmount: 0,
          policyFeeAmount: 0,
          borrowerPaidAmount: 950.00,
          lenderPaidAmount: 0,
          thirdPartyPaidAmount: 0,
          sellerPaidAmount: 0,
          hudline: null
        }]
      }
    },
    loanDetailsAccepted: false,
    rateModOfferAccepted: null,
    confirmLoanDetailsAccepted: null,
    rateModDetailsSubmit: null
  }),
  'rate-mod-conversion-chap-1': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'rateModQuoteDTO',
    applicationId: 'DMA1234',
    primaryApplicantPhone: '456123788',
    returnStep: null,
    flowSelection: null,
    loanAcctNumber: '280007113',
    loan: {
      borrowers: {
        borrower: [{
          partyID: '10050184808',
          name: {
            prefix: null,
            firstName: 'STEPHEN',
            middleName: null,
            lastName: 'SITTETE',
            suffix: null
          }
        }]
      },
      property: {
        propertyUsageType: 'PrimaryResidence',
        address: {
          streetAddress: '4421 NEWCASTLE CV',
          city: 'BRUNSWICK',
          state: 'OH',
          postalCode: '44212'
        }
      }
    },
    eligibility: {
      eligibile: true,
      status: 'OFFERED',
      statusDateTime: 1664301044869,
      validations: null
    },
    rateModification: {
      loanBalanceAmount: 93694.61,
      rateDateTime: 1664147186000,
      rateExpirationDateTime: 1664175600000,
      presentDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 8,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 812.67
        }
      },
      proposedDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 4.625,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 706.61
        }
      },
      savingsDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 3.375,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 106.06
        }
      },
      fees: {
        loanFee: [{
          categoryType: 'LENDER',
          categorySubType: 'NONE',
          description: 'One-time fee',
          quotedFeeAmount: 0,
          policyFeeAmount: 0,
          borrowerPaidAmount: 950.00,
          lenderPaidAmount: 0,
          thirdPartyPaidAmount: 0,
          sellerPaidAmount: 0,
          hudline: null
        }]
      }
    },
    loanDetailsAccepted: null,
    rateModOfferAccepted: null,
    rateModDetailsSubmit: null,
    rateModInProgressAccepted: null,
    processingStatus: 'SUCCESS'
  }),
  'rate-mod-conversion-chap-7': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'rateModQuoteDTO',
    applicationId: 'DMA1234',
    primaryApplicantPhone: '456123788',
    returnStep: null,
    flowSelection: null,
    productUniqueIdentifier: null,
    loanAcctNumber: '280007113',
    loan: {
      borrowers: {
        borrower: [{
          partyID: '10050184808',
          name: {
            prefix: null,
            firstName: 'STEPHEN',
            middleName: null,
            lastName: 'SITTETE',
            suffix: null
          }
        }]
      },
      property: {
        propertyUsageType: 'PrimaryResidence',
        address: {
          streetAddress: '4421 NEWCASTLE CV',
          city: 'BRUNSWICK',
          state: 'OH',
          postalCode: '44212'
        }
      }
    },
    eligibility: {
      eligibile: true,
      status: 'OFFERED',
      statusDateTime: 1664301044869,
      validations: null
    },
    rateModification: {
      loanBalanceAmount: 93694.61,
      rateDateTime: 1664147186000,
      rateExpirationDateTime: 1664175600000,
      presentDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 8,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 812.67
        }
      },
      proposedDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 4.625,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 706.61
        }
      },
      savingsDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 3.375,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 106.06
        }
      },
      fees: {
        loanFee: [{
          categoryType: 'LENDER',
          categorySubType: 'NONE',
          description: 'One-time fee',
          quotedFeeAmount: 0,
          policyFeeAmount: 0,
          borrowerPaidAmount: 950.00,
          lenderPaidAmount: 0,
          thirdPartyPaidAmount: 0,
          sellerPaidAmount: 0,
          hudline: null
        }]
      }
    },
    loanDetailsAccepted: null,
    rateModOfferAccepted: null,
    rateModDetailsSubmit: null,
    rateModInProgressAccepted: null,
    processingStatus: 'SUCCESS'
  }),
  'rate-mod-confirmation': {
    type: 'rateModConfirmationDTO',
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    isAuthenticated: true,
    subCampPhoneNumber: '800.539.9159',
    bypassServerSideValidationFields: null,
    applicationId: 'DMA1234',
    savedApplicationId: null,
    messageCodes: null,
    mortgagePrequalifyQueryString: null,
    mortgagePrequalifyURL: null,
    mloInformation: {
      entityID: 'a8aa2754-cfae-469d-beeb-002015575055',
      isDirty: false,
      firstName: 'Deborah',
      lastName: 'Smith',
      email: 'deborah.s.smith@bankofamerica.com',
      mloaddress: {
        entityID: 'fd3b7ec2-2188-45bb-957d-eda51f2926c5',
        isDirty: true,
        priorityLevel: 0,
        addressLine: ['119 Cross Center Drive', 'Suite A'],
        city: 'Denver',
        county: null,
        countyGroupCode: null,
        countyGroupName: null,
        countyCode: null,
        countryCode: null,
        countryCodeEnt: null,
        postalCode: '28037',
        state: 'NC',
        stateCode: null,
        type: null,
        sameAddressBoolean: null,
        samePrimaryAndMailingAddress: false,
        usage: null,
        numberOfMonthsAtAddress: null,
        numberOfYearsAtAddress: null,
        startDateAtaddress: null,
        endDateAtAddress: null,
        streetAddress: null,
        preferredContactMethod: false,
        currentDate: 1527190555584
      },
      affiliateCD: '020005NBKFN6E000000000',
      bcZIP: '28037',
      caiID: '84PZ6',
      nbId: 'NBKFN6E',
      nmlsid: '505114',
      phoneExt: '123456',
      phoneNumber: '7046024153',
      photoURL: 'https://mortgage.bankofamerica.com/deborahssmith/photo',
      title: 'Financial Center Lending Officer',
      webSite: 'https://mortgage.bankofamerica.com/deborahssmith',
      bbaURL: 'https://secure.bankofamerica.com/mycommunications/public/appointments/getTopics.go?marketingCode=MLOWEB_ECBBA_A5000_A5200&apptType=IP&zip=28037&caid=84PZ6',
      isGetACallBackEnabled: true,
      isBBAEnabled: true,
      mloisPresent: true,
      workWithAssociates: true,
      isActive: true,
      currentDate: 1527190555584
    },
    primaryApplicantPhone: '456123788',
    returnStep: null,
    flowSelection: null,
    productUniqueIdentifier: null,
    isTestLoan: true,
    loanAcctNumber: '280007113',
    loan: {
      borrowers: {
        borrower: [{
          partyID: '10050184808',
          name: {
            prefix: null,
            firstName: 'STEPHEN',
            middleName: null,
            lastName: 'SITTETE',
            suffix: null
          }
        }]
      },
      property: {
        propertyUsageType: 'PrimaryResidence',
        address: {
          streetAddress: '4421 NEWCASTLE CV',
          city: 'BRUNSWICK',
          state: 'OH',
          postalCode: '44212'
        }
      }
    },
    eligibility: {
      eligibile: true,
      status: 'OFFERED',
      statusDateTime: 1664301044869,
      validations: null
    },
    rateModification: {
      loanBalanceAmount: 93694.61,
      loanRemainingTermMonths: 12,
      rateDateTime: 1664147186000,
      rateExpirationDateTime: 1664175600000,
      presentDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 8,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 812.67
        }
      },
      proposedDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 4.625,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 706.61
        }
      },
      savingsDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 3.375,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 106.06
        }
      },
      fees: {
        loanFee: [{
          categoryType: 'LENDER',
          categorySubType: 'NONE',
          description: 'One-time fee',
          quotedFeeAmount: 0,
          policyFeeAmount: 0,
          borrowerPaidAmount: 950.00,
          lenderPaidAmount: 0,
          thirdPartyPaidAmount: 0,
          sellerPaidAmount: 0,
          hudline: null
        }]
      }
    },
    loanDetailsAccepted: null,
    rateModOfferAccepted: null,
    rateModDetailsSubmit: null,
    rateModInProgressAccepted: null,
    processingStatus: 'SUCCESS',
    saveAndExit: null,
    associate: true
  },
  'rate-mod-confirmation-chap-7': {
    type: 'rateModConfirmationDTO',
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    isAuthenticated: true,
    subCampPhoneNumber: '800.539.9159',
    bypassServerSideValidationFields: null,
    applicationId: 'DMA1234',
    savedApplicationId: null,
    messageCodes: null,
    mortgagePrequalifyQueryString: null,
    mortgagePrequalifyURL: null,
    mloInformation: {
      entityID: 'a8aa2754-cfae-469d-beeb-002015575055',
      isDirty: false,
      firstName: 'Deborah',
      lastName: 'Smith',
      email: 'deborah.s.smith@bankofamerica.com',
      mloaddress: {
        entityID: 'fd3b7ec2-2188-45bb-957d-eda51f2926c5',
        isDirty: true,
        priorityLevel: 0,
        addressLine: ['119 Cross Center Drive', 'Suite A'],
        city: 'Denver',
        county: null,
        countyGroupCode: null,
        countyGroupName: null,
        countyCode: null,
        countryCode: null,
        countryCodeEnt: null,
        postalCode: '28037',
        state: 'NC',
        stateCode: null,
        type: null,
        sameAddressBoolean: null,
        samePrimaryAndMailingAddress: false,
        usage: null,
        numberOfMonthsAtAddress: null,
        numberOfYearsAtAddress: null,
        startDateAtaddress: null,
        endDateAtAddress: null,
        streetAddress: null,
        preferredContactMethod: false,
        currentDate: 1527190555584
      },
      affiliateCD: '020005NBKFN6E000000000',
      bcZIP: '28037',
      caiID: '84PZ6',
      nbId: 'NBKFN6E',
      nmlsid: '505114',
      phoneExt: '123456',
      phoneNumber: '7046024153',
      photoURL: 'https://mortgage.bankofamerica.com/deborahssmith/photo',
      title: 'Financial Center Lending Officer',
      webSite: 'https://mortgage.bankofamerica.com/deborahssmith',
      bbaURL: 'https://secure.bankofamerica.com/mycommunications/public/appointments/getTopics.go?marketingCode=MLOWEB_ECBBA_A5000_A5200&apptType=IP&zip=28037&caid=84PZ6',
      isGetACallBackEnabled: true,
      isBBAEnabled: true,
      mloisPresent: true,
      workWithAssociates: true,
      isActive: true,
      currentDate: 1527190555584
    },
    primaryApplicantPhone: '456123788',
    returnStep: null,
    flowSelection: null,
    productUniqueIdentifier: null,
    isTestLoan: true,
    loanAcctNumber: '280007113',
    loan: {
      borrowers: {
        borrower: [{
          partyID: '10050184808',
          name: {
            prefix: null,
            firstName: 'STEPHEN',
            middleName: null,
            lastName: 'SITTETE',
            suffix: null
          }
        }]
      },
      property: {
        propertyUsageType: 'PrimaryResidence',
        address: {
          streetAddress: '4421 NEWCASTLE CV',
          city: 'BRUNSWICK',
          state: 'OH',
          postalCode: '44212'
        }
      }
    },
    eligibility: {
      eligibile: true,
      status: 'OFFERED',
      statusDateTime: 1664301044869,
      validations: null
    },
    rateModification: {
      loanBalanceAmount: 93694.61,
      rateDateTime: 1664147186000,
      rateExpirationDateTime: 1664175600000,
      presentDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 8,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 812.67
        }
      },
      proposedDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 4.625,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 706.61
        }
      },
      savingsDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 3.375,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 106.06
        }
      },
      fees: {
        loanFee: [{
          categoryType: 'LENDER',
          categorySubType: 'NONE',
          description: 'One-time fee',
          quotedFeeAmount: 0,
          policyFeeAmount: 0,
          borrowerPaidAmount: 950.00,
          lenderPaidAmount: 0,
          thirdPartyPaidAmount: 0,
          sellerPaidAmount: 0,
          hudline: null
        }]
      }
    },
    loanDetailsAccepted: null,
    rateModOfferAccepted: null,
    rateModDetailsSubmit: null,
    rateModInProgressAccepted: null,
    processingStatus: 'SUCCESS',
    saveAndExit: null,
    associate: true
  },
  'rate-mod-in-progress': {
    type: 'rateModInProgressDTO',
    productDTOList: [],
    mloInformation: []
  },
  'continue-rate-mod-in-progress': {
    type: 'continueRateModInProgressDTO',
    productDTOList: [],
    mloInformation: []
  },
  'rate-mod-offer-chap-1': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'RateModQuoteDTO',
    applicationId: 'DMA1234',
    loanAcctNumber: '280007113',
    eligibility: {
      eligibile: true,
      status: 'OFFERED',
      statusDateTime: 1664301044869,
      validations: null
    },
    rateModification: {
      loanBalanceAmount: 93694.61,
      rateDateTime: 1664147186000,
      rateExpirationDateTime: 1664175600000,
      presentDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 8,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 812.67
        }
      },
      proposedDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 4.625,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 706.61
        }
      },
      savingsDetail: {
        rateDetail: {
          ruleId: null,
          description: 'Rate',
          code: null,
          ratePercent: 3.375,
          marginPercent: 0,
          pointsPercent: 0
        },
        housingExpense: {
          type: 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
          description: 'Monthly Principal And Interest Payment',
          amount: 106.06
        }
      },
      fees: {
        loanFee: [{
          categoryType: 'LENDER',
          categorySubType: 'NONE',
          description: 'One-time fee',
          quotedFeeAmount: 0,
          policyFeeAmount: 0,
          borrowerPaidAmount: 950.00,
          lenderPaidAmount: 0,
          thirdPartyPaidAmount: 0,
          sellerPaidAmount: 0,
          hudline: null
        }]
      }
    },
    loanDetailsAccepted: false,
    rateModOfferAccepted: null,
    confirmLoanDetailsAccepted: null,
    rateModDetailsSubmit: null
  }),
  'rate-mod-waiting-chap-1': {
    type: 'waitingScreenDTO',
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    isAuthenticated: true,
    subCampPhoneNumber: '800.539.9159',
    bypassServerSideValidationFields: null,
    applicationId: 'DMA1234',
    savedApplicationId: null,
    messageCodes: null,
    mortgagePrequalifyQueryString: null,
    mortgagePrequalifyURL: null,
    mloInformation: {
      firstName: null,
      lastName: null,
      email: null,
      mloAddress: null,
      affiliateCD: null,
      bcZIP: null,
      caiID: null,
      nbId: null,
      nmlsid: null,
      phoneExt: null,
      phoneNumber: null,
      photoURL: null,
      title: null,
      webSite: null,
      bbaURL: null,
      workWithAssociates: null,
      isActive: null,
      isGetACallBackEnabled: false,
      isBBAEnabled: false,
      personNumber: null,
      workStatus: null,
      corpTitle: null,
      wMLO: null
    },
    primaryApplicantPhone: '456123788',
    returnStep: null,
    flowSelection: null,
    productUniqueIdentifier: null,
    isTestLoan: true,
    processingDone: false,
    saveAndExit: null,
    associate: true
  },
  'rate-mod-waiting-chap-7': {
    type: 'rateModWaitingDTO',
    productDTOList: [],
    mloInformation: []
  },
  'rate-lock': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    rateLockPeriod: 60
  }),
  'loan-summary': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'loanSummaryDTO',
    refinanceGoal: 'GetCashOut',
    // other options are: PayOffMyLoanFaster or GetCashOut
    cashOutAmount: '8652',
    productDTO: {
      productType: '30FX',
      productShortDescription: '30yr fixed',
      productTierDTOList: [{
        monthlyPayment: '2011.05',
        closingCosts: '4001',
        rate: '3.851',
        apr: '4.031',
        points: '-0.527',
        estimatedCashNeededAtClosing: '17201',
        downPayment: '20001',
        estimatedClosingCosts: '7201',
        estimatedPointsAndLenderAndThirdPartyFees: '5001',
        estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '2001',
        estimatedEscrowAccountFund: '201',
        discountPoints: '0.327',
        principalAndInterest: '200000.00',
        taxes: '1000.00',
        estimatedHomeOwnersInsurance: '100.00',
        privateMortgageInsurance: '100.00',
        rateLocked: false
      }]
    },
    productLongDescription: '15-year fixed',
    productShortDescription: '15yr fixed',
    productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 15 years of the loan.'
  }),
  'dmpa-loan-summary': {
    type: 'loanSummaryDTO',
    refinanceGoal: 'GetCashOut',
    // other options are: PayOffMyLoanFaster or GetCashOut
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    isAuthenticated: false,
    cashOutAmount: '8652',
    productDTO: {
      productType: '30FX',
      productShortDescription: '30yr fixed',
      productTierDTOList: [{
        monthlyPayment: '2011.05',
        closingCosts: '4001',
        rate: '3.851',
        apr: '4.031',
        points: '-0.527',
        estimatedCashNeededAtClosing: '17201',
        downPayment: '20001',
        estimatedClosingCosts: '7201',
        estimatedPointsAndLenderAndThirdPartyFees: '5001',
        estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '2001',
        estimatedEscrowAccountFund: '201',
        discountPoints: '0.327',
        principalAndInterest: '200000.00',
        taxes: '1000.00',
        estimatedHomeOwnersInsurance: '100.00',
        privateMortgageInsurance: '100.00',
        rateLocked: false
      }]
    },
    productLongDescription: '15-year fixed',
    productShortDescription: '15yr fixed',
    productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 15 years of the loan.'
  },
  approved: _objectSpread(_objectSpread({}, baseDTO()), {}, {
    isEditable: true,
    prequalSavedApplicationId: '23454',
    savedApplicationId: '23455',
    applicationId: 'DMA109780',
    loanAmount: '160000.00',
    loanNumber: '123456',
    productType: '30FX',
    apr: '3.375',
    rate: '3.851',
    rateLocked: boolDefault('rateLock', true),
    points: '0.002',
    loanTimeFrame: '45 days',
    firstName: 'Norma',
    lastName: 'Borders',
    nmlsid: '1196115',
    email: 'norma.borders@bankofamerica.com',
    loanOfficerWorkPhoneExtn: '302',
    phoneNumber: '704.616.5344',
    website: 'https://mortgage.bankofamerica.com/normaborders',
    primaryApplicantPhone: '7045529523',
    subjectPropertyInfo: {
      mpqPropertyType: 'SingleFamily',
      propertyPurpose: 'Primary',
      propertyAddress: {
        city: 'Charlotte',
        state: 'NC'
      }
    },
    city: 'Charlotte',
    state: 'NC',
    mortgagePrequalifyQueryString: null,
    mortgagePrequalifyURL: null,
    productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
    productLongDescription: '15-year fixed ',
    productShortDescription: '15yr fixed',
    productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 15 years of the loan.'
  }),
  'dmpa-approved': {
    messageCodes: [''],
    applicationId: 'DMA109780',
    loanAmount: '160000.00',
    loanNumber: '123456',
    productType: '30FX',
    apr: '4.035',
    rate: '4.375',
    rateLocked: true,
    points: '0.002',
    loanTimeFrame: '45 days',
    firstName: 'Norma',
    lastName: 'Borders',
    nmlsid: '1196115',
    email: 'norma.borders@bankofamerica.com',
    loanOfficerWorkPhoneExtn: '302',
    phoneNumber: '704.616.5344',
    website: 'https://mortgage.bankofamerica.com/normaborders',
    primaryApplicantPhone: '7045529523',
    subjectPropertyInfo: {
      mpqPropertyType: 'SingleFamily',
      propertyPurpose: 'Primary',
      propertyAddress: {
        city: 'Charlotte',
        state: 'NC'
      }
    },
    mloInformation: {
      entityID: 'a8aa2754-cfae-469d-beeb-002015575055',
      isDirty: false,
      firstName: 'Norma',
      lastName: 'Borders',
      email: 'norma.borders@bankofamerica.com',
      mloaddress: {
        entityID: 'fd3b7ec2-2188-45bb-957d-eda51f2926c5',
        isDirty: true,
        priorityLevel: 0,
        addressLine: ['119 Cross Center Drive', 'Suite A'],
        city: 'Denver',
        county: null,
        countyGroupCode: null,
        countyGroupName: null,
        countyCode: null,
        countryCode: null,
        countryCodeEnt: null,
        postalCode: '28037',
        state: 'NC',
        stateCode: null,
        type: null,
        sameAddressBoolean: null,
        samePrimaryAndMailingAddress: false,
        usage: null,
        numberOfMonthsAtAddress: null,
        numberOfYearsAtAddress: null,
        startDateAtaddress: null,
        endDateAtAddress: null,
        streetAddress: null,
        preferredContactMethod: false,
        currentDate: 1527190555584
      },
      affiliateCD: '020005NBKFN6E000000000',
      bcZIP: '28037',
      caiID: '84PZ6',
      nbId: 'NBKFN6E',
      nmlsid: '1196115',
      phoneExt: '78',
      phoneNumber: '603.440.4091',
      photoURL: 'https://mortgage.bankofamerica.com/normaborders/photo',
      title: 'Financial Center Lending Officer',
      webSite: 'https://mortgage.bankofamerica.com/deborahssmith',
      bbaURL: 'https://secure.bankofamerica.com/mycommunications/public/appointments/getTopics.go?marketingCode=MLOWEB_ECBBA_A5000_A5200&apptType=IP&zip=28037&caid=84PZ6',
      isGetACallBackEnabled: true,
      isBBAEnabled: true,
      mloisPresent: true,
      workWithAssociates: true,
      isActive: true,
      currentDate: 1527190555584
    },
    city: 'Charlotte',
    state: 'NC',
    mortgagePrequalifyQueryString: null,
    mortgagePrequalifyURL: null,
    prequalSavedApplicationId: null,
    productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
    productLongDescription: '15-year fixed ',
    productShortDescription: '15yr fixed',
    productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 15 years of the loan.'
  },
  'your-new-home-location': {
    includeFinanceContingencyDate: null,
    type: 'PropertyInformationDTO',
    index: null,
    selectedChapter: 'PROPERTY',
    completedChapters: ['PERSONAL-INFORMATION'],
    clickableChapters: ['PERSONAL-INFORMATION'],
    propertyAddress: {
      streetNumber: null,
      addressLineOne: null,
      addressLineTwo: null,
      city: null,
      state: 'CA',
      zipcode: null,
      countyName: null,
      fipsCountyCode: null
    },
    propertyPurpose: 'PrimaryResidence',
    mpqPropertyType: 'SingleFamilyHome',
    workingWithRealEstateAgent: 'true',
    realEstateAgent: {
      firstName: 'Norma',
      lastName: 'Borders',
      phoneNumber: '',
      email: '',
      company: 'ABC Corp.'
    },
    consent: {
      consentContentRevision: '123456',
      consentContentUUID: '111111-2222-11e7-bb31-be2e44b06b34',
      recorded: false
    },
    borrowerDOB: '01/01/2000'
  }
};
var routes = {
  'assets-prefill': {
    nextView: {
      submit: 'borrower-personal-information'
    }
  },
  default: {
    nextView: {
      submit: 'borrower-living-situation'
    }
  },
  'assets-manual': {
    nextView: {
      submit: 'borrower-living-situation'
    }
  },
  'assets-reo-additional-info': {
    nextView: {
      submit: 'assets-reo-additional-info'
    }
  },
  'personal-information': {
    nextView: {
      submit: 'borrower-personal-information'
    }
  },
  'loan-summary-waiting': {
    nextView: {
      submit: 'loan-amount-calculator-waiting'
    }
  },
  'borrower-personal-information': {
    nextView: {
      submit: 'co-borrower-personal-information',
      'go-back': 'default'
    }
  },
  'borrower-living-situation': {
    nextView: {
      submit: 'borrower-add-co-borrower',
      'go-back': 'borrower-personal-information'
    }
  },
  'co-borrower-living-situation': {
    nextView: {
      submit: 'off-ramp',
      'go-back': 'borrower-personal-information'
    }
  },
  'co-borrower-past-living-situation': {
    nextView: {
      submit: 'off-ramp',
      'go-back': 'borrower-personal-information'
    }
  },
  'your-new-home': {
    nextView: {
      submit: 'off-ramp',
      'go-back': 'default'
    }
  },
  'co-borrower-personal-information': {
    nextView: {
      submit: 'off-ramp',
      'go-back': 'default'
    }
  },
  'borrower-hmda': {
    nextView: {
      submit: 'review-your-information',
      'go-back': 'default'
    }
  },
  'co-borrower-hmda': {
    nextView: {
      submit: 'review-your-information',
      'go-back': 'default'
    }
  },
  'review-your-information': {
    nextView: {
      submit: 'credit-pull-idv-consent',
      'go-back': 'default'
    }
  },
  'credit-pull-idv-consent': {
    nextView: {
      submit: 'off-ramp',
      'go-back': 'default'
    }
  },
  'associate-liens-to-property': {
    nextView: {
      submit: 'lien-position',
      'go-back': 'default'
    }
  },
  'lien-position': {
    nextView: {
      submit: 'borrower-personal-information',
      'go-back': 'associate-liens-to-property'
    }
  },
  'purchase-gating-question': {
    nextView: {
      submit: 'off-ramp',
      'go-back': 'default'
    }
  },
  landing: {
    nextView: {
      submit: 'off-ramp',
      'go-back': 'default'
    }
  },
  'borrower-declarations': {
    nextView: {
      submit: 'off-ramp',
      'go-back': 'default'
    }
  },
  'rate-lock': {
    nextView: {
      submit: 'off-ramp',
      'go-back': 'default'
    }
  },
  'your-new-home-location': {
    nextView: {
      submit: 'off-ramp',
      'go-back': 'default'
    }
  },
  'off-ramp': {
    nextView: {
      'go-back': 'default'
    }
  }
};
var welcomeBackMocks = {
  'save-and-exit': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    applicationId: 'DMA120',
    savedApplicationId: '23455',
    flowSelection: 'CONVERTTODMA'
  }),
  'off-ramp': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    flowSelection: 'DMPA',
    // DMPQUPDATE, CONVERTTODMA
    offRampCode: strDefault('code', 'OR025'),
    subCampPhoneNumber: '800.324.4843',
    daysUntilClosing: '25',
    applicationId: 'ff23d2edf'
  }),
  landing: _objectSpread(_objectSpread({}, baseDTO()), {}, {
    isEditable: boolDefault('editable', true),
    messageCodes: (params.messageCodes || '').split('-'),
    applicationId: 'DMA109780',
    loanAmount: '160000.00',
    loanNumber: '123456',
    productType: '30FX',
    apr: '3.375',
    rate: '3.851',
    rateLocked: true,
    points: '0.002',
    loanTimeFrame: '45 days',
    firstName: 'Norma',
    lastName: 'Borders',
    nmlsid: '1196115',
    email: 'norma.borders@bankofamerica.com',
    loanOfficerWorkPhoneExtn: '302',
    phoneNumber: '704.616.5344',
    website: 'https://mortgage.bankofamerica.com/normaborders',
    primaryApplicantPhone: '7045529523',
    subjectPropertyInfo: {
      mpqPropertyType: 'SingleFamily',
      propertyPurpose: 'Primary',
      propertyAddress: {
        city: 'Charlotte',
        state: 'NC'
      }
    },
    city: 'Charlotte',
    state: 'NC'
  }),
  'hmda-intro': {
    mloInformation: {
      firstName: 'Deborah',
      lastName: 'Smith',
      nmlsid: '12345678',
      email: 'deborah@gmail.com',
      phoneNumber: '8007001234',
      phoneExt: '246',
      photoURL: 'https://mortgage.bankofamerica.com/deborahssmith/photo',
      isGetACallBackEnabled: true
    }
  },
  'borrower-hmda-dmpa': {
    applicantName: 'Amar',
    races: ['NoThankYou'],
    otherAmericanIndianOrAlaskaNativeRace: 'Something',
    otherAsianRace: 'Hmong',
    otherPacificIslanderRace: 'Fijian',
    ethnicities: ['NoThankYou'],
    otherEthnicity: 'Argentinean',
    genders: ['NoThankYou']
  },
  'co-borrower-hmda-dmpa': {
    applicantName: 'Kushal',
    ethnicities: ['NoThankYou'],
    otherEthnicity: 'a',
    races: ['NoThankYou'],
    otherAsianRace: 'Laotian',
    genders: ['NoThankYou']
  },
  'borrower-hmda-dma': {
    applicantName: 'Amar',
    races: ['NoThankYou'],
    otherAmericanIndianOrAlaskaNativeRace: 'Something',
    otherAsianRace: 'Hmong',
    otherPacificIslanderRace: 'Fijian',
    ethnicities: ['NoThankYou'],
    otherEthnicity: 'Argentinean',
    genders: ['NoThankYou']
  },
  'co-borrower-hmda-dma': {
    ethnicities: ['NoThankYou'],
    otherEthnicity: 'a',
    races: ['NoThankYou'],
    otherAsianRace: 'Laotian',
    genders: ['NoThankYou']
  },
  'dmpa-your-new-home-location': {
    includeFinanceContingencyDate: null,
    type: 'PropertyInformationDTO',
    index: null,
    selectedChapter: 'PROPERTY',
    completedChapters: ['PERSONAL-INFORMATION'],
    clickableChapters: ['PERSONAL-INFORMATION'],
    propertyAddress: {
      streetNumber: null,
      addressLineOne: null,
      addressLineTwo: null,
      city: null,
      state: 'CA',
      zipcode: null,
      countyName: null,
      fipsCountyCode: null
    },
    propertyPurpose: 'PrimaryResidence',
    mpqPropertyType: 'SingleFamilyHome',
    workingWithRealEstateAgent: 'true',
    realEstateAgent: {
      firstName: 'Norma',
      lastName: 'Borders',
      phoneNumber: '',
      email: '',
      company: 'ABC Corp.'
    },
    consent: {
      consentContentRevision: '123456',
      consentContentUUID: '111111-2222-11e7-bb31-be2e44b06b34',
      recorded: false
    },
    borrowerDOB: '01/01/2000'
  },
  'professional-relationship': {},
  'dmpa-loan-amount-calculator': {
    type: 'LoanAmountCalcDTO',
    index: null,
    selectedChapter: null,
    clickableChapters: null,
    completedChapters: null,
    purchasePrice: 100000.0,
    downPaymentDollars: 20000,
    downPaymentPercent: 20,
    refiCurrentLoanAmount: '231235.00',
    cashOutAmount: 0,
    isCashOut: true
  },
  'dma-loan-amount-calculator': {
    type: 'LoanAmountCalcDTO',
    index: null,
    selectedChapter: null,
    clickableChapters: null,
    completedChapters: null,
    purchasePrice: 100000.0,
    downPaymentDollars: 20000,
    downPaymentPercent: 20,
    refiCurrentLoanAmount: '231235.00',
    cashOutAmount: 0,
    isCashOut: true
  },
  'loan-amount-calculator': {
    type: 'LoanAmountCalcDTO',
    index: null,
    selectedChapter: null,
    clickableChapters: null,
    completedChapters: null,
    purchasePrice: 100000.0,
    downPaymentDollars: 20000,
    downPaymentPercent: 20,
    refiCurrentLoanAmount: '231235.00',
    cashOutAmount: 0,
    isCashOut: true
  },
  'loan-summary-waiting': {},
  'loan-amount-calculator-waiting': {},
  'dmpa-loan-summary-waiting': {},
  'dmpa-loan-amount-calculator-waiting': {},
  'dma-loan-summary-waiting': {},
  'dma-loan-amount-calculator-waiting': {},
  'dmpa-select-loan-term-and-points': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'loanTermAndPointsDTO',
    horizontalTabs: ['30FX', '15FX', '7Y'],
    refinanceGoal: 'GetCashOut',
    // other options are: LowerMyPayment or GetCashOut
    productDTOList: [{
      productType: '30FX',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: true,
        productShortDescription: '30||yr fixed',
        productLongDescription: '30-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your dmpa custom mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }, {
        type: '1',
        verticalPriority: '1',
        singlePriceOption: false,
        productShortDescription: '30yr FHA',
        productLongDescription: '30-year FHA',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1012.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }, {
      productType: '15FX',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: 'False',
        productShortDescription: '30yr fixed',
        productLongDescription: '30-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }, {
      productType: '7Y',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: 'False',
        productShortDescription: '7yr fixed',
        productLongDescription: '7-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }],
    displayProducts: true,
    selectedProduct: '30FX',
    selectedTier: '0.527',
    selectedTierVerticalPriority: 0,
    borrowerPreferedRewardTier: 'Diamond',
    coBorrowerPreferedRewardTier: 'DiamondHonors',
    borrowerFirstName: 'Jake',
    coBorrowerFirstName: 'Jane',
    cashOutAmount: '8652'
  }),
  'dma-select-loan-term-and-points': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'loanTermAndPointsDTO',
    horizontalTabs: ['30FX', '15FX', '7Y'],
    refinanceGoal: 'GetCashOut',
    // other options are: LowerMyPayment or GetCashOut
    productDTOList: [{
      productType: '30FX',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: true,
        productShortDescription: '30!!yr fixed',
        productLongDescription: '30-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your dma custom mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }, {
        type: '1',
        verticalPriority: '1',
        singlePriceOption: false,
        productShortDescription: '30yr FHA',
        productLongDescription: '30-year FHA',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1012.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }, {
      productType: '15FX',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: 'False',
        productShortDescription: '30yr fixed',
        productLongDescription: '30-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }, {
      productType: '7Y',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: 'False',
        productShortDescription: '7yr fixed',
        productLongDescription: '7-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }],
    displayProducts: true,
    selectedProduct: '30FX',
    selectedTier: '0.527',
    selectedTierVerticalPriority: 0,
    borrowerPreferedRewardTier: 'Diamond',
    coBorrowerPreferedRewardTier: 'DiamondHonors',
    borrowerFirstName: 'Jake',
    coBorrowerFirstName: 'Jane',
    cashOutAmount: '8652'
  }),
  'select-loan-term-and-points': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    type: 'loanTermAndPointsDTO',
    horizontalTabs: ['30FX', '15FX', '7Y'],
    refinanceGoal: 'GetCashOut',
    // other options are: LowerMyPayment or GetCashOut
    productDTOList: [{
      productType: '30FX',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: true,
        productShortDescription: '30__yr fixed',
        productLongDescription: '30-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your custom mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }, {
        type: '1',
        verticalPriority: '1',
        singlePriceOption: false,
        productShortDescription: '30yr FHA',
        productLongDescription: '30-year FHA',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1012.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }, {
      productType: '15FX',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: 'False',
        productShortDescription: '30yr fixed',
        productLongDescription: '30-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }, {
      productType: '7Y',
      horizontalPriority: '1',
      loanTypeList: [{
        type: '0',
        verticalPriority: '0',
        singlePriceOption: 'False',
        productShortDescription: '7yr fixed',
        productLongDescription: '7-year fixed',
        productBenefitStatement: '5% min. down payment, fixed rate over life of loan',
        productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 30 years of the loan. This mortgage may give you a lower monthly payment, but at a higher interest rate, than other options.',
        productTierDTOList: [{
          monthlyPayment: '1011.05',
          closingCosts: '4001',
          rate: '3.851',
          apr: '4.031',
          points: '-0.527',
          estimatedCashNeededAtClosing: '17201',
          downPayment: '10001',
          estimatedClosingCosts: '7201',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '3000',
          closingCosts: '4002',
          rate: '3.852',
          apr: '4.032',
          points: '0.002',
          estimatedCashNeededAtClosing: '17202',
          downPayment: '10002',
          estimatedClosingCosts: '7202',
          estimatedEscrowAccountFund: null,
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }, {
          monthlyPayment: '1013.05',
          closingCosts: '4003',
          rate: '3.853',
          apr: '4.033',
          points: '0.527',
          estimatedCashNeededAtClosing: '17203',
          downPayment: '10003',
          estimatedClosingCosts: '7203',
          estimatedEscrowAccountFund: '203',
          estimatedPointsAndLenderAndThirdPartyFees: '3621',
          estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '5904.54'
        }]
      }]
    }],
    displayProducts: true,
    selectedProduct: '30FX',
    selectedTier: '0.527',
    selectedTierVerticalPriority: 1,
    borrowerPreferedRewardTier: 'Diamond',
    coBorrowerPreferedRewardTier: 'DiamondHonors',
    borrowerFirstName: 'Jake',
    coBorrowerFirstName: 'Jane',
    cashOutAmount: '8652'
  }),
  'dmpa-loan-summary': {
    type: 'loanSummaryDTO',
    refinanceGoal: 'GetCashOut',
    // other options are: PayOffMyLoanFaster or GetCashOut
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    isAuthenticated: false,
    cashOutAmount: '8652',
    coBorrowerFirstName: 'Jane',
    productDTO: {
      productType: '30FX',
      productShortDescription: '30yr fixed',
      productTierDTOList: [{
        monthlyPayment: '2011.05',
        closingCosts: '4001',
        rate: '3.625',
        apr: '3.981',
        points: '0.002',
        estimatedCashNeededAtClosing: '17201',
        downPayment: '20001',
        estimatedClosingCosts: '7201',
        estimatedPointsAndLenderAndThirdPartyFees: '5001',
        estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '2001',
        estimatedEscrowAccountFund: '201',
        discountPoints: '0.327',
        principalAndInterest: '200000.00',
        taxes: '1000.00',
        estimatedHomeOwnersInsurance: '100.00',
        privateMortgageInsurance: '100.00',
        rateLocked: false
      }]
    },
    productLongDescription: '15-year fixed',
    productShortDescription: '15yr fixed',
    productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 15 years of the loan.'
  },
  'dma-loan-summary': {
    type: 'loanSummaryDTO',
    refinanceGoal: 'GetCashOut',
    // other options are: PayOffMyLoanFaster or GetCashOut
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    isAuthenticated: false,
    cashOutAmount: '8652',
    coBorrowerFirstName: 'Jane',
    productDTO: {
      productType: '30FX',
      productShortDescription: '30yr fixed',
      productTierDTOList: [{
        monthlyPayment: '2011.05',
        closingCosts: '4001',
        rate: '3.851',
        apr: '4.031',
        points: '-0.527',
        estimatedCashNeededAtClosing: '17201',
        downPayment: '20001',
        estimatedClosingCosts: '7201',
        estimatedPointsAndLenderAndThirdPartyFees: '5001',
        estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '2001',
        estimatedEscrowAccountFund: '201',
        discountPoints: '0.327',
        principalAndInterest: '200000.00',
        taxes: '1000.00',
        estimatedHomeOwnersInsurance: '100.00',
        privateMortgageInsurance: '100.00',
        rateLocked: false
      }]
    },
    productLongDescription: '15-year fixed',
    productShortDescription: '15yr fixed',
    productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 15 years of the loan.'
  },
  'loan-summary': {
    type: 'loanSummaryDTO',
    refinanceGoal: 'GetCashOut',
    // other options are: PayOffMyLoanFaster or GetCashOut
    selectedChapter: null,
    clickableChapters: [],
    completedChapters: [],
    isAuthenticated: false,
    cashOutAmount: '8652',
    productDTO: {
      productType: '30FX',
      productShortDescription: '30yr fixed',
      productTierDTOList: [{
        monthlyPayment: '2011.05',
        closingCosts: '4001',
        rate: '3.851',
        apr: '4.031',
        points: '-0.527',
        estimatedCashNeededAtClosing: '17201',
        downPayment: '20001',
        estimatedClosingCosts: '7201',
        estimatedPointsAndLenderAndThirdPartyFees: '5001',
        estimatedPrepaidInterestTaxAndInsuranceAndEscrowFunds: '2001',
        estimatedEscrowAccountFund: '201',
        discountPoints: '0.327',
        principalAndInterest: '200000.00',
        taxes: '1000.00',
        estimatedHomeOwnersInsurance: '100.00',
        privateMortgageInsurance: '100.00',
        rateLocked: false
      }]
    },
    productLongDescription: '15-year fixed',
    productShortDescription: '15yr fixed',
    productTooltipText: 'Your mortgage interest rate and total monthly payment of principal and interest will stay the same for all 15 years of the loan.'
  },
  'dmpa-received': {
    messageCodes: [''],
    applicationId: 'DMA109780',
    loanAmount: '160000.00',
    loanNumber: '123456',
    productType: '30FX',
    apr: '4.035',
    rate: '4.375',
    rateLocked: true,
    points: '0.002',
    loanTimeFrame: '45 days',
    firstName: 'Norma',
    lastName: 'Borders',
    nmlsid: '1196115',
    email: 'norma.borders@bankofamerica.com',
    loanOfficerWorkPhoneExtn: '302',
    phoneNumber: '704.616.5344',
    website: 'https://mortgage.bankofamerica.com/normaborders',
    primaryApplicantPhone: '7045529523',
    subjectPropertyInfo: {
      mpqPropertyType: 'SingleFamily',
      propertyPurpose: 'Primary',
      propertyAddress: {
        city: 'Charlotte',
        state: 'NC'
      }
    },
    mloInformation: {
      entityID: 'a8aa2754-cfae-469d-beeb-002015575055',
      isDirty: false,
      firstName: 'Norma',
      lastName: 'Borders',
      email: 'norma.borders@bankofamerica.com',
      mloaddress: {
        entityID: 'fd3b7ec2-2188-45bb-957d-eda51f2926c5',
        isDirty: true,
        priorityLevel: 0,
        addressLine: ['119 Cross Center Drive', 'Suite A'],
        city: 'Denver',
        county: null,
        countyGroupCode: null,
        countyGroupName: null,
        countyCode: null,
        countryCode: null,
        countryCodeEnt: null,
        postalCode: '28037',
        state: 'NC',
        stateCode: null,
        type: null,
        sameAddressBoolean: null,
        samePrimaryAndMailingAddress: false,
        usage: null,
        numberOfMonthsAtAddress: null,
        numberOfYearsAtAddress: null,
        startDateAtaddress: null,
        endDateAtAddress: null,
        streetAddress: null,
        preferredContactMethod: false,
        currentDate: 1527190555584
      },
      affiliateCD: '020005NBKFN6E000000000',
      bcZIP: '28037',
      caiID: '84PZ6',
      nbId: 'NBKFN6E',
      nmlsid: '1196115',
      phoneExt: '78',
      phoneNumber: '6034404091',
      photoURL: 'https://mortgage.bankofamerica.com/normaborders/photo',
      title: 'Financial Center Lending Officer',
      webSite: 'https://mortgage.bankofamerica.com/deborahssmith',
      bbaURL: 'https://secure.bankofamerica.com/mycommunications/public/appointments/getTopics.go?marketingCode=MLOWEB_ECBBA_A5000_A5200&apptType=IP&zip=28037&caid=84PZ6',
      isGetACallBackEnabled: true,
      isBBAEnabled: true,
      mloisPresent: true,
      workWithAssociates: true,
      isActive: true,
      currentDate: 1527190555584
    },
    city: 'Charlotte',
    state: 'NC',
    productShortDescription: '15yr fixed'
  },
  'dmpa-referred-to-hln': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    applicationId: 'DMA109780'
  }),
  'dmpq-referred-to-hln': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    applicationId: 'DMA109780'
  }),
  'dma-referred-to-hln': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    applicationId: 'DMA109780'
  }),
  'your-new-home-location-review': {
    propertyAddress: {
      zipcode: 28262
    },
    propertyPurpose: 'Primary',
    propertyType: 'SingleFamily',
    changesNeeded: false,
    primaryApplicantPhone: '8484487862',
    mloInformation: {
      firstName: 'Deborah',
      lastName: 'Smith',
      nmlsid: '12345678',
      email: 'deborah@gmail.com',
      phoneNumber: '8007001234',
      phoneExt: '246',
      photoURL: 'https://mortgage.bankofamerica.com/deborahssmith/photo',
      isGetACallBackEnabled: true
    }
  },
  'your-new-home-location': {
    includeFinanceContingencyDate: null,
    type: 'PropertyInformationDTO',
    index: null,
    selectedChapter: 'PROPERTY',
    completedChapters: ['PERSONAL-INFORMATION'],
    clickableChapters: ['PERSONAL-INFORMATION'],
    propertyAddress: {
      streetNumber: null,
      addressLineOne: null,
      addressLineTwo: null,
      city: null,
      state: 'CA',
      zipcode: null,
      countyName: null,
      fipsCountyCode: null
    },
    propertyPurpose: 'PrimaryResidence',
    mpqPropertyType: 'SingleFamilyHome',
    workingWithRealEstateAgent: 'true',
    realEstateAgent: {
      firstName: 'Norma',
      lastName: 'Borders',
      phoneNumber: '',
      email: '',
      company: 'ABC Corp.'
    },
    consent: {
      consentContentRevision: '123456',
      consentContentUUID: '111111-2222-11e7-bb31-be2e44b06b34',
      recorded: false
    },
    borrowerDOB: '01/01/2000'
  },
  'dmpq-approved': _objectSpread(_objectSpread({}, baseDTO()), {}, {
    isEditable: true,
    applicationId: 'DMA109780',
    loanAmount: '160000.00',
    loanNumber: '123456',
    productType: '30FX',
    apr: '3.375',
    rate: '3.851',
    rateLocked: true,
    points: '0.002',
    loanTimeFrame: '45 days',
    firstName: 'Norma',
    lastName: 'Borders',
    nmlsid: '1196115',
    email: 'norma.borders@bankofamerica.com',
    loanOfficerWorkPhoneExtn: '302',
    phoneNumber: '704.616.5344',
    website: 'https://mortgage.bankofamerica.com/normaborders',
    primaryApplicantPhone: '7045529523',
    subjectPropertyInfo: {
      mpqPropertyType: 'SingleFamily',
      propertyPurpose: 'Primary',
      propertyAddress: {
        city: 'Charlotte',
        state: 'NC'
      }
    },
    city: 'Charlotte',
    state: 'NC',
    productShortDescription: '15yr fixed'
  }),
  'your-new-home': {
    type: 'PropertyInformationDTO',
    index: null,
    selectedChapter: 'PROPERTY',
    completedChapters: ['PERSONAL-INFORMATION'],
    clickableChapters: ['PERSONAL-INFORMATION'],
    propertyAddress: {
      cachedCounties: [{
        state: 'NC',
        fipsStateCode: '37',
        countyName: 'CABARRUS',
        fipsCountyCode: '025'
      }, {
        state: 'NC',
        fipsStateCode: '37',
        countyName: 'MECKLENBURG',
        fipsCountyCode: '119'
      }]
    },
    plannedClosingDate: '01/01/2022',
    includeFinanceContingencyDate: 'true',
    financeContingencyDate: '01/01/2022',
    propertyUse: 'Primary',
    propertyType: 'Townhouse',
    borrowerDOB: '02/01/1990',
    coborrowerDOB: null,
    closingDateLimit: 28
  },
  'your-new-home-confirm-address': {
    type: 'addressStandardizationDTO',
    index: null,
    selectedChapter: 'YOUR-NEW-HOME',
    completedChapters: ['BORROWER-PERSONAL-INFORMATION'],
    clickableChapters: ['BORROWER-PERSONAL-INFORMATION'],
    standardizedAddressOptions: [{
      addressLineOne: 'Side St.',
      addressLineTwo: 'Apt 1B',
      city: 'Chicago',
      state: 'IL',
      streetNumber: '246',
      zipcode: '60007'
    }, {
      addressLineOne: 'Main St.',
      addressLineTwo: 'Apt 1B',
      city: 'Chicago',
      state: 'IL',
      streetNumber: '246',
      zipcode: '60007'
    }],
    selectedAddressIndex: 0
  },
  'your-new-home-misc': {
    heldOnTrustOrCorp: 'true',
    underConstruction: 'true',
    noneOftheStmts: null,
    shortsaleOrForeclosure: 'true',
    pud: null,
    hOADues: null,
    hOADuesAmount: null
  },
  'your-new-home-misc-urla-2020': {
    heldOnTrustOrCorp: 'true',
    propertyToRunMyOwnBusiness: 'true',
    underConstruction: 'true',
    noneOftheStmts: null,
    shortsaleOrForeclosure: 'true',
    pud: null,
    hOADues: null,
    hOADuesAmount: null,
    manufacturedHome: 'true'
  },
  'rate-lock': {
    rateLockPeriod: 60
  },
  'dma-approved': {
    messageCodes: [''],
    applicationId: 'DMA109780',
    loanAmount: '160000.00',
    loanNumber: '123456',
    productType: '30FX',
    apr: '4.035',
    rate: '4.375',
    rateLocked: true,
    points: '0.002',
    loanTimeFrame: '45 days',
    firstName: 'Norma',
    lastName: 'Borders',
    nmlsid: '1196115',
    email: 'norma.borders@bankofamerica.com',
    loanOfficerWorkPhoneExtn: '302',
    phoneNumber: '704.616.5344',
    website: 'https://mortgage.bankofamerica.com/normaborders',
    primaryApplicantPhone: '7045529523',
    subjectPropertyInfo: {
      mpqPropertyType: 'SingleFamily',
      propertyPurpose: 'Primary',
      propertyAddress: {
        city: 'Charlotte',
        state: 'NC'
      }
    },
    mloInformation: {
      entityID: 'a8aa2754-cfae-469d-beeb-002015575055',
      isDirty: false,
      firstName: 'Deborah',
      lastName: 'Smith',
      email: 'deborah.s.smith@bankofamerica.com',
      mloaddress: {
        entityID: 'fd3b7ec2-2188-45bb-957d-eda51f2926c5',
        isDirty: true,
        priorityLevel: 0,
        addressLine: ['119 Cross Center Drive', 'Suite A'],
        city: 'Denver',
        postalCode: '28037',
        state: 'NC',
        samePrimaryAndMailingAddress: false,
        preferredContactMethod: false,
        currentDate: 1527190555584
      },
      affiliateCD: '020005NBKFN6E000000000',
      bcZIP: '28037',
      caiID: '84PZ6',
      nbId: 'NBKFN6E',
      nmlsid: '505114',
      phoneExt: '123456',
      phoneNumber: '7046024153',
      photoURL: 'https://mortgage.bankofamerica.com/deborahssmith/photo',
      title: 'Financial Center Lending Officer',
      webSite: 'https://mortgage.bankofamerica.com/deborahssmith',
      bbaURL: 'https://secure.bankofamerica.com/mycommunications/public/appointments/getTopics.go?marketingCode=MLOWEB_ECBBA_A5000_A5200&apptType=IP&zip=28037&caid=84PZ6',
      isGetACallBackEnabled: true,
      isBBAEnabled: true,
      mloisPresent: true,
      workWithAssociates: true,
      isActive: true,
      currentDate: 1527190555584,
      productShortDescription: '15yr fixed'
    },
    city: 'Charlotte',
    state: 'NC',
    productShortDescription: '15yr fixed'
  }
};

/* globals window, global spaParams */
function mockFetch(url) {
  var httpMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var mockData = _objectSpread({}, data);
  if (/get-countries/.test(url)) {
    return Promise.resolve(countries);
  }
  if (/rest\/v1\/occupation/.test(url)) {
    return Promise.resolve(occupations);
  }
  if (/rest\/v1\/residency-type/.test(url)) {
    return Promise.resolve(residency.type);
  }
  if (/rest\/v1\/residency-document/.test(url)) {
    return Promise.resolve(residency.document);
  }
  var routeName;
  if (window.location.hash) {
    var matches = window.location.hash.match(/\#([^\?]+)\/?$/); // eslint-disable-line
    routeName = matches && matches[1];
  }
  var action = url.includes('go-back-action') ? 'go-back' : 'submit';
  routeName = routeName || 'default';
  if (httpMethod.toUpperCase() === 'GET' && action !== 'go-back') {
    var isWelcomeBack = window.location.href.indexOf('/welcomeback/') > -1;
    var isDmpa = window.location.href.indexOf('#dmpa-') > -1;
    var mocked = mocks[routeName];
    if (isWelcomeBack || isDmpa) {
      mocked = welcomeBackMocks[routeName];
    }
    return Promise.resolve(mocked);
  }
  if (mocks[routeName]) {
    if ('post' in mocks[routeName]) {
      mockData = mocks[routeName].post;
    }
  }
  var nextView = routes[routeName].nextView[action];
  return Promise.resolve(_objectSpread(_objectSpread({}, mockData), {}, {
    nextView: nextView
  }));
}

/**
 * @function fetch
 * @param {string} url - the request URL
 * @param {*} httpMethod - the http method to use (GET, PUT, POST, DELETE)
 * @param {*} data - the request body
 * @param {*} settings - TODO - fill this out
 * @returns {Promise} TODO - fill this out
 */
function fetch(url) {
  var httpMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var data = arguments.length > 2 ? arguments[2] : undefined;
  var settings = arguments.length > 3 ? arguments[3] : undefined;
  var requestUrl = url;
  if (spaParams.siteParams.isLocal) {
    requestUrl = "".concat(spaParams.siteParams.secureHost).concat(url);
  }
  var requestHeaders = settings ? _objectSpread({}, settings) : {};
  return new Promise(function (resolve, reject) {
    var request = {
      url: requestUrl,
      async: true,
      cache: requestHeaders.cache || false,
      dataType: 'JSON',
      type: httpMethod,
      data: data && JSON.stringify(data),
      contentType: 'application/json; charset=utf-8',
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      }
    };
    $.ajax(_objectSpread(_objectSpread({}, request), {}, {
      /**
       * @method error
       * @param {XMLHttpRequest} jqXHR
       * @param {string} textStatus - a string describing the type of error that occurred
       * @param {object} errorThrown - an optional exception object
       * @desc If request fails
       */
      error: function error(jqXHR, textStatus, errorThrown) {
        reject(jqXHR, textStatus, errorThrown);
      },
      /**
       * @method success
       * @param payload
       * @desc If request succeeds
       */
      success: function success(response) {
        spartaEventsUtility.pub('DME.AJAX.SUCCESS');
        resolve(response);
      }
    }));
  });
}
var index = {
  fetch: fetch,
  mockFetch: mockFetch
};
export { index as default };